import React__default, { Component, createElement, createRef, Fragment, PureComponent, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { jsx } from '@emotion/core';
import AsyncSelect from 'react-select/async';
import { Link } from 'react-router-dom';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-GB';
import { format, parseISO } from 'date-fns';
import FocusLock from 'react-focus-lock';
import { Manager, Reference, Popper } from 'react-popper';
import ReactSelect, { components } from 'react-select';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".alert{background-color:#dcf0fa;border:1px solid #64c8fa;padding:.75rem 1rem;color:#000;border-radius:2px}.alert--success{background-color:#dcf0dc;border-color:#8cc84b}.alert--warning{background-color:#fffac8;border-color:#ffde0a}.alert--error{background-color:#fe9898;border-color:#f24137}.alert--inline{display:inline-block;margin-right:1rem}";
styleInject(css_248z);

var Alert = function Alert(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "info" : _ref$type,
      children = _ref.children,
      inline = _ref.inline,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["type", "children", "inline", "className"]);

  var classes = classnames("alert", {
    "alert--success": type === "success",
    "alert--warning": type === "warning",
    "alert--error": type === "error",
    "alert--inline": inline
  }, className);
  return jsx("div", _extends({
    role: "alert",
    className: classes
  }, props), children);
};

Alert.propTypes = {
  /**
   * Determines colour scheme of component. One of `["info", "success", "warning", "error"]` |
   */
  type: PropTypes.oneOf(["info", "success", "warning", "error"]),

  /**
   * Content to be rendered inside the alert
   */
  children: PropTypes.node.isRequired,

  /**
   * Custom className to add to the component
   */
  className: PropTypes.string,

  /**
   * Applying styling for inlining the component
   */
  inline: PropTypes.bool
};
Alert.defaultProps = {
  type: "info"
};

var css_248z$1 = ".autocomplete-container{font-size:1.25rem;line-height:1.2;font-weight:700}.autocomplete-container .autocomplete__control,.autocomplete-container .autocomplete__menu{width:100%}.autocomplete-container .autocomplete__control{border-radius:0;border:2px solid #e5e5e5;background-color:#fafafa;min-height:0;padding:1.25rem 1.5rem;box-shadow:none}.autocomplete-container .autocomplete__control:hover{border:2px solid #e5e5e5}.autocomplete-container .autocomplete__control.autocomplete__control--is-focused{border:2px solid #b9b9b9}.autocomplete-container .autocomplete__placeholder+div{padding:0;margin:0}.autocomplete-container .autocomplete__placeholder{color:#939393}.autocomplete-container .autocomplete__value-container{padding:0}.autocomplete-container .autocomplete__dropdown-indicator,.autocomplete-container .autocomplete__indicator-separator{display:none}.autocomplete-container .autocomplete__input{display:block}.autocomplete-container .autocomplete__input input{transition:none}.autocomplete-container .autocomplete__menu{border-radius:0;margin:0;box-shadow:0 4px 24px rgba(0,0,0,.32);color:#000}.autocomplete-container .autocomplete__menu-list{padding:0}.autocomplete-container .autocomplete__option{padding:.75rem 1.25rem;transition:all .1s ease-in-out;font-weight:400}.autocomplete-container .autocomplete__option:last-child{border-bottom:0}.autocomplete-container .autocomplete__option:active{background:#d33333}.autocomplete-container .autocomplete__option--is-focused{background:#c80000;color:#fff}.autocomplete-container .autocomplete__option--is-focused:active{background-color:#c80000;color:#fff}.autocomplete-container .autocomplete__option--is-selected{background-color:#c80000;color:#fff;font-weight:700}.autocomplete-container .autocomplete__option--is-selected:active{background:#c80000;color:#fff}";
styleInject(css_248z$1);

var Autocomplete = function Autocomplete(_ref) {
  var id = _ref.id,
      loadOptions = _ref.loadOptions,
      className = _ref.className,
      placeholder = _ref.placeholder,
      onInputChange = _ref.onInputChange,
      rest = _objectWithoutProperties(_ref, ["id", "loadOptions", "className", "placeholder", "onInputChange"]);

  var classes = classnames("autocomplete-container", className);
  return jsx("div", {
    className: classes
  }, jsx(AsyncSelect, _extends({
    id: id,
    loadOptions: loadOptions,
    defaultOptions: [],
    onInputChange: onInputChange,
    placeholder: placeholder,
    classNamePrefix: "autocomplete"
  }, rest)));
};

Autocomplete.propTypes = {
  id: PropTypes.string.isRequired,
  loadOptions: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onInputChange: PropTypes.func
};

var css_248z$2 = ".anchor{color:#000;border-bottom:.125rem dotted #3f3f3f;font-weight:700;transition:all .1s ease-in-out;text-decoration:none;display:inline-block;position:relative;padding-bottom:.125rem;line-height:1.1}.anchor:focus,.anchor:hover{color:#c80000}.anchor:active{color:#a00000}.anchor:after{content:\"\";width:0;position:absolute;left:0;bottom:0;margin-bottom:-.125rem;transition:width .1s ease-out;display:block;border-bottom:.13rem solid #c80000}.anchor:focus:after,.anchor:hover:after{width:100%}.anchor:active:after{width:100%;border-bottom-color:#a00000;border-bottom-style:solid}.anchor svg{display:inline-block;width:1rem;vertical-align:middle}";
styleInject(css_248z$2);

var isExternal = function isExternal(url) {
  return /^(http|tel|mailto|\/\/)/.test(url || "");
};

var BaseAnchor = function BaseAnchor(_ref) {
  var to = _ref.to,
      onClick = _ref.onClick,
      children = _ref.children,
      className = _ref.className,
      forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, ["to", "onClick", "children", "className", "forwardedRef"]);

  return isExternal(to) || !to && onClick ? jsx("a", _extends({
    className: className,
    href: to,
    onClick: onClick,
    rel: "noopener noreferrer",
    target: "_blank",
    ref: forwardedRef
  }, props), children) : jsx(Link, _extends({
    className: className,
    to: to,
    onClick: onClick
  }, props, {
    innerRef: forwardedRef
  }), children);
};

BaseAnchor.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  forwardedRef: PropTypes.shape({
    current: PropTypes.instanceOf(jsx("anchor", null))
  })
};

var isExternal$1 = function isExternal(url) {
  return /^(http|tel|mailto|\/\/)/.test(url || "");
};

var Anchor = function Anchor(_ref) {
  var to = _ref.to,
      onClick = _ref.onClick,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["to", "onClick", "children", "className"]);

  var classes = classnames("anchor", className);
  return jsx(BaseAnchor, _extends({
    className: classes,
    to: to,
    onClick: onClick
  }, props), children);
};

Anchor.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.string.isRequired,
  className: PropTypes.string
};

var css_248z$3 = ".badge{background:#c80000;color:#fff;font-size:.625rem;font-family:avenir,Helvetica,Arial,sans-serif;font-weight:700;border-radius:10rem;display:inline-block;width:auto;text-align:center;line-height:1rem;min-width:1rem;height:1rem;padding:0 .3rem}";
styleInject(css_248z$3);

var Badge = function Badge(_ref) {
  var number = _ref.number,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["number", "className"]);

  var value = number > 98 ? "99+" : number;
  var classes = classnames("badge", className);
  return jsx("span", _extends({
    className: classes
  }, props), value || " ");
};

Badge.propTypes = {
  /**
   * Number to display.
   */
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string
};

var css_248z$4 = ".body-copy{font-family:avenir,Helvetica,Arial,sans-serif;font-size:1rem;line-height:1.5}.body-copy a{color:#000;border-bottom:.125rem dotted #3f3f3f;font-weight:700;transition:all .1s ease-in-out;text-decoration:none;display:inline-block;position:relative;line-height:1.1;display:initial;padding-bottom:0}.body-copy a:focus,.body-copy a:hover{color:#c80000}.body-copy a:active{color:#a00000}.body-copy a:focus,.body-copy a:hover{border-bottom-color:#c80000;border-bottom-style:solid}.body-copy a:active{border-bottom-color:#a00000;border-bottom-style:solid}.body-copy h1+*,.body-copy h2+*,.body-copy h3+*,.body-copy h4+*,.body-copy h5+*,.body-copy h6+*{margin-top:1.5rem}.body-copy h1{font-size:1.5rem;line-height:1.33}@media screen and (min-width:460px){.body-copy h1{font-size:2rem}}@media screen and (min-width:1024px){.body-copy h1{font-size:2.5rem}}@media screen and (min-width:460px){.body-copy h1{line-height:1.25}}@media screen and (min-width:1024px){.body-copy h1{line-height:1.2}}.body-copy h2{font-size:1.5rem;line-height:1.33}@media screen and (min-width:460px){.body-copy h2{font-size:2rem}}@media screen and (min-width:1024px){.body-copy h2{font-size:2.5rem}}@media screen and (min-width:460px){.body-copy h2{line-height:1.25}}@media screen and (min-width:1024px){.body-copy h2{line-height:1.2}}.body-copy h3{font-size:1.5rem;line-height:1.33}@media screen and (min-width:460px){.body-copy h3{font-size:2rem}}@media screen and (min-width:1024px){.body-copy h3{font-size:2.5rem}}@media screen and (min-width:460px){.body-copy h3{line-height:1.25}}@media screen and (min-width:1024px){.body-copy h3{line-height:1.2}}.body-copy h4{font-size:1.5rem;line-height:1.33}@media screen and (min-width:1024px){.body-copy h4{font-size:2rem;line-height:1.25}}.body-copy h5{font-size:1.25rem;line-height:1.2}@media screen and (min-width:1024px){.body-copy h5{font-size:1.5rem;line-height:1.33}}.body-copy h6{font-size:1.25rem;line-height:1.2}.body-copy p+*{margin-top:1.5rem}.body-copy p img,.body-copy p svg{vertical-align:middle;display:inline-block}.body-copy.u-bg-black,.body-copy.u-bg-black a,.body-copy.u-bg-black h1,.body-copy.u-bg-black h2,.body-copy.u-bg-black h3,.body-copy.u-bg-black h4,.body-copy.u-bg-black h5,.body-copy.u-bg-black h6,.body-copy.u-bg-grey,.body-copy.u-bg-grey a,.body-copy.u-bg-grey h1,.body-copy.u-bg-grey h2,.body-copy.u-bg-grey h3,.body-copy.u-bg-grey h4,.body-copy.u-bg-grey h5,.body-copy.u-bg-grey h6,.body-copy.u-bg-red,.body-copy.u-bg-red a,.body-copy.u-bg-red h1,.body-copy.u-bg-red h2,.body-copy.u-bg-red h3,.body-copy.u-bg-red h4,.body-copy.u-bg-red h5,.body-copy.u-bg-red h6,.u-bg-black .body-copy,.u-bg-black .body-copy a,.u-bg-black .body-copy h1,.u-bg-black .body-copy h2,.u-bg-black .body-copy h3,.u-bg-black .body-copy h4,.u-bg-black .body-copy h5,.u-bg-black .body-copy h6,.u-bg-grey .body-copy,.u-bg-grey .body-copy a,.u-bg-grey .body-copy h1,.u-bg-grey .body-copy h2,.u-bg-grey .body-copy h3,.u-bg-grey .body-copy h4,.u-bg-grey .body-copy h5,.u-bg-grey .body-copy h6,.u-bg-red .body-copy,.u-bg-red .body-copy a,.u-bg-red .body-copy h1,.u-bg-red .body-copy h2,.u-bg-red .body-copy h3,.u-bg-red .body-copy h4,.u-bg-red .body-copy h5,.u-bg-red .body-copy h6{color:#fff}.body-copy.u-bg-black a,.body-copy.u-bg-grey a,.body-copy.u-bg-red a,.u-bg-black .body-copy a,.u-bg-grey .body-copy a,.u-bg-red .body-copy a{color:currentColor;border-bottom-color:currentColor}.body-copy.u-bg-black a:active,.body-copy.u-bg-black a:focus,.body-copy.u-bg-black a:hover,.body-copy.u-bg-grey a:active,.body-copy.u-bg-grey a:focus,.body-copy.u-bg-grey a:hover,.body-copy.u-bg-red a:active,.body-copy.u-bg-red a:focus,.body-copy.u-bg-red a:hover,.u-bg-black .body-copy a:active,.u-bg-black .body-copy a:focus,.u-bg-black .body-copy a:hover,.u-bg-grey .body-copy a:active,.u-bg-grey .body-copy a:focus,.u-bg-grey .body-copy a:hover,.u-bg-red .body-copy a:active,.u-bg-red .body-copy a:focus,.u-bg-red .body-copy a:hover{border-bottom-color:currentColor;color:currentColor}.body-copy.u-bg-black ul li:before,.body-copy.u-bg-grey ul li:before,.body-copy.u-bg-red ul li:before,.u-bg-black .body-copy ul li:before,.u-bg-grey .body-copy ul li:before,.u-bg-red .body-copy ul li:before{background-color:currentColor}";
styleInject(css_248z$4);

var BodyCopy = function BodyCopy(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("body-copy", className);
  return jsx("div", _extends({
    className: classes
  }, props), children);
};

BodyCopy.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node), PropTypes.objectOf(PropTypes.node)]).isRequired
};

var BaseButton = function BaseButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      type = _ref.type,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, ["children", "className", "type", "disabled", "onClick", "forwardedRef"]);

  return jsx("button", _extends({
    className: className,
    disabled: disabled,
    type: type,
    onClick: onClick,
    ref: forwardedRef
  }, props), children);
};

BaseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit"]),
  children: PropTypes.node.isRequired,
  forwardedRef: PropTypes.oneOfType([PropTypes.shape({
    current: PropTypes.instanceOf(jsx("button", null))
  }), PropTypes.func])
};
BaseButton.defaultProps = {
  type: "button"
};

var css_248z$5 = ".button{border:1px solid;cursor:pointer;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-family:avenir,Helvetica,Arial,sans-serif;font-weight:700;font-size:1rem;min-width:0;overflow:hidden;padding:.81em 1.5em;text-decoration:none;transition:all .1s ease-in-out;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;min-height:48px;border-radius:2px}.button__text{-ms-flex:none;flex:none;-ms-flex-negative:1;flex-shrink:1}.button__icon{-ms-flex:none;flex:none;fill:currentColor;height:1rem;margin:0 .5rem 0 0;padding:0;width:1rem}.button--primary{color:#fff;border-color:#c80000;background-color:#c80000;box-shadow:0 1px 6px 0 rgba(0,0,0,.16)}.button--primary:focus,.button--primary:hover{color:#fff;border-color:#a00000;background-color:#d33333;box-shadow:0 1px 6px 0 rgba(0,0,0,.16)}.button--primary:active{color:#fff;border-color:#a00000;background-color:#a00000;box-shadow:0 1px 6px 0 rgba(0,0,0,.16)}.button--primary[disabled]{background-color:#939393;border-color:#939393;color:#fff;cursor:not-allowed;box-shadow:none}.button--primary.button--is-reversed{color:#000;border-color:#fff;background-color:#fff;box-shadow:0 1px 6px 0 rgba(0,0,0,.16)}.button--primary.button--is-reversed:focus,.button--primary.button--is-reversed:hover{color:#000;border-color:#787878;background-color:#f2f2f2;box-shadow:0 1px 6px 0 rgba(0,0,0,.16)}.button--primary.button--is-reversed:active{color:#000;border-color:#000;background-color:#e5e5e5;box-shadow:0 1px 6px 0 rgba(0,0,0,.16)}.button--outlined{color:#000;border-color:#3c3c3c;background-color:transparent;box-shadow:none}.button--outlined:focus,.button--outlined:hover{color:#000;border-color:#000;background-color:#f2f2f2;box-shadow:none}.button--outlined:active{color:#000;border-color:#000;background-color:#dcdcdc;box-shadow:none}.button--outlined[disabled]{background-color:transparent;border-color:#939393;color:#939393;cursor:not-allowed;box-shadow:none}.button--outlined.button--is-reversed{color:#fff;border-color:#fff;background-color:transparent;box-shadow:none}.button--outlined.button--is-reversed:focus,.button--outlined.button--is-reversed:hover{color:#f2f2f2;border-color:#f2f2f2;background-color:hsla(0,0%,100%,.16);box-shadow:none}.button--outlined.button--is-reversed:active{color:#e5e5e5;border-color:#e5e5e5;background-color:hsla(0,0%,100%,.24);box-shadow:none}.button--link,.button--nav{min-height:1.8rem;padding:0;border-color:transparent;background-color:transparent;color:#000}.button--link .button__text,.button--nav .button__text{position:relative;border-bottom:.125rem dotted;border-color:#3f3f3f}.button--link .button__text:after,.button--nav .button__text:after{content:\"\";position:absolute;width:0;left:0;bottom:-.125rem;transition:width .1s ease-in;border-bottom:.13rem solid}.button--link:focus,.button--link:hover,.button--nav:focus,.button--nav:hover{color:#c80000}.button--link:focus .button__text:after,.button--link:hover .button__text:after,.button--nav:focus .button__text:after,.button--nav:hover .button__text:after{width:100%;border-bottom-color:#c80000}.button--link:active,.button--nav:active{color:#d33333}.button--link:active .button__text:after,.button--nav:active .button__text:after{width:100%;border-bottom-color:#d33333}.button--link.button--active,.button--nav.button--active{color:#000}.button--link.button--active .button__text:after,.button--nav.button--active .button__text:after{width:100%;border-bottom-color:#000}.button--link[disabled],.button--nav[disabled]{color:#939393;cursor:not-allowed}.button--link[disabled] .button__text,.button--nav[disabled] .button__text{border-color:#939393}.button--link[disabled] .button__text:after,.button--nav[disabled] .button__text:after{display:none}.button--link .button__icon,.button--nav .button__icon{margin-bottom:.3125rem}.button--nav{font-weight:400}.button--nav .button__text{padding-bottom:0;border-bottom-color:transparent}.button--link.button--is-reversed{color:#fff}.button--link.button--is-reversed .button__text{border-color:#fff}.button--link.button--is-reversed:focus,.button--link.button--is-reversed:hover{color:#f2f2f2}.button--link.button--is-reversed:focus .button__text:after,.button--link.button--is-reversed:hover .button__text:after{border-bottom-color:#f2f2f2}.button--link.button--is-reversed:active{color:#e5e5e5}.button--link.button--is-reversed:active .button__text:after{border-bottom-color:#e5e5e5}.button--link.button--icon .button__icon{margin-right:-1rem}.button--link.button--icon .button__text{padding-left:1.5rem}.button--link.button--icon.button--icon-right .button__icon{margin-left:-1rem;margin-right:0}.button--link.button--icon.button--icon-right .button__text{padding-left:0;padding-right:1.5rem}.button--icon.button--icon-right .button__icon{margin-left:.5rem;margin-right:0}.button--fullwidth{width:100%}.button--mega{padding:.69em 1.32em;font-size:1.5rem;min-height:64px}.button--mega .button__icon{height:1.5rem;width:1.5rem;margin-right:1.5rem}.button--mega.button--icon.button--icon-right .button__icon{margin-left:1.5rem;margin-right:0}.button--mega.button--link,.button--mega.button--nav{padding:0}.button--mega.button--link.button--icon .button__text,.button--mega.button--nav.button--icon .button__text{padding-left:2.5rem}.button--mega.button--link.button--icon .button__icon,.button--mega.button--nav.button--icon .button__icon{margin-right:-2rem;margin-bottom:.5rem}.button--mega.button--link.button--icon.button--icon-right .button__text,.button--mega.button--nav.button--icon.button--icon-right .button__text{padding-left:0;padding-right:2.5rem}.button--mega.button--link.button--icon.button--icon-right .button__icon,.button--mega.button--nav.button--icon.button--icon-right .button__icon{margin-left:-2rem;margin-right:0}.button--text-left{-ms-flex-pack:start;justify-content:flex-start}.button--text-left .button__text{text-align:left}.button--text-right{-ms-flex-pack:end;justify-content:flex-end}.button--text-right .button__text{text-align:right}";
styleInject(css_248z$5);

var Button = function Button(_ref) {
  var text = _ref.text,
      fullWidth = _ref.fullWidth,
      onClick = _ref.onClick,
      to = _ref.to,
      disabled = _ref.disabled,
      size = _ref.size,
      variant = _ref.variant,
      iconPosition = _ref.iconPosition,
      icon = _ref.icon,
      type = _ref.type,
      textAlignment = _ref.textAlignment,
      isReversed = _ref.isReversed,
      className = _ref.className,
      active = _ref.active,
      forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, ["text", "fullWidth", "onClick", "to", "disabled", "size", "variant", "iconPosition", "icon", "type", "textAlignment", "isReversed", "className", "active", "forwardedRef"]);

  var classes = classnames("button", {
    "button--link": variant === "link",
    "button--primary": variant === "primary",
    "button--outlined": variant === "outlined",
    "button--nav": variant === "nav",
    "button--fullwidth": fullWidth,
    "button--mega": size === "mega",
    "button--icon": !!icon,
    "button--icon-right": iconPosition === "right",
    "button--text-left": textAlignment === "left",
    "button--text-right": textAlignment === "right",
    "button--is-reversed": isReversed,
    "button--active": active
  }, className);

  var handleClick = function handleClick(e) {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return to ? jsx(BaseAnchor, _extends({
    to: to,
    onClick: handleClick,
    className: classes,
    forwardedRef: forwardedRef
  }, props), icon && iconPosition !== "right" && icon({
    className: "button__icon"
  }), jsx("span", {
    className: "button__text"
  }, text), icon && iconPosition === "right" && icon({
    className: "button__icon"
  })) : jsx(BaseButton, _extends({
    type: type,
    disabled: disabled,
    onClick: handleClick,
    className: classes,
    forwardedRef: forwardedRef
  }, props), icon && iconPosition !== "right" && icon({
    className: "button__icon"
  }), jsx("span", {
    className: "button__text"
  }, text), icon && iconPosition === "right" && icon({
    className: "button__icon"
  }));
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["link", "primary", "outlined", "nav"]),
  iconPosition: PropTypes.oneOf(["left", "right"]),
  icon: PropTypes.func,
  textAlignment: PropTypes.oneOf(["default", "left", "right"]),
  isReversed: PropTypes.bool,
  size: PropTypes.oneOf(["default", "mega"]),
  type: PropTypes.oneOf(["button", "submit"]),
  className: PropTypes.string,
  active: PropTypes.bool,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
Button.defaultProps = {
  disabled: false,
  isReversed: false,
  size: "default",
  variant: "primary",
  iconPosition: "left",
  textAlignment: "default",
  type: "button"
};

var css_248z$6 = ".button-group__row{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-bottom:1rem;margin-left:-.5rem;margin-right:-.5rem}.button-group__row .button{-ms-flex:1 1 auto;flex:1 1 auto;margin:0 .5rem}.button-group__row--space-between{-ms-flex-pack:justify;justify-content:space-between}.button-group__row--center{-ms-flex-pack:center;justify-content:center}.button-group__row--space-evenly{-ms-flex-pack:space-evenly;justify-content:space-evenly}.button-group__row--center .button,.button-group__row--space-between .button,.button-group__row--space-evenly .button{-ms-flex:none;flex:none}@media screen and (max-width:28.74875em){.button-group__row--screen0-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:28.74875em){.button-group__row--screen0-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:47.99875em){.button-group__row--small-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:47.99875em){.button-group__row--small-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:63.99875em){.button-group__row--medium-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:63.99875em){.button-group__row--medium-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:28.74875em){.button-group__row--large-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:28.74875em){.button-group__row--large-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:47.99875em){.button-group__row--screen460-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:47.99875em){.button-group__row--screen460-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:63.99875em){.button-group__row--screen768-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:63.99875em){.button-group__row--screen768-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:82.49875em){.button-group__row--screen1024-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:82.49875em){.button-group__row--screen1024-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:87.49875em){.button-group__row--screen1320-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:87.49875em){.button-group__row--screen1320-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:99.99875em){.button-group__row--screen1400-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:99.99875em){.button-group__row--screen1400-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}@media screen and (max-width:119.99875em){.button-group__row--screen1600-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}}@media screen and (max-width:119.99875em){.button-group__row--screen1600-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}}.button-group__row--screen1920-stacked{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:row;flex-direction:row;margin-bottom:0}.button-group__row--screen1920-stacked .button{-ms-flex-preferred-size:100%;flex-basis:100%;margin-bottom:1rem}";
styleInject(css_248z$6);

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classnames("button-group", className);
  return jsx("div", _extends({
    className: classes
  }, props), children);
};

ButtonGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
};

var ButtonGroupRow = function ButtonGroupRow(_ref) {
  var _classNames;

  var stackAtSize = _ref.stackAtSize,
      buttonAlignment = _ref.buttonAlignment,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["stackAtSize", "buttonAlignment", "children", "className"]);

  var classes = classnames("button-group__row", (_classNames = {}, _defineProperty(_classNames, "button-group__row--".concat(stackAtSize, "-stacked"), stackAtSize), _defineProperty(_classNames, "button-group__row--space-between", buttonAlignment === "space-between"), _defineProperty(_classNames, "button-group__row--center", buttonAlignment === "center"), _defineProperty(_classNames, "button-group__row--space-evenly", buttonAlignment === "space-evenly"), _classNames), className);
  return jsx("div", _extends({
    className: classes
  }, props), children);
};

ButtonGroupRow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  stackAtSize: PropTypes.string,
  className: PropTypes.string,
  buttonAlignment: PropTypes.string
};

var css_248z$7 = ".card{background-color:#fff;box-shadow:0 1px 6px 0 rgba(0,0,0,.16);padding:0 1.5rem 1.5rem;display:block;text-decoration:inherit;color:inherit}.card .card__inner{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-top:1.5rem}.card__inner .card__inner-content{-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;max-width:100%}@media screen and (min-width:48em){.card{padding:0 2rem 2rem}.card .card__inner{padding-top:2rem}}@media screen and (min-width:82.5em){.card{padding:0 3rem 3rem}.card .card__inner{padding-top:3rem}}.card--is-button{cursor:pointer}@media screen and (min-width:28.75em){.card--with-icon .card__inner{-ms-flex-flow:nowrap;flex-flow:nowrap;-ms-flex-direction:row;flex-direction:row}}.card__icon{width:1rem;height:1rem;-ms-flex:0 0 auto;flex:0 0 auto;margin-top:.25rem;margin-right:1rem;margin-bottom:1rem}.card--with-medium-icon .card__icon{width:1.5rem;height:1.5rem;margin-right:1.5rem;margin-bottom:1.5rem}.card--with-large-icon .card__icon{width:2rem;height:2rem;margin-right:2rem;margin-bottom:2rem}a.card{transition:box-shadow .1s ease-in-out}a.card:focus,a.card:hover{box-shadow:0 4px 24px rgba(0,0,0,.32)}";
styleInject(css_248z$7);

var Card = function Card(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      href = _ref.href,
      target = _ref.target,
      backgroundColor = _ref.backgroundColor,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      center = _ref.center,
      props = _objectWithoutProperties(_ref, ["children", "className", "onClick", "href", "target", "backgroundColor", "icon", "iconSize", "center"]);

  var classes = classnames("card", (_classNames = {}, _defineProperty(_classNames, "u-bg-".concat(backgroundColor, " u-white"), backgroundColor === "red" || backgroundColor === "black"), _defineProperty(_classNames, "u-bg-grey-5", backgroundColor === "grey"), _defineProperty(_classNames, "card--with-icon", !!icon), _defineProperty(_classNames, "card--with-medium-icon", icon && iconSize === "medium"), _defineProperty(_classNames, "card--with-large-icon", icon && iconSize === "large"), _defineProperty(_classNames, "card--is-button", !!onClick), _defineProperty(_classNames, "u-text-center", center), _classNames), className);

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 13) {
      onClick();
    }
  };

  var innerProps = {};

  if (onClick) {
    innerProps = _objectSpread2(_objectSpread2({}, innerProps), {}, {
      onClick: onClick,
      onKeyDown: handleKeyPress,
      role: "button",
      tabIndex: "0"
    });
  }

  if (onClick || href) {
    return jsx("a", _extends({
      href: href,
      target: target,
      className: classes
    }, innerProps, props), jsx("div", {
      className: "card__inner"
    }, icon && icon({
      className: "card__icon"
    }), jsx("div", {
      className: "card__inner-content"
    }, children)));
  }

  return jsx("div", _extends({
    className: classes
  }, innerProps, props), jsx("div", {
    className: "card__inner"
  }, icon && icon({
    className: "card__icon"
  }), jsx("div", {
    className: "card__inner-content"
  }, children)));
};

Card.propTypes = {
  backgroundColor: PropTypes.oneOf(["white", "red", "black", "grey"]),
  icon: PropTypes.func,
  iconSize: PropTypes.oneOf(["default", "medium", "large"]),
  center: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string
};

var css_248z$8 = ".overline-heading{font-size:.75rem;line-height:1.67;letter-spacing:.094em;text-transform:uppercase;font-weight:400;padding:0 1.5rem;text-align:center}.overline-heading__title{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.overline-heading__icon{height:1rem;width:1rem;margin-right:.5rem}.overline-heading--large{font-size:1rem}.overline-heading--large .overline-heading__icon{margin-right:1rem}";
styleInject(css_248z$8);

var OverlineHeading = function OverlineHeading(_ref) {
  var text = _ref.text,
      size = _ref.size,
      icon = _ref.icon,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["text", "size", "icon", "className"]);

  var classes = classnames("overline-heading", {
    "overline-heading--large": size === "large"
  }, className);
  return jsx("h3", _extends({
    className: classes
  }, props), jsx("span", {
    className: "overline-heading__title"
  }, icon && icon({
    className: "overline-heading__icon"
  }), text));
};

OverlineHeading.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["default", "large"]),
  icon: PropTypes.func,
  className: PropTypes.string
};

var css_248z$9 = ".card-group{box-shadow:0 1px 6px 0 rgba(0,0,0,.16);background-color:#fff}.card-group .card{box-shadow:none}.card-group .card+.card .card__inner{border-top:1px solid #e5e5e5}.card-group .card+.card.u-bg-black .card__inner,.card-group .card+.card.u-bg-grey .card__inner,.card-group .card+.card.u-bg-red .card__inner{border-top:none}.card-group__heading{padding:2rem 0 0}@media screen and (min-width:64em){.card-group--inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.card-group--inline .card-group__heading{-ms-flex:0 0 100%;flex:0 0 100%}.card-group--inline .card{-ms-flex:1 0 33.33333%;flex:1 0 33.33333%;padding-top:2rem}.card-group--inline .card .card__inner{padding-top:0}.card-group--inline .card+.card{position:relative}.card-group--inline .card+.card:before{position:absolute;content:\"\";background-color:#e5e5e5;height:40%;width:1px;top:50%;left:0;transform:translateY(-50%)}.card-group--inline .card+.card .card__inner{border-top:none}}@media screen and (min-width:82.5em){.card-group--inline .card{padding-top:3rem}}";
styleInject(css_248z$9);

var CardGroup = function CardGroup(_ref) {
  var children = _ref.children,
      inline = _ref.inline,
      heading = _ref.heading,
      headingIcon = _ref.headingIcon,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "inline", "heading", "headingIcon", "className"]);

  var classes = classnames("card-group", {
    "card-group--inline": inline
  }, className);
  return jsx("div", _extends({
    className: classes
  }, props), heading && jsx(OverlineHeading, {
    text: heading,
    icon: headingIcon,
    size: "large",
    className: "card-group__heading"
  }), children);
};

CardGroup.propTypes = {
  inline: PropTypes.bool,
  heading: PropTypes.string,
  headingIcon: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string
};

var css_248z$a = ".toggle-control{background:transparent;padding:0;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;cursor:pointer;font-family:avenir,Helvetica,Arial,sans-serif}.toggle-control__control{-ms-flex:none;flex:none;background:transparent;position:relative;margin-right:.75rem}.toggle-control input{position:absolute;left:-100vw}.toggle-control__label{line-height:1.5}.toggle-control__additional{margin-top:1rem}.toggle-control--disabled{cursor:auto}.toggle-control--disabled .toggle-control__content,.toggle-control--disabled .toggle-control__control{opacity:.3}.toggle-control--boxed.toggle-control--disabled .toggle-control__content{opacity:.4}.toggle-control--boxed{background:#fafafa;border:1px solid #e5e5e5;padding:1.5rem;border-radius:5px}.toggle-control--boxed.toggle-control--checked{box-shadow:0 4px 16px rgba(0,0,0,.24);background:#fff}.toggle-control--boxed .toggle-control__label{font-size:1.25rem;line-height:1.2;font-weight:700}@media screen and (min-width:64em){.toggle-control--boxed{padding:2rem}.toggle-control__content{margin-top:.25rem}}";
styleInject(css_248z$a);

var ToggleControl = function ToggleControl(_ref) {
  var id = _ref.id,
      type = _ref.type,
      value = _ref.value,
      children = _ref.children,
      checked = _ref.checked,
      text = _ref.text,
      onChange = _ref.onChange,
      boxed = _ref.boxed,
      className = _ref.className,
      name = _ref.name,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["id", "type", "value", "children", "checked", "text", "onChange", "boxed", "className", "name", "disabled"]);

  var classes = classnames("toggle-control", {
    "toggle-control--checked": checked,
    "toggle-control--boxed": boxed,
    "toggle-control--disabled": disabled
  }, "toggle-control--".concat(type), className);
  return jsx("label", _extends({
    htmlFor: id,
    className: classes
  }, props), jsx("input", {
    id: id,
    type: type,
    value: value,
    checked: checked,
    onChange: onChange,
    name: name,
    disabled: disabled
  }), jsx("span", {
    className: "toggle-control__control"
  }), jsx("div", {
    className: "toggle-control__content"
  }, jsx("div", {
    className: "toggle-control__label body-copy"
  }, text), children && jsx("div", {
    className: "toggle-control__additional"
  }, children)));
};

var ToggleControlPropTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
  text: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  boxed: PropTypes.bool,
  name: PropTypes.string
};
ToggleControl.propTypes = _objectSpread2(_objectSpread2({}, ToggleControlPropTypes), {}, {
  type: PropTypes.string.isRequired
});

var css_248z$b = ".toggle-control--checkbox .toggle-control__control{display:block;position:relative;height:2rem;width:2rem;border:2px solid #e5e5e5;background:#fafafa 50% no-repeat;-ms-flex:none;flex:none;margin-right:1rem}.toggle-control--checkbox .toggle-control__control:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:50% no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 15'%3E%3Cpath fill='%23C80000' fill-rule='evenodd' stroke='%23C80000' d='M7.706 9.573l8.57-8.26 2.454 2.265L7.72 14.115l-6.457-5.96 2.454-2.264 3.99 3.682z'/%3E%3C/svg%3E\");background-size:0;transition:all .1s ease-out}.toggle-control--checkbox.toggle-control--checked .toggle-control__control:after{background-size:80%}";
styleInject(css_248z$b);

var Checkbox = function Checkbox(props) {
  return jsx(ToggleControl, _extends({
    type: "checkbox"
  }, props));
};

Checkbox.propTypes = ToggleControlPropTypes;

var css_248z$c = ".content-list{text-align:left;width:100%}.content-list li{list-style:none;margin-bottom:0}.content-list--centered{text-align:center}.content-list--centered ul{text-align:left;display:inline-block;margin:0 auto}.content-list--inline{text-align:center}.content-list--inline li{display:inline-block;padding:0 .5rem}.content-list--inline li:before{display:none}";
styleInject(css_248z$c);

var ContentList = function ContentList(_ref) {
  var center = _ref.center,
      inline = _ref.inline,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["center", "inline", "className", "children"]);

  var classes = classnames("content-list", {
    "content-list--centered": center,
    "content-list--inline": inline
  }, className);
  return jsx("div", _extends({
    className: classes
  }, props), children);
};

ContentList.propTypes = {
  center: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var css_248z$d = ".dashboard-card{background-color:#fff;box-shadow:0 1px 6px 0 rgba(0,0,0,.16);padding:0 2rem 2rem;display:block;text-decoration:inherit;color:inherit}.dashboard-card .card__inner{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-top:2rem}.dashboard-card__inner .dashboard-card__inner-content{-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;max-width:100%}@media screen and (min-width:64em){.dashboard-card{padding:0 4rem 4rem}.dashboard-card .card__inner{padding-top:4rem}}.dashboard-card--is-button{cursor:pointer}@media screen and (min-width:28.75em){.dashboard-card--with-icon .card__inner{-ms-flex-flow:nowrap;flex-flow:nowrap;-ms-flex-direction:row;flex-direction:row}}.dashboard-card__icon{width:1rem;height:1rem;-ms-flex:0 0 auto;flex:0 0 auto;margin-top:.25rem;margin-right:1rem;margin-bottom:1rem}.dashboard-card--with-medium-icon .dashboard-card__icon{width:1.5rem;height:1.5rem;margin-right:1.5rem;margin-bottom:1.5rem}.dashboard-card--with-large-icon .dashboard-card__icon{width:2rem;height:2rem;margin-right:2rem;margin-bottom:2rem}.dashboard-card .card__inner{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.dashboard-card__illustration-container{height:8rem;overflow:hidden;text-align:right;width:100%;position:relative;-ms-flex:none;flex:none}.dashboard-card__illustration{height:100%;max-width:none;position:absolute;top:0;right:0}.dashboard-card__content{padding-top:1.5rem}.dashboard-card__button-container .button{margin-top:2rem}.dashboard-card__heading a[href^=tel]{color:inherit;text-decoration:none}@media screen and (min-width:48em){.dashboard-card__content-container{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;width:100%}.dashboard-card__heading{-ms-flex:1 1 auto;flex:1 1 auto;width:66.66667%}.dashboard-card__heading+.dashboard-card__button-container{-ms-flex-item-align:center;align-self:center}.dashboard-card__heading+.dashboard-card__button-container .button{margin-top:0}.dashboard-card__content{-ms-flex:1 1 auto;flex:1 1 auto;width:66.66667%}.dashboard-card__button-container{-ms-flex:0 0 auto;flex:0 0 auto;width:33.33333%;text-align:right;-ms-flex-item-align:end;align-self:flex-end}.dashboard-card__button-container .button{margin-top:1.5rem;-ms-flex:0 0 auto;flex:0 0 auto;margin-left:2.5rem}}@media screen and (min-width:82.5em){.dashboard-card__heading{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}}";
styleInject(css_248z$d);

var DashboardCard = function DashboardCard(_ref) {
  var heading = _ref.heading,
      children = _ref.children,
      button = _ref.button,
      illustration = _ref.illustration,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["heading", "children", "button", "illustration", "backgroundColor", "className"]);

  var classes = classnames("dashboard-card", className);

  var componentProps = _objectSpread2({
    backgroundColor: backgroundColor,
    className: classes
  }, props);

  return jsx(Card, componentProps, illustration && jsx("div", {
    className: "dashboard-card__illustration-container u-margin-bottom-1"
  }, jsx("img", {
    src: illustration,
    alt: "",
    className: "dashboard-card__illustration"
  })), jsx("div", {
    className: "dashboard-card__content-container"
  }, jsx("h2", {
    className: "dashboard-card__heading h500 u-font-heading"
  }, heading), children && jsx(BodyCopy, {
    className: "dashboard-card__content"
  }, children), button && jsx("div", {
    className: "dashboard-card__button-container"
  }, button)));
};

DashboardCard.propTypes = {
  backgroundColor: PropTypes.oneOf(["white", "red", "black", "grey"]),
  heading: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  button: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Button)]),
  illustration: PropTypes.string,
  className: PropTypes.string
};

var css_248z$e = ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:transparent}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#fff}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:transparent}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:transparent}.react-datepicker-wrapper{display:inline-block;padding:0;border:0}.react-datepicker{font-family:avenir,Helvetica,Arial,sans-serif;font-size:1rem;background-color:#fff;color:#000;border:1px solid transparent;border-radius:0;display:inline-block;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle,.react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle{left:auto;right:50px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#fff;border-bottom:1px solid transparent;border-top-left-radius:0;border-top-right-radius:0;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker-year-header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:1.18rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:2rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:.5rem solid transparent;z-index:1;height:10px;width:10px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__year-container{margin:1rem;text-align:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.react-datepicker__year-container-text{display:inline-block;cursor:pointer;-ms-flex:1 0 30%;flex:1 0 30%;width:12px;padding:2px}.react-datepicker__month{margin:1rem;text-align:center}.react-datepicker__month .react-datepicker__month-text,.react-datepicker__month .react-datepicker__quarter-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__input-time-container{clear:both;width:100%;float:left;margin:5px 0 10px 15px;text-align:left}.react-datepicker__input-time-container .react-datepicker-time__caption,.react-datepicker__input-time-container .react-datepicker-time__input-container{display:inline-block}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input{display:inline-block;margin-left:10px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input{width:85px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]{-moz-appearance:textfield}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter{margin-left:5px;display:inline-block}.react-datepicker__time-container{float:right;border-left:1px solid transparent;width:85px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:85px;overflow-x:hidden;margin:0 auto;text-align:center}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 1rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px;white-space:nowrap}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#c80000;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#c80000}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:2rem;line-height:2rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:0;background-color:#fff}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:2rem;line-height:2rem;text-align:center;margin:.166rem}.react-datepicker__month--in-range,.react-datepicker__month--in-selecting-range,.react-datepicker__month--selected,.react-datepicker__quarter--in-range,.react-datepicker__quarter--in-selecting-range,.react-datepicker__quarter--selected{border-radius:0;background-color:#c80000;color:#fff}.react-datepicker__month--in-range:hover,.react-datepicker__month--in-selecting-range:hover,.react-datepicker__month--selected:hover,.react-datepicker__quarter--in-range:hover,.react-datepicker__quarter--in-selecting-range:hover,.react-datepicker__quarter--selected:hover{background-color:#af0000}.react-datepicker__month--disabled,.react-datepicker__quarter--disabled{color:#ccc;pointer-events:none}.react-datepicker__month--disabled:hover,.react-datepicker__quarter--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__day,.react-datepicker__month-text,.react-datepicker__quarter-text{cursor:pointer}.react-datepicker__day:hover,.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover{border-radius:0;background-color:#fff}.react-datepicker__day--today,.react-datepicker__month-text--today,.react-datepicker__quarter-text--today{font-weight:700}.react-datepicker__day--highlighted,.react-datepicker__month-text--highlighted,.react-datepicker__quarter-text--highlighted{border-radius:0;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover,.react-datepicker__month-text--highlighted:hover,.react-datepicker__quarter-text--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1,.react-datepicker__month-text--highlighted-custom-1,.react-datepicker__quarter-text--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2,.react-datepicker__month-text--highlighted-custom-2,.react-datepicker__quarter-text--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected,.react-datepicker__month-text--in-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--selected,.react-datepicker__quarter-text--in-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__quarter-text--selected{border-radius:0;background-color:#c80000;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover,.react-datepicker__month-text--in-range:hover,.react-datepicker__month-text--in-selecting-range:hover,.react-datepicker__month-text--selected:hover,.react-datepicker__quarter-text--in-range:hover,.react-datepicker__quarter-text--in-selecting-range:hover,.react-datepicker__quarter-text--selected:hover{background-color:#af0000}.react-datepicker__day--keyboard-selected,.react-datepicker__month-text--keyboard-selected,.react-datepicker__quarter-text--keyboard-selected{border-radius:0;background-color:#fb0000;color:#fff}.react-datepicker__day--keyboard-selected:hover,.react-datepicker__month-text--keyboard-selected:hover,.react-datepicker__quarter-text--keyboard-selected:hover{background-color:#af0000}.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range{background-color:rgba(200,0,0,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range,.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range,.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range{background-color:#fff;color:#000}.react-datepicker__day--disabled,.react-datepicker__month-text--disabled,.react-datepicker__quarter-text--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover,.react-datepicker__month-text--disabled:hover,.react-datepicker__quarter-text--disabled:hover{background-color:transparent}.react-datepicker__month-text.react-datepicker__month--in-range:hover,.react-datepicker__month-text.react-datepicker__month--selected:hover,.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,.react-datepicker__month-text.react-datepicker__quarter--selected:hover,.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,.react-datepicker__quarter-text.react-datepicker__month--selected:hover,.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover,.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover{background-color:#c80000}.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover{background-color:#fff}.react-datepicker__input-container{position:relative;display:inline-block;width:100%}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:0}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.5rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#fff;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:0;border:1px solid transparent}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:0;border-top-right-radius:0}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{cursor:pointer;background-color:transparent;border:0;outline:0;padding:0 6px 0 0;position:absolute;top:0;right:0;height:100%;display:table-cell;vertical-align:middle}.react-datepicker__close-icon:after{cursor:pointer;background-color:#c80000;color:#fff;border-radius:50%;height:16px;width:16px;padding:2px;font-size:12px;line-height:1;text-align:center;display:table-cell;vertical-align:middle;content:\"\\00d7\"}.react-datepicker__today-button{background:#fff;border-top:1px solid transparent;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.8rem}.react-datepicker__portal .react-datepicker__navigation{border:.9rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.date-picker-component{max-width:17.5rem}.date-picker,.date-picker[type=date],.date-picker[type=datetime-local],.date-picker[type=text]{background-position:50%;background-repeat:no-repeat;background-size:1rem 1rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M11.449 0c.301 0 .545.244.545.545v2.097c.633.227 1.091.834 1.091 1.54 0 .897-.739 1.636-1.636 1.636-.897 0-1.637-.739-1.637-1.636 0-.706.459-1.313 1.091-1.54V.545c0-.3.245-.545.546-.545zm-6.91 0c.302 0 .546.244.546.545v2.097c.633.227 1.091.834 1.091 1.54 0 .897-.739 1.636-1.636 1.636-.898 0-1.637-.739-1.637-1.636 0-.706.459-1.313 1.091-1.54V.545c0-.3.245-.545.546-.545zm9.455 1.09c1.102 0 2.006.905 2.006 2.007v10.897A2.014 2.014 0 0113.994 16H2.006A2.014 2.014 0 010 13.994V3.097C0 1.995.904 1.09 2.006 1.09H3.09c.288-.004.551.257.551.545s-.263.55-.551.546H2.006c-.515 0-.915.4-.915.915v3.085h13.818V3.097c0-.515-.4-.915-.915-.915H12.91a.565.565 0 01-.551-.546c0-.288.263-.55.551-.545h1.085zM10 1.09a.545.545 0 110 1.092H6A.545.545 0 016 1.09h4zm1.449 2.546a.537.537 0 00-.546.546c0 .308.238.545.546.545a.537.537 0 00.545-.545.537.537 0 00-.545-.546zm-6.91 0a.537.537 0 00-.545.546c0 .308.238.545.546.545s.545-.237.545-.545a.537.537 0 00-.545-.546zm10.37 3.637H1.091v6.721c0 .515.4.915.915.915h11.988c.515 0 .915-.4.915-.915V7.273z'/%3E%3C/svg%3E\");padding-right:2rem;position:relative;background-position:right 1rem center}.datepicker-range{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.datepicker-range .datepicker-range__item{-ms-flex:1;flex:1}.datepicker-range .datepicker-range__separator{-ms-flex:none;flex:none;padding:1rem;text-align:center}.react-datepicker{box-shadow:0 4px 24px rgba(0,0,0,.32)}.react-datepicker-popper{z-index:4}.react-datepicker__header{border-bottom:none;padding-top:1.5rem;font-weight:400}.react-datepicker-time__header,.react-datepicker__current-month{font-size:1.25rem;line-height:1.2;font-weight:700}.react-datepicker__month{margin-top:0}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{font-size:1.25rem;line-height:2.25rem}.react-datepicker__day-names{padding-top:.75rem}.react-datepicker__day-name{color:#939393}.react-datepicker__day{transition:all .1s ease-in-out}.react-datepicker__day:focus,.react-datepicker__day:hover{background:#c80000;color:#fff}.react-datepicker__day.react-datepicker__day--in-range,.react-datepicker__day.react-datepicker__day--in-selecting-range{background:#3f3f3f;color:#fff}.react-datepicker__day.react-datepicker__day--range-end,.react-datepicker__day.react-datepicker__day--range-start{background:#c80000;color:#fff;font-weight:700}.react-datepicker__day.react-datepicker__day--keyboard-selected{background:#c80000;color:#fff}.react-datepicker__day--outside-month{color:transparent;pointer-events:none}.react-datepicker__navigation{background:50% no-repeat;height:1rem;width:1rem;border:none;top:1.75rem}.react-datepicker__navigation--previous{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.772 8L11 11.497 9.614 13 5 8l4.614-5L11 4.502z'/%3E%3C/svg%3E\");left:1.5rem}.react-datepicker__navigation--next,.react-datepicker__navigation--previous{background-position:50%;background-repeat:no-repeat;background-size:1rem 1rem}.react-datepicker__navigation--next{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.228 8L5 4.503 6.386 3 11 8l-4.614 5L5 11.498z'/%3E%3C/svg%3E\");right:1.5rem}.react-datepicker__time-container,.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:6rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{margin-bottom:0;height:auto;padding:0;font-size:1rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:before{display:none}.react-datepicker__year-dropdown{box-shadow:0 4px 24px rgba(0,0,0,.32)}.react-datepicker__year-dropdown-container{margin-top:1rem}.react-datepicker__year-read-view--down-arrow{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 8.228L11.497 5 13 6.386 8 11 3 6.386 4.502 5z' fill='currentColor'/%3E%3C/svg%3E\");border:none;top:0;margin-left:.5rem}.react-datepicker__year-option--selected,.react-datepicker__year-read-view--down-arrow{background-position:50%;background-repeat:no-repeat;background-size:1rem 1rem;width:1rem;height:1rem}.react-datepicker__year-option--selected{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 11.228L13.497 4 15 5.386 6 14 1 9.386 2.502 8z' fill='currentColor' fill-rule='evenodd'/%3E%3C/svg%3E\");text-indent:-10rem}.react-datepicker__day--keyboard-selected{background:#c80000;color:#fff}.react-datepicker__input-container{display:block}@media screen and (max-width:63.99875em){.native-datepicker[type=date],.native-datepicker[type=datetime-local]{display:block}.react-datepicker-wrapper{display:none}}@media screen and (min-width:48em){.native-datepicker[type=date],.native-datepicker[type=datetime-local]{display:none}.react-datepicker-wrapper{display:block;max-width:17.5rem}.datepicker-range{-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}}";
styleInject(css_248z$e);

registerLocale("en-GB", enGB);
var formatNativeDate = function formatNativeDate(date) {
  var includesTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!date) {
    return "";
  }

  if (includesTime) {
    return "".concat(format(date, "yyyy-MM-dd"), "T").concat(format(date, "HH:mm"));
  }

  return format(date, "yyyy-MM-dd");
};
var parseNativeDate = function parseNativeDate(dateStr) {
  if (!dateStr) {
    return null;
  }

  return parseISO(dateStr);
};

var DatePicker = function DatePicker(_ref) {
  var id = _ref.id,
      dateFormat = _ref.dateFormat,
      date = _ref.date,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      includeTime = _ref.includeTime,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      range = _ref.range,
      isRangeStart = _ref.isRangeStart,
      isRangeEnd = _ref.isRangeEnd,
      showYearDropdown = _ref.showYearDropdown,
      dropdownYears = _ref.dropdownYears,
      locale = _ref.locale,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      inputRef = _ref.inputRef,
      openToDate = _ref.openToDate;

  var handleChangeNative = function handleChangeNative(e) {
    onChange(parseNativeDate(e.target.value));
  };

  var value = formatNativeDate(date, includeTime);
  var min = minDate ? format(minDate, "yyyy-MM-dd") : "";
  var max = maxDate ? format(maxDate, "yyyy-MM-dd") : "";
  var classes = classnames("date-picker-component", className);
  return jsx("div", {
    className: classes
  }, jsx("input", {
    id: id,
    type: includeTime ? "datetime-local" : "date",
    value: value,
    onChange: handleChangeNative,
    min: min,
    max: max,
    readOnly: disabled,
    className: "native-datepicker"
  }), jsx(ReactDatePicker, {
    ref: inputRef,
    id: id,
    selected: date,
    minDate: minDate,
    maxDate: maxDate,
    onChange: onChange,
    onBlur: onBlur,
    className: "date-picker",
    placeholderText: placeholder,
    readOnly: disabled,
    dateFormat: dateFormat,
    showTimeSelect: includeTime,
    selectsStart: isRangeStart,
    selectsEnd: isRangeEnd,
    startDate: range ? range.startDate : null,
    endDate: range ? range.endDate : null,
    showYearDropdown: showYearDropdown,
    scrollableYearDropdown: showYearDropdown,
    yearDropdownItemNumber: dropdownYears,
    locale: locale,
    openToDate: openToDate,
    autoComplete: "off"
  }));
};

DatePicker.propTypes = {
  inputRef: PropTypes.node,
  id: PropTypes.string.isRequired,
  dateFormat: PropTypes.string.isRequired,
  date: PropTypes.shape({}),
  minDate: PropTypes.shape({}),
  maxDate: PropTypes.shape({}),
  placeholder: PropTypes.string,
  includeTime: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  range: PropTypes.shape({
    startDate: PropTypes.shape({}),
    endDate: PropTypes.shape({})
  }),
  isRangeStart: PropTypes.bool,
  isRangeEnd: PropTypes.bool,
  showYearDropdown: PropTypes.bool,
  dropdownYears: PropTypes.number,
  locale: PropTypes.string,
  openToDate: PropTypes.shape({})
};

var css_248z$f = ".doughnut{position:relative;margin-left:auto;margin-right:auto;max-width:100%;max-height:100%;width:6rem;height:6rem}.doughnut__text{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;font-size:1rem;color:#000}.doughnut__track{stroke:#ecedf0}.doughnut__marker,.doughnut__path{stroke:currentColor;will-change:transform}.doughnut__marker{width:24px;height:24px;position:absolute}.doughnut__marker-div{position:absolute;border-color:currentColor;top:2px;left:50%;border-radius:50%}.doughnut--medium{width:11.5rem;height:11.5rem}.doughnut--medium .doughnut__text{font-size:1.5rem}.doughnut--large{width:15.25rem;height:15.25rem}.doughnut--large .doughnut__text{font-size:2rem}";
styleInject(css_248z$f);

var getStrokeDashOffset = function getStrokeDashOffset() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var circumference = arguments.length > 1 ? arguments[1] : undefined;
  return Math.round((100 - Math.min(val, 100)) / 100 * circumference);
};

var getMarkerRotation = function getMarkerRotation() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Math.round(val / 100 * 360);
};

var inView = function inView(element, elementHeight) {
  if (element) {
    var windowHeight = window.innerHeight;
    var scrollY = window.scrollY || window.pageYOffset;
    var scrollPosition = scrollY + windowHeight;
    var elementPosition = element.getBoundingClientRect().top + scrollY + elementHeight;

    if (scrollPosition > elementPosition) {
      return true;
    }
  }

  return false;
};

var Doughnut = /*#__PURE__*/function (_Component) {
  _inherits(Doughnut, _Component);

  var _super = _createSuper(Doughnut);

  function Doughnut(props) {
    var _this;

    _classCallCheck(this, Doughnut);

    _this = _super.call(this, props);
    var shouldAnimate = props.shouldAnimate;
    _this.doughnutRef = null;

    _this.setDoughnutRef = function (element) {
      _this.doughnutRef = element;
    };

    _this.setUpComponent = _this.setUpComponent.bind(_assertThisInitialized(_this));
    _this.animate = _this.animate.bind(_assertThisInitialized(_this));

    var componentState = _this.setUpComponent();

    var markerRotationValue = componentState.markerRotationValue,
        strokeDashoffsetValue = componentState.strokeDashoffsetValue,
        circumference = componentState.circumference,
        radius = componentState.radius;
    _this.state = {
      markerRotationValue: shouldAnimate ? 0 : markerRotationValue,
      markerRotationAnimationValue: markerRotationValue,
      strokeDashoffsetValue: shouldAnimate ? circumference : strokeDashoffsetValue,
      strokeDashoffsetAnimationValue: strokeDashoffsetValue,
      circumference: circumference,
      radius: radius
    };
    return _this;
  }

  _createClass(Doughnut, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var shouldAnimate = this.props.shouldAnimate;

      if (!shouldAnimate) {
        return;
      }

      document.addEventListener("scroll", this.animate);
      setTimeout(function () {
        _this2.animate();
      }, 200);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          size = _this$props.size,
          progress = _this$props.progress;

      if (prevProps.size !== size || prevProps.progress !== progress) {
        var updatedState = this.setUpComponent();
        this.setState(function (state) {
          return _objectSpread2(_objectSpread2({}, state), updatedState);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("scroll", this.animate);
    }
  }, {
    key: "setUpComponent",
    value: function setUpComponent() {
      var _this$props2 = this.props,
          progress = _this$props2.progress,
          size = _this$props2.size;
      var radius = 38;

      if (size === "medium") {
        radius = 82;
      } else if (size === "large") {
        radius = 112;
      }

      var circumference = Math.round(Math.PI * radius * 2);
      var strokeDashOffset = getStrokeDashOffset(progress, circumference);
      var markerRotation = getMarkerRotation(progress);
      return {
        markerRotationValue: markerRotation,
        strokeDashoffsetValue: strokeDashOffset,
        circumference: circumference,
        radius: radius
      };
    }
  }, {
    key: "animate",
    value: function animate() {
      this.doughnutHeight = this.doughnutRef && this.doughnutRef.clientHeight;

      if (inView(this.doughnutRef, this.doughnutHeight)) {
        this.setState(function (state) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            strokeDashoffsetValue: state.strokeDashoffsetAnimationValue,
            markerRotationValue: state.markerRotationAnimationValue
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          lineWidth = _this$props3.lineWidth,
          shouldAnimate = _this$props3.shouldAnimate,
          animationDuration = _this$props3.animationDuration,
          children = _this$props3.children,
          size = _this$props3.size,
          hideMarker = _this$props3.hideMarker,
          markerType = _this$props3.markerType;
      var _this$state = this.state,
          strokeDashoffsetValue = _this$state.strokeDashoffsetValue,
          markerRotationValue = _this$state.markerRotationValue,
          circumference = _this$state.circumference,
          radius = _this$state.radius;
      var progress = this.props.progress;
      var easing = "cubic-bezier(0.19, 1, 0.22, 1)";
      var pathTransitionStyles = shouldAnimate ? "stroke-dashoffset ".concat(animationDuration, " ").concat(easing) : undefined;
      var markerTransitionStyles = shouldAnimate ? "transform ".concat(animationDuration, " ").concat(easing) : undefined;
      var viewPortSize = radius * 2 + 20;
      var classes = classnames("doughnut", {
        "doughnut--medium": size === "medium",
        "doughnut--large": size === "large"
      }, className);
      return jsx("div", {
        className: classes,
        ref: this.setDoughnutRef
      }, jsx("svg", {
        viewBox: "-10 -10 ".concat(viewPortSize, " ").concat(viewPortSize),
        style: {
          overflow: "visible"
        }
      }, jsx("circle", {
        className: "doughnut__track",
        strokeLinecap: "round",
        strokeDasharray: circumference,
        cx: radius,
        cy: radius,
        r: radius,
        strokeWidth: lineWidth,
        fill: "none"
      }), progress !== 0 && jsx("circle", {
        transform: "rotate(-90 ".concat(radius, " ").concat(radius, ")"),
        cx: radius,
        cy: radius,
        r: radius,
        strokeDasharray: circumference,
        strokeWidth: lineWidth,
        strokeDashoffset: circumference,
        strokeLinecap: "round",
        fill: "none",
        style: {
          strokeDashoffset: strokeDashoffsetValue,
          transition: pathTransitionStyles
        },
        onTransitionEnd: function onTransitionEnd() {},
        className: "doughnut__path"
      }), !hideMarker && jsx("circle", {
        className: "doughnut__marker",
        strokeWidth: lineWidth / 2,
        cx: radius,
        cy: 0,
        r: lineWidth / 1.5,
        fill: markerType === "SOLID" ? "currentColor" : "#fff",
        style: {
          transform: "rotate(".concat(markerRotationValue, "deg)"),
          transition: markerTransitionStyles,
          transformOrigin: "".concat(radius, "px ").concat(radius, "px")
        }
      })), jsx("span", {
        className: "doughnut__text"
      }, children));
    }
  }]);

  return Doughnut;
}(Component);

Doughnut.defaultProps = {
  lineWidth: 8,
  progress: 0,
  shouldAnimate: true,
  animationDuration: "3s",
  size: "small",
  markerType: "CIRCLE"
};
Doughnut.propTypes = {
  className: PropTypes.string,
  lineWidth: PropTypes.number,
  progress: PropTypes.number,
  shouldAnimate: PropTypes.bool,
  animationDuration: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  hideMarker: PropTypes.bool,
  markerType: PropTypes.oneOf(["CIRCLE", "SOLID"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("path", {
  d: "M2 3.556v8.888L6.444 8 2 3.556zM3.556 2L8 6.444 12.444 2H3.556zM14 3.556L9.556 8 14 12.444V3.556zM12.444 14L8 9.556 3.556 14h8.888zM0 0h16v16H0V0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgIconPlaceholder(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8.5 7.5h6v1h-6V14h-1V8.5h-6v-1h6V2h1z"
});

function Svg16Px(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    viewBox: "0 0 16 16"
  }, props), _ref$1);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13 11h9v2h-9v9h-2v-9H2v-2h9V2h2z"
});

function Svg24Px(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    viewBox: "0 0 24 24"
  }, props), _ref$2);
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M3.56 8.5l5.147 5.146-.707.708L1.646 8 8 1.646l.707.708L3.561 7.5H15.5v1z"
});

function Svg16Px$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    viewBox: "0 0 16 16"
  }, props), _ref$3);
}

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M4.828 13l8.293 8.293-1.414 1.414L1 12 11.707 1.293l1.414 1.414L4.828 11H24v2z"
});

function Svg24Px$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    viewBox: "0 0 24 24"
  }, props), _ref$4);
}

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M12.793 7.5L7.646 2.354l.708-.708L14.707 8l-6.353 6.354-.708-.708L12.793 8.5H.5v-1z"
});

function Svg16Px$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    viewBox: "0 0 16 16"
  }, props), _ref$5);
}

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M19.586 13H0v-2h19.586l-8.293-8.293 1.414-1.414L23.414 12 12.707 22.707l-1.414-1.414z"
});

function Svg24Px$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    viewBox: "0 0 24 24"
  }, props), _ref$6);
}

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M1 7.5h14v-4A1.5 1.5 0 0013.5 2H13a.5.5 0 110-1h.5A2.5 2.5 0 0116 3.5v10a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 010 13.5v-10A2.5 2.5 0 012.5 1H3a.5.5 0 010 1h-.5A1.5 1.5 0 001 3.5v4zm0 1v5A1.5 1.5 0 002.5 15h11a1.5 1.5 0 001.5-1.5v-5H1zm10.496-5.938a2 2 0 11-.992 0A.505.505 0 0110.5 2.5v-2a.5.5 0 111 0v2a.505.505 0 01-.004.062zm-6 0a2 2 0 11-.992 0A.505.505 0 014.5 2.5v-2a.5.5 0 011 0v2a.505.505 0 01-.004.062zM7 2a.5.5 0 010-1h2a.5.5 0 010 1H7zM5 5.5a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2z"
});

function Svg16Px$3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    viewBox: "0 0 16 16"
  }, props), _ref$7);
}

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$8 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  id: "16px_svg__a",
  d: "M8 6.207l-4.646 4.647-.708-.708L8 4.793l5.354 5.353-.708.708z"
}));

var _ref2 = /*#__PURE__*/createElement("use", {
  transform: "matrix(1 0 0 -1 0 15.646)",
  xlinkHref: "#16px_svg__a"
});

function Svg16Px$4(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    viewBox: "0 0 16 16"
  }, props), _ref$8, _ref2);
}

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$9 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  id: "16px_svg__a",
  fill: "currentColor",
  d: "M8 6.437l-4.646 4.647-.708-.707L8 5.023l5.354 5.354-.708.707z"
}));

var _ref2$1 = /*#__PURE__*/createElement("use", {
  transform: "rotate(-90 8 8.054)",
  xlinkHref: "#16px_svg__a"
});

function Svg16Px$5(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    viewBox: "0 0 16 16"
  }, props), _ref$9, _ref2$1);
}

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$a = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  id: "16px_svg__a",
  fill: "currentColor",
  d: "M8 6.437l-4.646 4.647-.708-.707L8 5.023l5.354 5.354-.708.707z"
}));

var _ref2$2 = /*#__PURE__*/createElement("use", {
  transform: "scale(1 -1) rotate(90 16.054 0)",
  xlinkHref: "#16px_svg__a"
});

function Svg16Px$6(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    viewBox: "0 0 16 16"
  }, props), _ref$a, _ref2$2);
}

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$b = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8 6.207l-4.646 4.647-.708-.708L8 4.793l5.354 5.353-.708.708z"
});

function Svg16Px$7(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    viewBox: "0 0 16 16"
  }, props), _ref$b);
}

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$c = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8 7.293l5.646-5.647.708.708L8.707 8l5.647 5.646-.708.708L8 8.707l-5.646 5.647-.708-.708L7.293 8 1.646 2.354l.708-.708z"
});

function Svg16Px$8(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    viewBox: "0 0 16 16"
  }, props), _ref$c);
}

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$d = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M12 10.586l8.293-8.293 1.414 1.414L13.414 12l8.293 8.293-1.414 1.414L12 13.414l-8.293 8.293-1.414-1.414L10.586 12 2.293 3.707l1.414-1.414z"
});

function Svg24Px$3(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    viewBox: "0 0 24 24"
  }, props), _ref$d);
}

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$e = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M2.828 8L4 9.172 5.172 8H12V2H2v6h.828zM0 0h14v10H6l-2 2-2-2H0V0zm22 20v-6H9v6h8.828L19 21.172 20.172 20H22zm2-8v10h-3l-2 2-2-2H7V12h17zm-14 4v-1h9v1h-9zm0 2v-1h7v1h-7zM3 4V3h6.5v1H3zm0 2V5h4.5v1H3z"
});

function Svg24Px$4(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    viewBox: "0 0 24 24"
  }, props), _ref$e);
}

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$f = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M22 17.375l-7.128-5.346L12 14.12l-2.872-2.09L2 17.375V18h20v-.625zm0-1.25v-9.28l-6.281 4.569L22 16.125zm-20 0l6.281-4.711L2 6.846v9.279zM2 5.609l10 7.273 10-7.273V5H2v.609zM2 3h20a2 2 0 012 2v13a2 2 0 01-2 2H2a2 2 0 01-2-2V5a2 2 0 012-2z"
});

function Svg24Px$5(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    viewBox: "0 0 24 24"
  }, props), _ref$f);
}

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$g = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M7.979 7.044c.035-.106.044-.303-.02-.631-.082-.417-.222-1.099-.403-1.97l-.013-.063a745.133 745.133 0 00-.441-2.102 1.356 1.356 0 00-.075-.056c-.484-.34-1.153-.353-2.198.305-.2.134-.547.439-.899.898-.878 1.144-1.208 2.527-.671 4.26.028.103.09.316.192.625.173.525.392 1.12.66 1.77a32.794 32.794 0 003.04 5.704c2.334 3.501 5.87 5.6 9.061 6.173 1.521.274 3.222-.765 3.823-1.787.35-.596.388-.889.375-.899l-3.773-2.823c-.005.02-.03.054-.088.11l-1.96 1.633c-.086.073-.2.147-.343.21-.589.262-1.307.193-2.001-.307.073.053-.603-.42-.858-.611-.44-.33-.86-.682-1.29-1.092-1.124-1.075-2.18-2.433-3.167-4.177a26.113 26.113 0 01-.99-1.943A1.994 1.994 0 015.846 10a2.03 2.03 0 01-.034-1.004A1.68 1.68 0 016.6 7.91l1.379-.866zM9.7 8.075c-.142.253-.31.43-.512.57l-1.393.875a24.5 24.5 0 00.876 1.71c.89 1.573 1.826 2.775 2.81 3.715.367.352.726.653 1.106.937.223.168.876.625.826.59.029.02.048.035.06.047l1.735-1.444c.72-.705 1.557-.813 2.244-.475.147.072.262.152.283.175l3.847 2.876c1.17.82 1 2.132.177 3.533-.988 1.68-3.449 3.183-5.9 2.742-3.7-.666-7.717-3.05-10.373-7.033a34.78 34.78 0 01-3.225-6.052 28.441 28.441 0 01-.71-1.905 13.324 13.324 0 01-.214-.7c-.731-2.357-.244-4.4 1.006-6.029.5-.651 1.006-1.096 1.397-1.357C5.487-.252 7.03-.22 8.175.584c.318.223.537.456.668.644l.116.167.042.198a702.186 702.186 0 01.5 2.38l.013.062c.183.879.324 1.566.407 1.992.165.837.073 1.526-.221 2.048z"
});

function Svg24Px$6(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    viewBox: "0 0 24 24"
  }, props), _ref$g);
}

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$h = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8.5 9.293l4.146-4.147.708.708L8 11.207 2.646 5.854l.708-.708L7.5 9.293V0h1v9.293zM14 13v1H2v-3h1v2h10v-2h1v2z"
});

function Svg16Px$9(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    viewBox: "0 0 16 16"
  }, props), _ref$h);
}

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$i = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13.01 14h-1.907a.5.5 0 010-1H13.5c.019 0 .037.001.056.004.143-.315.275-.653.392-1.004H11.7a.5.5 0 010-1H14c.078 0 .153.019.219.05.083-.348.15-.7.198-1.05H11.7a.5.5 0 010-1h2.798l.002-.163a3.51 3.51 0 00-.165-1.103c-.11-.313-.251-.391-.486-.391H8.455l.065-.558c.33-2.841.33-4.563.085-4.915l-.02-.031c-.122-.178-.41-.682-.429-.71-.126-.198-.043-.185-.341.06-.296.242-.621.942-1.05 2.194.01-.025-.36 1.073-.46 1.352-.176.492-.32.828-.465 1.06-.34.567-.847 1.084-1.423 1.554v7.736h7.17c.483 0 .98-.422 1.422-1.085zm-9.593 1.085V7.726H1.5v7.359h1.917zm6.159-8.742h4.273c.627 0 1.163.304 1.43 1.062l.004.008c.141.424.217.902.217 1.424 0 3.193-1.723 7.248-3.914 7.248H.5V6.726h3.093c.572-.444 1.09-.946 1.394-1.453.102-.162.224-.447.377-.876.096-.267.461-1.354.455-1.337.5-1.46.858-2.232 1.362-2.645C7.945-.21 8.551-.11 9 .59c.039.06.318.548.412.687l.016.023c.426.614.451 2.225.149 5.043z"
});

function Svg16Px$a(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    viewBox: "0 0 16 16"
  }, props), _ref$i);
}

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$j = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13 15v-2h1v3H0V2h3v1H1v12h12zm.663-13.372H6.562v-1h8.985v8.985h-1V2.158l-8.744 8.744-.707-.707 8.567-8.567z"
});

function Svg16Px$b(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    viewBox: "0 0 16 16"
  }, props), _ref$j);
}

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$k = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M19 22v-3h2v5H0V3h5v2H2v17h17zm3.002-18.597L8.072 17.335 6.656 15.92l13.92-13.919H9.86v-2h14.142v14.142h-2V3.403z"
});

function Svg24Px$7(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    viewBox: "0 0 24 24"
  }, props), _ref$k);
}

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$l = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M32 62c16.569 0 30-13.431 30-30C62 15.431 48.569 2 32 2 15.431 2 2 15.431 2 32c0 16.569 13.431 30 30 30zm0 2C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32z"
});

var _ref2$3 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M25.067 18.667L44.267 32l-19.2 13.333z"
});

function Svg64Px(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    viewBox: "0 0 64 64"
  }, props), _ref$l, _ref2$3);
}

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$m = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13.617 0c.573 0 1.115.2 1.546.569l.14.129c.45.449.697 1.047.697 1.684 0 .573-.2 1.115-.569 1.546l-.129.14L5.09 14.28a.415.415 0 01-.094.07l-.053.023-4.406 1.602a.4.4 0 01-.533-.438l.02-.074 1.602-4.406a.4.4 0 01.055-.102l.038-.045L11.932.698A2.367 2.367 0 0113.617 0zm-2.403 2.549l-8.865 8.865L1.07 14.93l3.516-1.279 8.865-8.865-2.237-2.237zM13.616.8c-.422 0-.82.164-1.118.463l-.718.718 2.238 2.237.717-.718c.298-.3.462-.697.462-1.119 0-.422-.164-.82-.463-1.118A1.571 1.571 0 0013.616.8z"
});

function Svg16Px$c(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    viewBox: "0 0 16 16"
  }, props), _ref$m);
}

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$n = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13.43 8.168l.09.003a.5.5 0 01.436.556A5.99 5.99 0 013 11.295v.872a.5.5 0 11-1 0V10.5c0-.644.523-1.166 1.167-1.166h1.666a.5.5 0 110 1H3.588a4.994 4.994 0 009.376-1.727.504.504 0 01.556-.436zm-6.806-6.01A5.99 5.99 0 0113 4.706v-.872a.5.5 0 011 0V5.5c0 .644-.523 1.166-1.167 1.167h-1.666a.5.5 0 110-1h1.245a4.994 4.994 0 00-9.376 1.727.5.5 0 11-.992-.12 5.99 5.99 0 014.58-5.116z"
});

function Svg16Px$d(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    viewBox: "0 0 16 16"
  }, props), _ref$n);
}

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$o = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.5 2.914l4.146 4.147.708-.707L8 1 2.646 6.354l.708.707L7.5 2.914V12h1V2.914zM14 14v1H2v-3h1v2h10v-2h1v2z"
});

function Svg16Px$e(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    viewBox: "0 0 16 16"
  }, props), _ref$o);
}

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$p = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M22.088 32V19.639h4.146l.665-5.046h-4.811v-3.507c0-.98.794-1.773 1.773-1.773h3.117V4.774h-4.355a5.581 5.581 0 00-5.581 5.581v4.238h-4.166v5.046h4.166V32H2a2 2 0 01-2-2V2a2 2 0 012-2h28a2 2 0 012 2v28a2 2 0 01-2 2h-7.912z"
});

function SvgFacebook(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    viewBox: "0 0 32 32"
  }, props), _ref$p);
}

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$q = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M2 0h28a2 2 0 012 2v28a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2.24 23.72a13.703 13.703 0 007.363 2.134c7.608 0 13.775-6.168 13.775-13.776 0-.19-.004-.378-.01-.566.274-.217 1.976-1.581 2.393-2.458 0 0-1.382.574-2.734.71h-.009l.007-.004c.125-.083 1.867-1.27 2.103-2.683 0 0-.977.522-2.346.978-.227.076-.464.149-.709.219a4.832 4.832 0 00-8.236 4.396c-.373-.015-6.056-.334-9.92-5.015 0 0-2.31 3.154 1.376 6.397 0 0-1.12-.045-2.088-.622 0 0-.355 3.82 3.82 4.798 0 0-.822.31-2.132.089 0 0 .733 3.087 4.443 3.376 0 0-2.934 2.649-7.098 2.028h.001z"
});

function SvgTwitter(props) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    viewBox: "0 0 32 32"
  }, props), _ref$q);
}

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$r = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M2 0h28a2 2 0 012 2v28a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm5.531 4.86c-1.483 0-2.697 1.201-2.697 2.674 0 1.52 1.253 2.711 2.68 2.681 1.405.034 2.684-1.128 2.688-2.67a2.69 2.69 0 00-2.67-2.685zm1.557 22.277c.407 0 .738-.33.738-.737V13.003a.739.739 0 00-.738-.738h-3.14a.738.738 0 00-.738.738v13.396c0 .408.33.738.738.738h3.14zM27.166 16.97a5.085 5.085 0 00-5.085-5.085h-.806a4.513 4.513 0 00-3.957 2.336.257.257 0 00-.042-.005v-1.644a.307.307 0 00-.307-.307h-3.917a.307.307 0 00-.307.307V26.83c0 .17.137.307.306.307h4.004a.306.306 0 00.306-.305v-8.238c0-1.424 1.136-2.606 2.56-2.623a2.577 2.577 0 011.86.759 2.58 2.58 0 01.759 1.83v8.273c0 .169.137.306.306.306h4.013a.307.307 0 00.307-.305V16.97z"
});

function SvgLinkedIn(props) {
  return /*#__PURE__*/createElement("svg", _extends$s({
    viewBox: "0 0 32 32"
  }, props), _ref$r);
}

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$s = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M2 0h28a2 2 0 012 2v28a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm19.338 6.67h-1.174v4.699c0 .04.004.09-.017.117-.152.192-.33.353-.564.434-.191.066-.34-.027-.374-.227a1.103 1.103 0 01-.017-.191V6.67h-1.165v5.418c0 .158.03.32.076.473.14.455.514.593.953.507.286-.055.53-.198.746-.387.122-.108.233-.227.363-.355l-.001.68h1.174V6.67zm-5.493 4.879a.485.485 0 01-.97 0V8.126a.486.486 0 01.97 0v3.423zm-.485-5.037a1.68 1.68 0 00-1.682 1.68v3.29a1.682 1.682 0 003.363 0v-3.29a1.68 1.68 0 00-1.68-1.68zm-3.733 1.26c-.256-1.075-.79-3.344-.79-3.344H9.503s1.025 3.405 1.484 4.923a.587.587 0 01.025.172v3.482h1.232V9.523c0-.057.006-.117.024-.171l1.485-4.924h-1.337s-.533 2.269-.788 3.343zm11.101 6.998a314.43 314.43 0 00-13.457 0 2.862 2.862 0 00-2.8 2.862v7.005a2.862 2.862 0 002.8 2.862c4.486.097 8.972.097 13.457 0a2.862 2.862 0 002.801-2.862v-7.005a2.862 2.862 0 00-2.8-2.862zm1.084 9.659c-.199.582-.61.905-1.212.994-.374.055-.744.047-1.094-.112-.48-.216-.752-.608-.868-1.106a3.339 3.339 0 01-.084-.712c-.009-.934-.004-1.87-.003-2.804.001-.49.118-.94.453-1.314.381-.428.87-.588 1.428-.552.168.01.34.038.5.09.542.18.832.586.946 1.125.043.208.06.424.063.636.01.499-.004 1.598-.004 1.598H21.74v1.575a.512.512 0 101.023 0v-.81h1.181s.017.956-.132 1.392zm-4.238.24c-.153.46-.49.695-.975.69a1.29 1.29 0 01-.976-.446l-.11-.118v.48h-1.149v-8.536h1.148v2.81s.064-.13.123-.196c.178-.2.394-.353.661-.42.441-.111.948.026 1.19.54.142.304.182.629.182.959.002 1.193.002 2.386.001 3.579a2.101 2.101 0 01-.095.658zm-4.357-2.43v3.037h-1.145v-.694a2.823 2.823 0 00-.086.093c-.247.277-.526.51-.883.633a1.087 1.087 0 01-.537.048.66.66 0 01-.518-.414 1.572 1.572 0 01-.119-.66c-.003-.836-.002-5.257-.002-5.3h1.143c.002.038.006 3.212.007 4.76 0 .085 0 .17.017.253.042.208.202.298.402.225.23-.085.406-.243.554-.434.021-.027.021-.076.021-.116v-4.695l1.146-.003v3.268zm-4.628 3.037H9.295v-7.313H7.956V16.74h3.974v1.22h-1.34v7.316zm12.174-4.865a.511.511 0 00-1.023 0v.884h1.023v-.884zm-4.278.073a1.023 1.023 0 00-.08-.355c-.059-.146-.186-.22-.344-.234-.186-.02-.335.056-.47.175a.316.316 0 00-.079.118l.003 3.79v.092l.037.05c.11.118.238.213.401.246.27.056.46-.056.513-.306a.949.949 0 00.021-.192c.001-1.128.003-2.256-.002-3.384z"
});

function SvgYoutube(props) {
  return /*#__PURE__*/createElement("svg", _extends$t({
    viewBox: "0 0 32 32"
  }, props), _ref$s);
}

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$t = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M21 30v2l-2.5-1-2.5 1v-2H7.75C6.231 30 5 28.81 5 27.342V2.658C5 1.19 6.231 0 7.75 0h16.5C25.769 0 27 1.19 27 2.658v24.684C27 28.81 25.769 30 24.25 30H21zm0-2h3c.667 0 1-.333 1-1V3c.011-.667-.322-1-1-1H8c-.667.01-1 .343-1 1v24c-.023.667.31 1 1 1h8v-2.877a4 4 0 115 0V28zm-4-2.29v4.889L18.5 30l1.5.599v-4.89a3.98 3.98 0 01-1.5.291 4 4 0 01-1.5-.29zM10 7a.5.5 0 010-1h12a.5.5 0 110 1H10zm0 3a.5.5 0 010-1h12a.5.5 0 110 1H10zm0 3a.5.5 0 110-1h12a.5.5 0 110 1H10zm8.5 12a3 3 0 100-6 3 3 0 000 6z",
  fillRule: "evenodd"
});

function Svg32Px(props) {
  return /*#__PURE__*/createElement("svg", _extends$u({
    viewBox: "0 0 32 32"
  }, props), _ref$t);
}

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$u = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M7 9h12v7H7v11.273c0 .398.332.727.75.727h16.5a.74.74 0 00.75-.727V7.523h-5.864V2H7.75a.74.74 0 00-.75.727V9zM5 9V2.727C5 1.221 6.231 0 7.75 0h12.886L27 6v21.273C27 28.779 25.769 30 24.25 30H7.75C6.231 30 5 28.779 5 27.273V16H4V9h1zm19.64-2.477l-4.504-4.246v4.246h4.503zM5 10v5h13v-5H5z"
});

function Svg32Px$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$v({
    viewBox: "0 0 32 32"
  }, props), _ref$u);
}

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$v = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M10 7a.5.5 0 010-1h12a.5.5 0 110 1H10zm0 3a.5.5 0 010-1h12a.5.5 0 110 1H10zm0 3a.5.5 0 110-1h12a.5.5 0 110 1H10zm0 3a.5.5 0 110-1h12a.5.5 0 110 1H10zm0 3a.5.5 0 110-1h12a.5.5 0 110 1H10zm0 3a.5.5 0 110-1h8a.5.5 0 110 1h-8zm5.833 6h8.417c.43 0 .75-.31.75-.658V2.658C25 2.31 24.68 2 24.25 2H7.75c-.43 0-.75.31-.75.658v24.684c0 .348.32.658.75.658h8.083zm8.417 2H7.75C6.231 30 5 28.81 5 27.342V2.658C5 1.19 6.231 0 7.75 0h16.5C25.769 0 27 1.19 27 2.658v24.684C27 28.81 25.769 30 24.25 30z"
});

function Svg32Px$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$w({
    viewBox: "0 0 32 32"
  }, props), _ref$v);
}

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$w = /*#__PURE__*/createElement("path", {
  d: "M15.506 17.785l-.428-4.36V11.41h1.781v2.016l-.422 4.36h-.931zM15.148 20v-1.646h1.647V20h-1.647zm-6.53 2h14.764L16 7.236 8.618 22zm8.276-17.447l9 18A1 1 0 0125 24H7a1 1 0 01-.894-1.447l9-18a1 1 0 011.788 0z",
  fill: "currentColor"
});

function Svg32Px$3(props) {
  return /*#__PURE__*/createElement("svg", _extends$x({
    viewBox: "0 0 32 32"
  }, props), _ref$w);
}

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$x = /*#__PURE__*/createElement("path", {
  d: "M16 20.571a4.571 4.571 0 110-9.142 4.571 4.571 0 010 9.142zm0-2a2.571 2.571 0 100-5.142 2.571 2.571 0 000 5.142z",
  fill: "currentColor"
});

var _ref2$4 = /*#__PURE__*/createElement("path", {
  d: "M16 26.667C10.109 26.667 5.333 21.89 5.333 16S10.11 5.333 16 5.333 26.667 10.11 26.667 16 21.89 26.667 16 26.667zm0-2a8.667 8.667 0 100-17.334 8.667 8.667 0 000 17.334z",
  fillOpacity: 0.25,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/createElement("path", {
  d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z",
  fillOpacity: 0.25,
  fill: "currentColor"
});

function Svg32Px$4(props) {
  return /*#__PURE__*/createElement("svg", _extends$y({
    viewBox: "0 0 32 32"
  }, props), _ref$x, _ref2$4, _ref3);
}

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$y = /*#__PURE__*/createElement("path", {
  d: "M15.408 18.911a1.4 1.4 0 11.984 0A.503.503 0 0116.4 19v1.2a.5.5 0 11-1 0V19c0-.03.003-.06.008-.089zM11 15v7h10v-7H11zm8.108-1v-3.156C19.108 9.3 17.74 8 16 8s-3.108 1.299-3.108 2.844V14h6.216zm-8.813-1.244h.597v-1.912C10.892 8.172 13.177 6 16 6c2.823 0 5.108 2.172 5.108 4.844v1.912h.597c.707 0 1.295.547 1.295 1.21v8.817c0 .664-.588 1.217-1.295 1.217h-11.41C9.588 24 9 23.447 9 22.783v-8.816c0-.664.588-1.211 1.295-1.211z",
  fill: "currentColor"
});

function Svg32Px$5(props) {
  return /*#__PURE__*/createElement("svg", _extends$z({
    viewBox: "0 0 32 32"
  }, props), _ref$y);
}

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$z = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13.462 18.046l7.458-7.463 1.414 1.414-8.834 8.84-.037-.038-.038.038-4.84-4.84L10 14.584l3.462 3.463z"
});

function Svg32Px$6(props) {
  return /*#__PURE__*/createElement("svg", _extends$A({
    viewBox: "0 0 32 32"
  }, props), _ref$z);
}

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$A = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M19.955 10.586L21.369 12l-3.977 3.978 3.977 3.977-1.414 1.414-3.977-3.977L12 21.369l-1.414-1.414 3.978-3.977L10.586 12 12 10.586l3.978 3.978 3.977-3.978z"
});

function Svg32Px$7(props) {
  return /*#__PURE__*/createElement("svg", _extends$B({
    viewBox: "0 0 32 32"
  }, props), _ref$A);
}

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var _ref$B = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M6 11.293l8-8 .707.707L6 12.707 1.293 8 2 7.293z"
});

function Svg16Px$f(props) {
  return /*#__PURE__*/createElement("svg", _extends$C({
    viewBox: "0 0 16 16"
  }, props), _ref$B);
}

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var _ref$C = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M6.731 9.023l3.729-3.731.707.707-4.417 4.42-.019-.02-.019.02-2.42-2.42L5 7.292l1.731 1.73zM8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 118 0a8 8 0 010 16z",
  fillRule: "evenodd"
});

function Svg16Px$g(props) {
  return /*#__PURE__*/createElement("svg", _extends$D({
    viewBox: "0 0 16 16"
  }, props), _ref$C);
}

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var _ref$D = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0 2C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-2.538-13.954l7.458-7.463 1.414 1.414-8.834 8.84-.037-.038-.038.038-4.84-4.84L10 14.584l3.462 3.463z"
});

function Svg32Px$8(props) {
  return /*#__PURE__*/createElement("svg", _extends$E({
    viewBox: "0 0 32 32"
  }, props), _ref$D);
}

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var _ref$E = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8 16A8 8 0 118 0a8 8 0 010 16zM6.731 9.023L5 7.292l-.707.707 2.42 2.42.018-.02.02.02 4.416-4.42-.707-.707-3.729 3.73z",
  fillRule: "evenodd"
});

function Svg16Px$h(props) {
  return /*#__PURE__*/createElement("svg", _extends$F({
    viewBox: "0 0 16 16"
  }, props), _ref$E);
}

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var _ref$F = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-2.538-13.954L10 14.583l-1.414 1.415 4.839 4.839.038-.038.037.038 8.834-8.84-1.414-1.414-7.458 7.463z",
  fillRule: "evenodd"
});

function Svg32Px$9(props) {
  return /*#__PURE__*/createElement("svg", _extends$G({
    viewBox: "0 0 32 32"
  }, props), _ref$F);
}

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var _ref$G = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M7.989 7.282l1.988-1.99.708.708-1.99 1.989 1.99 1.988-.708.708-1.988-1.99L6 10.686l-.707-.708L7.282 7.99 5.292 6 6 5.293l1.989 1.989zM8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 118 0a8 8 0 010 16z",
  fillRule: "evenodd"
});

function Svg16Px$i(props) {
  return /*#__PURE__*/createElement("svg", _extends$H({
    viewBox: "0 0 16 16"
  }, props), _ref$G);
}

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var _ref$H = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M15.977 14.563l3.978-3.977L21.369 12l-3.977 3.977 3.977 3.978-1.414 1.414-3.978-3.977L12 21.369l-1.414-1.414 3.977-3.978L10.586 12 12 10.586l3.977 3.977zM16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0 2C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16z",
  fillRule: "evenodd"
});

function Svg32Px$a(props) {
  return /*#__PURE__*/createElement("svg", _extends$I({
    viewBox: "0 0 32 32"
  }, props), _ref$H);
}

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var _ref$I = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M7.989 7.282L6 5.292 5.293 6l1.989 1.989-1.99 1.988.708.708 1.989-1.99 1.988 1.99.708-.708-1.99-1.988L10.686 6l-.708-.707L7.99 7.282zM8 16A8 8 0 118 0a8 8 0 010 16z",
  fillRule: "evenodd"
});

function Svg16Px$j(props) {
  return /*#__PURE__*/createElement("svg", _extends$J({
    viewBox: "0 0 16 16"
  }, props), _ref$I);
}

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var _ref$J = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-.023-17.437L12 10.586 10.586 12l3.977 3.977-3.977 3.978L12 21.369l3.977-3.977 3.978 3.977 1.414-1.414-3.977-3.978L21.369 12l-1.414-1.414-3.978 3.977z",
  fillRule: "evenodd"
});

function Svg32Px$b(props) {
  return /*#__PURE__*/createElement("svg", _extends$K({
    viewBox: "0 0 32 32"
  }, props), _ref$J);
}

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var _ref$K = /*#__PURE__*/createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "currentColor"
});

var _ref2$5 = /*#__PURE__*/createElement("path", {
  fill: "#FFF",
  d: "M9 9.7v-.4l.2-.4.3-.4.7-.6.5-.6.2-.5a2.5 2.5 0 00-.1-1.7 2.1 2.1 0 00-.6-.7l-.8-.5-1-.1c-1 0-1.6.2-2.2.7-.5.4-.8 1-.9 1.9l1.9.1c0-.3 0-.5.3-.7.2-.3.5-.4.8-.4.3 0 .5.1.7.3l.2.6a.7.7 0 01-.1.4 2.3 2.3 0 01-.3.4 7 7 0 01-.5.4l-.6.6c-.2.1-.3.3-.3.5a1.7 1.7 0 00-.1.6v.5H9zm-.8 2.9a1.1 1.1 0 00.7-.3 1.1 1.1 0 00.4-.8 1.1 1.1 0 00-.4-.8 1.1 1.1 0 00-.7-.3 1.1 1.1 0 00-.8.3 1.1 1.1 0 00-.3.8 1.1 1.1 0 00.3.8 1.1 1.1 0 00.8.3z"
});

function Svg16Px$k(props) {
  return /*#__PURE__*/createElement("svg", _extends$L({
    viewBox: "0 0 16 16"
  }, props), _ref$K, _ref2$5);
}

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var _ref$L = /*#__PURE__*/createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "currentColor"
});

var _ref2$6 = /*#__PURE__*/createElement("path", {
  fill: "#FFF",
  d: "M18.1 19.4v-.7c0-.3 0-.6.2-.8.1-.3.4-.6.7-.9a15.5 15.5 0 001.5-1.2l.9-1.1.5-1.1a5.1 5.1 0 00-.3-3.3 4.3 4.3 0 00-1.2-1.5l-1.7-1a7 7 0 00-2-.2c-1.8 0-3.1.4-4.2 1.3a6 6 0 00-1.9 3.9l3.7.2a2.4 2.4 0 01.7-1.5c.4-.4 1-.6 1.7-.6.5 0 .9.1 1.2.4.4.3.5.7.5 1.3 0 .2 0 .5-.2.7a4.7 4.7 0 01-.6.8l-1 1-1.2 1-.7 1-.2 1.2v1h3.6zM16.3 25a2.2 2.2 0 001.6-.6l.5-.7a2.2 2.2 0 000-1.7 2.1 2.1 0 00-.5-.7l-.7-.5a2.2 2.2 0 00-.9-.2c-.3 0-.6 0-.9.2a2.1 2.1 0 00-.7.5l-.4.7a2.2 2.2 0 000 1.7 2.1 2.1 0 002 1.3z"
});

function Svg32Px$c(props) {
  return /*#__PURE__*/createElement("svg", _extends$M({
    viewBox: "0 0 32 32"
  }, props), _ref$L, _ref2$6);
}

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var _ref$M = /*#__PURE__*/createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "currentColor"
});

var _ref2$7 = /*#__PURE__*/createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2,
  d: "M6 5v6m4-6v6"
});

function Svg16Px$l(props) {
  return /*#__PURE__*/createElement("svg", _extends$N({
    viewBox: "0 0 16 16"
  }, props), _ref$M, _ref2$7);
}

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var _ref$N = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "currentColor",
  transform: "translate(0 .5)"
}), /*#__PURE__*/createElement("g", {
  transform: "translate(6 3.5)"
}, /*#__PURE__*/createElement("circle", {
  cx: 2,
  cy: 9,
  r: 1.5,
  fill: "#FFF"
}), /*#__PURE__*/createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M2 .5v5"
})));

function Svg16Px$m(props) {
  return /*#__PURE__*/createElement("svg", _extends$O({
    viewBox: "0 0 16 16"
  }, props), _ref$N);
}

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var _ref$O = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "currentColor"
}), /*#__PURE__*/createElement("circle", {
  cx: 16,
  cy: 23.001,
  r: 2.001,
  fill: "#FFF"
}), /*#__PURE__*/createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M16.001 7v10"
}));

function Svg32Px$d(props) {
  return /*#__PURE__*/createElement("svg", _extends$P({
    viewBox: "0 0 32 32"
  }, props), _ref$O);
}

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var _ref$P = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M3.2 13.9l9.418 7.064L16 18.505l3.383 2.46h-.001l9.665-7.25a1.48 1.48 0 00-.516-.705c-.244-.191-4.388-3.71-12.431-10.557-.326.285-11.846 10.179-12.323 10.553-.315.248-.496.516-.576.895zm-.046 1.215c.003 1.653.002 5.898-.002 12.734l8.62-6.27-8.618-6.464zm25.994-.226l-8.92 6.69 8.848 6.436.072-13.126zM3.196 29.053c.057.264.162.464.297.596.22.216.595.351 1.134.351h22.97c.535 0 .922-.142 1.134-.35.118-.116.208-.264.266-.456L16 19.74 3.196 29.053zm26.57-17.617c.941.743 1.385 1.743 1.385 3.026a7299.28 7299.28 0 00-.078 14.128c0 1.025-.314 1.872-.94 2.487-.602.59-1.49.923-2.536.923H4.627c-1.02 0-1.908-.308-2.535-.923-.6-.59-.94-1.462-.94-2.487.017-7.111.017-11.82 0-14.128 0-1.308.444-2.283 1.384-3.026C2.928 11.128 14.714 1 15.576.256c.157-.128.34-.23.523-.256h.105c.183.026.365.128.522.256.863.744 12.722 10.93 13.04 11.18z"
});

function Svg32Px$e(props) {
  return /*#__PURE__*/createElement("svg", _extends$Q({
    viewBox: "0 0 32 32"
  }, props), _ref$P);
}

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var _ref$Q = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M30 9H2v8h28V9zM10 7V5a2 2 0 012-2h8a2 2 0 012 2v2h8a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V9a2 2 0 012-2h8zm2 0h8V5h-8v2zM2 18v9h28v-9h-3v5a1 1 0 01-1 1h-8a1 1 0 01-1-1v-5h-2v5a1 1 0 01-1 1H6a1 1 0 01-1-1v-5H2zm12 0H6v5h8v-5zm12 0h-8v5h8v-5z"
});

function Svg32Px$f(props) {
  return /*#__PURE__*/createElement("svg", _extends$R({
    viewBox: "0 0 32 32"
  }, props), _ref$Q);
}

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var _ref$R = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M14 8H2v3h28V8H18v2h-4V8zm0-2V4h4v2h12a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V8a2 2 0 012-2h12zM2 12v14h2.534a.499.499 0 01-.034-.182 5.5 5.5 0 0111 0 .499.499 0 01-.034.182H30V12H2zm3.466 14h9.068a.499.499 0 01-.034-.182 4.5 4.5 0 10-9 0 .499.499 0 01-.034.182zM10 18.455A1.727 1.727 0 1010 15a1.727 1.727 0 000 3.455zm0 1A2.727 2.727 0 1110 14a2.727 2.727 0 010 5.455zM15 5v4h2V5h-2zm2.391 10.757a.5.5 0 010-1h8a.5.5 0 010 1h-8zm0 3a.5.5 0 010-1h8a.5.5 0 010 1h-8zm0 3a.5.5 0 010-1h5a.5.5 0 010 1h-5z"
});

function Svg32Px$g(props) {
  return /*#__PURE__*/createElement("svg", _extends$S({
    viewBox: "0 0 32 32"
  }, props), _ref$R);
}

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var _ref$S = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M30 24.828l-9.974-8.16L16 19.62l-4.026-2.953L2 24.827V26h28v-1.172zm0-1.292V9.353l-9.141 6.704L30 23.536zm-28 0l9.141-7.48L2 9.354v14.183zM2 8.113L16 18.38 30 8.113V7H2v1.113zM2 5h28a2 2 0 012 2v19a2 2 0 01-2 2H2a2 2 0 01-2-2V7a2 2 0 012-2z"
});

function Svg32Px$h(props) {
  return /*#__PURE__*/createElement("svg", _extends$T({
    viewBox: "0 0 32 32"
  }, props), _ref$S);
}

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var _ref$T = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm0 30c-3.6 0-6.9-1.4-9.4-3.6 1.7-3.5 5.4-5.9 9.4-5.9 4.1 0 7.7 2.3 9.4 5.9-2.5 2.2-5.8 3.6-9.4 3.6zm10.2-4.4c-2-3.7-5.8-6.1-10.2-6.1-4.3 0-8.2 2.4-10.2 6.1C3.5 23.1 2 19.7 2 16 2 8.3 8.3 2 16 2s14 6.3 14 14c0 3.7-1.5 7.1-3.8 9.6z"
});

var _ref2$8 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M16 5c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 11c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
});

function Svg32Px$i(props) {
  return /*#__PURE__*/createElement("svg", _extends$U({
    viewBox: "0 0 32 32"
  }, props), _ref$T, _ref2$8);
}

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var _ref$U = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M15.302 23.956a2.8 2.8 0 11.996 0L16.3 24v3a.5.5 0 11-1 0v-3c0-.015 0-.03.002-.044zM8.5 14.5h14.998V9.689C23.5 5.438 20.136 2 16 2S8.5 5.438 8.5 9.689V14.5zm0 1v.011H5.405a.438.438 0 00-.418.422v13.634c0 .225.206.433.418.433h21.19c.212 0 .418-.208.418-.433V15.933c0-.22-.2-.422-.418-.422H23.5V15.5H8.501zm18.094-1.989c1.316 0 2.405 1.099 2.405 2.422v13.634C29 30.885 27.917 32 26.595 32H5.405C4.083 32 3 30.885 3 29.567V15.933c0-1.323 1.089-2.422 2.405-2.422h1.109V9.69C6.514 4.345 10.755 0 16 0c5.245 0 9.486 4.345 9.486 9.689v3.822h1.11zM15.8 23a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z"
});

function Svg32Px$j(props) {
  return /*#__PURE__*/createElement("svg", _extends$V({
    viewBox: "0 0 32 32"
  }, props), _ref$U);
}

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var _ref$V = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M21 23.71v4.889L22.5 28l1.5.599v-4.89a3.98 3.98 0 01-1.5.291 4 4 0 01-1.5-.29zm-1-.587a4 4 0 115 0V24h5V6H2v18h18v-.877zM25 26v4l-2.5-1-2.5 1v-4H2a2 2 0 01-2-2V6a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2h-5zm-2.5-3a3 3 0 100-6 3 3 0 000 6zM5.333 10.5a.5.5 0 110-1h19a.5.5 0 110 1h-19zm0 3a.5.5 0 110-1h19a.5.5 0 110 1h-19zm0 3a.5.5 0 110-1H16a.5.5 0 110 1H5.333z"
});

function Svg32Px$k(props) {
  return /*#__PURE__*/createElement("svg", _extends$W({
    viewBox: "0 0 32 32"
  }, props), _ref$V);
}

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var _ref$W = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M10.5 30v-8h11v8H26V2H6v28h4.5zM4 30V2a2 2 0 012-2h20a2 2 0 012 2v28h3a1 1 0 010 2H1a1 1 0 010-2h3zm11.5 1v-8h-4v8h4zm1 0h4v-8h-4v8zM8.7 11c-.42 0-.7-.24-.7-.6V5.6c0-.36.28-.6.7-.6h5.6c.42 0 .7.24.7.6v4.8c0 .36-.28.6-.7.6H8.7zm5.3-1V6H9v4h5zm3.7 1c-.42 0-.7-.24-.7-.6V5.6c0-.36.28-.6.7-.6h5.6c.42 0 .7.24.7.6v4.8c0 .36-.28.6-.7.6h-5.6zm5.3-1V6h-5v4h5zm-8.7 9H8.7c-.42 0-.7-.24-.7-.6v-4.8c0-.36.28-.6.7-.6h5.6c.42 0 .7.24.7.6v4.8c0 .36-.28.6-.7.6zm-.3-5H9v4h5v-4zm3.7 5c-.42 0-.7-.24-.7-.6v-4.8c0-.36.28-.6.7-.6h5.6c.42 0 .7.24.7.6v4.8c0 .36-.28.6-.7.6h-5.6zm5.3-1v-4h-5v4h5z"
});

function Svg32Px$l(props) {
  return /*#__PURE__*/createElement("svg", _extends$X({
    viewBox: "0 0 32 32"
  }, props), _ref$W);
}

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var _ref$X = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8 26h17V5H8v21zm0 1v3h17v-3H8zM8 4h17V2H8v2zm0-4h17a2 2 0 012 2v28a2 2 0 01-2 2H8a2 2 0 01-2-2V2a2 2 0 012-2zm7 29a.5.5 0 110-1h3a.5.5 0 110 1h-3zm-4.118-11.177a.5.5 0 11-.764-.646l8.457-10a.5.5 0 11.764.646l-8.457 10zm0-5a.5.5 0 11-.764-.646l3.875-4.581a.5.5 0 01.763.646l-3.874 4.58z"
});

function Svg32Px$m(props) {
  return /*#__PURE__*/createElement("svg", _extends$Y({
    viewBox: "0 0 32 32"
  }, props), _ref$X);
}

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var _ref$Y = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M11.274 43.93c-2.263 5.129-1.511 8.877 2.27 11.41l8.51-3.851c-5.715-3.67-8.163-8.746-7.338-15.162l-3.443 7.603h.001zm-2.268 5.007L4.191 59.57l8.297-3.754c-2.378-1.775-3.54-4.08-3.482-6.88zm8-17.667c-3.177 8.811-1.132 15.337 6.143 19.723l12.903-5.839c-3.386-.836-7.312-3.149-10.793-6.63-3.491-3.49-5.808-7.43-6.637-10.823l-1.617 3.57zm3.721-8.258a1.012 1.012 0 01-.059.168l-.2.441c-.925 2.944 1.32 8.604 6.205 13.49 4.815 4.814 10.38 7.064 13.359 6.243l.966-.438a2.58 2.58 0 00.368-.305c2.29-2.29.179-9.014-5.5-14.693-5.68-5.68-12.404-7.79-14.693-5.5a2.667 2.667 0 00-.446.594zm21.91 21.151c-.1.2-.266.369-.485.468l-.611.276a5.924 5.924 0 01-.292.133L.104 63.658l18.713-41.33c.031-.069.069-.131.112-.189.219-.42.495-.801.83-1.136 3.319-3.32 11.164-.857 17.521 5.5 6.357 6.358 8.82 14.203 5.5 17.522a4.527 4.527 0 01-.144.138zM35.523.565a1 1 0 011.56 1.252c-.558.695-.855 1.296-.953 1.843-.145.81.046 1.377.898 3.008.882 1.688 1.24 2.667 1.284 4.056.039 1.244-.401 2.036-1.472 3.237l-.324.362c-1.223 1.385-1.49 2.303-.765 4.293a1 1 0 01-1.88.683c-1.003-2.756-.523-4.41 1.146-6.3.077-.087.344-.384.33-.37.756-.846.984-1.258.966-1.842-.032-1.004-.307-1.755-1.058-3.193-1.058-2.027-1.345-2.879-1.094-4.285.161-.902.606-1.803 1.362-2.744zM62.62 32.702a1 1 0 01-1.808.854c-1.03-2.182-3.024-3.733-5.175-4.054-1.515-.227-2.482.41-4.587 2.729-1.076 1.185-2.396 1.552-3.746 1.25a5.237 5.237 0 01-2.113-1.032 1 1 0 011.246-1.565c.346.276.81.535 1.302.645.674.15 1.257-.01 1.83-.642 2.534-2.791 3.951-3.724 6.363-3.363 2.83.422 5.38 2.407 6.688 5.178zm-6.4-19.16a1 1 0 011.459 1.37c-1.76 1.873-3.493 1.89-8.198.952a61.868 61.868 0 00-1.454-.277c-3.424-.602-5.058.98-5.418 5.087a1 1 0 01-1.992-.174c.453-5.185 3.06-7.709 7.756-6.883.433.076.827.152 1.499.286 3.976.792 5.278.78 6.349-.36zm-8.861 9.472a1.5 1.5 0 102.988.261 1.5 1.5 0 00-2.988-.261zm-.996-.087a2.5 2.5 0 114.98.435 2.5 2.5 0 01-4.98-.435zm-.36-14.58a1.5 1.5 0 102.989.262 1.5 1.5 0 00-2.989-.261zm-.996-.087a2.5 2.5 0 114.981.436 2.5 2.5 0 01-4.98-.436zM26.391 12.4a1.5 1.5 0 102.988.261 1.5 1.5 0 00-2.988-.261zm-.996-.087a2.5 2.5 0 114.98.435 2.5 2.5 0 01-4.98-.435z"
});

function Svg64Px$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$Z({
    viewBox: "0 0 64 64"
  }, props), _ref$Y);
}

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var _ref$Z = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M14.45 6.775L13 7.5v3.656l-.088.128C11.892 12.764 10.235 13.5 8 13.5s-3.892-.736-4.912-2.216L3 11.156v-3.59L.36 6.281a.2.2 0 01-.004-.358l7.419-3.807a.5.5 0 01.452-.003l7.415 3.708a.2.2 0 010 .358l-.68.34v3.424l.958 1.456.039.175c-.116.754-.548 1.17-1.247 1.176-.705 0-1.142-.416-1.26-1.176l.04-.175.958-1.456V6.775zM12 8L8.22 9.89a.5.5 0 01-.442.002L4 8.052v2.787c.825 1.105 2.14 1.661 4 1.661 1.86 0 3.175-.556 4-1.66V8zM8.006 3.121l-5.77 2.961 5.758 2.803L13.764 6 8.006 3.121zm5.958 8.47c.093.46.328.659.746.659.413-.003.645-.203.738-.66l-.742-1.127-.742 1.128z"
});

function Svg16Px$n(props) {
  return /*#__PURE__*/createElement("svg", _extends$_({
    viewBox: "0 0 16 16"
  }, props), _ref$Z);
}

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var _ref$_ = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13.06 1H3.5c-.393 0-.502.109-.5.5v10h6a.5.5 0 110 1H1.015c.09 1.399.582 2 1.485 2H9a.5.5 0 110 1H2.5C.838 15.5 0 14.244 0 12v-.5h2V1.502C1.996.558 2.554 0 3.5 0h11c.943 0 1.5.557 1.5 1.5v.667h-1V1.5c0-.391-.11-.5-.5-.5h-.003c-.388 0-.497.11-.497.5v1.472c.714-.09 1-.402 1-.972h1v.167h-.005c-.067 1.065-.782 1.68-1.995 1.808V5a.5.5 0 11-1 0V1.5c0-.181.02-.348.06-.5zM12 11.83V14l1-1 1 1v-2.17a2.995 2.995 0 01-2 0zm-1-.594a3 3 0 114 0V16l-2-1.92L11 16v-4.764zM13 11a2 2 0 100-4 2 2 0 000 4zM5 3.5a.5.5 0 110-1h6a.5.5 0 110 1H5zm0 3a.5.5 0 110-1h4a.5.5 0 110 1H5zm0 3a.5.5 0 110-1h3a.5.5 0 110 1H5z"
});

function Svg16Px$o(props) {
  return /*#__PURE__*/createElement("svg", _extends$$({
    viewBox: "0 0 16 16"
  }, props), _ref$_);
}

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var _ref$$ = /*#__PURE__*/createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  stroke: "currentColor"
});

function Svg16Px$p(props) {
  return /*#__PURE__*/createElement("svg", _extends$10({
    viewBox: "0 0 16 16",
    fill: "transparent"
  }, props), _ref$$);
}

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var _ref$10 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8.5 1.018V7.5h6.482A7.001 7.001 0 008.5 1.018zm-1 0a7 7 0 105.084 12.273L7.5 8.207v-7.19zm5.79 11.566A6.97 6.97 0 0014.983 8.5H9.207l4.084 4.084zM8 16A8 8 0 118 0a8 8 0 010 16z"
});

function Svg16Px$q(props) {
  return /*#__PURE__*/createElement("svg", _extends$11({
    viewBox: "0 0 16 16"
  }, props), _ref$10);
}

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var _ref$11 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M19.416 18.709a9.96 9.96 0 002.572-6.209h-8.78l6.208 6.209zm-.707.707L11.5 12.207V2.012C6.21 2.272 2 6.645 2 12c0 5.523 4.477 10 10 10a9.963 9.963 0 006.709-2.584zM12.5 2.012V11.5h9.488A10 10 0 0012.5 2.012zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z"
});

function Svg24Px$8(props) {
  return /*#__PURE__*/createElement("svg", _extends$12({
    viewBox: "0 0 24 24"
  }, props), _ref$11);
}

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var _ref$12 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M0 4a2 2 0 012-2h4.293c.453 0 .887.18 1.207.5.32.32.754.5 1.207.5H13c1.054 0 1.918.816 1.995 1.85L15 5l.001.268A2 2 0 0116 7v5a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm15 2H1v7h14V6zM6.293 3H1L.999 5h13L14 4H8.707c-.453 0-.887-.18-1.207-.5a1.71 1.71 0 00-1.038-.492L6.292 3z"
});

function Svg16Px$r(props) {
  return /*#__PURE__*/createElement("svg", _extends$13({
    viewBox: "0 0 16 16"
  }, props), _ref$12);
}

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var _ref$13 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M0 4a2 2 0 012-2h7.172c.53 0 1.039.21 1.414.586l.828.828A2 2 0 0012.828 4H20a2 2 0 012 2v1h1l.001.268A2 2 0 0124 9v11a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm22 5H2v11h20V9zM8.172 4H2l-.001 3H20V6h-8.172c-.471 0-.925-.166-1.284-.467l-.13-.119-.828-.828a2 2 0 00-1.239-.578L8.172 4z"
});

function Svg24Px$9(props) {
  return /*#__PURE__*/createElement("svg", _extends$14({
    viewBox: "0 0 24 24"
  }, props), _ref$13);
}

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var _ref$14 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M2 4.5v-1h12v1H2zm0 4v-1h12v1H2zm0 4v-1h12v1H2z"
});

function Svg16Px$s(props) {
  return /*#__PURE__*/createElement("svg", _extends$15({
    viewBox: "0 0 16 16"
  }, props), _ref$14);
}

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var _ref$15 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M4 8V6h16v2H4zm0 5v-2h16v2H4zm0 5v-2h16v2H4z"
});

function Svg24Px$a(props) {
  return /*#__PURE__*/createElement("svg", _extends$16({
    viewBox: "0 0 24 24"
  }, props), _ref$15);
}

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var _ref$16 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M1 14.443l2.965-2.964h10.372a.664.664 0 00.663-.664V1.663A.664.664 0 0014.337 1H1.663A.664.664 0 001 1.663v12.78zm3.38-1.964L1.036 15.82A.607.607 0 010 15.39V1.664C0 .745.745 0 1.663 0h12.674C15.255 0 16 .745 16 1.663v9.152c0 .919-.745 1.664-1.663 1.664H4.379zM9 6.5a1 1 0 11-2 0 1 1 0 012 0zm-4 0a1 1 0 11-2 0 1 1 0 012 0zm8 0a1 1 0 11-2 0 1 1 0 012 0z"
});

function Svg16Px$t(props) {
  return /*#__PURE__*/createElement("svg", _extends$17({
    viewBox: "0 0 16 16"
  }, props), _ref$16);
}

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var _ref$17 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M2 20.458l3.74-3.74h15.765a.496.496 0 00.495-.495V2.495A.496.496 0 0021.505 2H2.495A.496.496 0 002 2.495v17.963zm4.569-1.74l-5.014 5.013C.981 24.305 0 23.9 0 23.087V2.495A2.496 2.496 0 012.495 0h19.01A2.496 2.496 0 0124 2.495v13.728a2.496 2.496 0 01-2.495 2.495H6.569zM12 11a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-1a.5.5 0 100-1 .5.5 0 000 1zm5 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-1a.5.5 0 100-1 .5.5 0 000 1zM7 11a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-1a.5.5 0 100-1 .5.5 0 000 1z"
});

function Svg24Px$b(props) {
  return /*#__PURE__*/createElement("svg", _extends$18({
    viewBox: "0 0 24 24"
  }, props), _ref$17);
}

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var _ref$18 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M9.3 1.12l.03.04a.5.5 0 01-.811.585A17.355 17.355 0 007.949 1a7.1 7.1 0 00-.405.015C4.88 4.305 4.098 7.555 5.2 10.82c3.26 1.075 6.505.275 9.789-2.4.005-.089.008-.178.01-.267a17.651 17.651 0 01-.1-1.345A7.007 7.007 0 009.302 1.12zM7.82 14.999a.504.504 0 01.046-.067c.21-.257.408-.513.595-.77a.5.5 0 01.808.59l-.114.154a7.009 7.009 0 005.594-5.042c-1.286.926-2.577 1.587-3.87 1.981a.498.498 0 01-.041.227 12.9 12.9 0 01-.459.933.5.5 0 11-.88-.476c.073-.133.142-.266.207-.399a9.568 9.568 0 01-4.03-.131c.47.99 1.113 1.982 1.927 2.977l-.015.013c.077.005.154.008.231.01zm3.733-9.028c.063.305.11.61.144.916a.5.5 0 01-.994.108 8.832 8.832 0 00-.153-.934.5.5 0 01.86-.441.498.498 0 01.702-.457c.312.138.623.29.934.459a.5.5 0 01-.477.88 11.901 11.901 0 00-.86-.424.499.499 0 01-.156-.107zM4.02 10.35a9.575 9.575 0 01-.144-4.122c-.176.084-.351.174-.527.269a.5.5 0 11-.476-.88c.311-.168.623-.32.934-.458a.498.498 0 01.333-.025C4.527 3.84 5.18 2.548 6.1 1.261a7.01 7.01 0 00-4.985 5.473l.088-.064a.5.5 0 01.585.811A17.395 17.395 0 001 8.083a7.1 7.1 0 00.012.337c1.006.82 2.008 1.463 3.007 1.93zm2.155 4.41c-.761-1.05-1.346-2.101-1.753-3.155-1.059-.402-2.116-.983-3.17-1.742a7.013 7.013 0 004.923 4.896zM8 16A8 8 0 118 0a8 8 0 010 16zm2.078-11.515a.5.5 0 11-.22.976 8.859 8.859 0 00-.933-.158.5.5 0 11.114-.994c.346.04.693.099 1.039.176zm-3.15-.182a.5.5 0 11.108.994 8.832 8.832 0 00-.934.153.5.5 0 11-.214-.977 9.832 9.832 0 011.04-.17zm4.587 5.733a.5.5 0 11-.976-.219c.07-.311.123-.622.158-.933a.5.5 0 01.994.114c-.04.346-.099.692-.176 1.038zm-.674-6.271a.5.5 0 11-.915.403 11.889 11.889 0 00-.423-.862.5.5 0 01.88-.475c.168.31.32.622.458.934z"
});

function Svg16Px$u(props) {
  return /*#__PURE__*/createElement("svg", _extends$19({
    viewBox: "0 0 16 16"
  }, props), _ref$18);
}

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var _ref$19 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M21.992 11.589l-.08-.061a.5.5 0 01.008-.802 10.01 10.01 0 00-7.29-8.376.5.5 0 01.085.095c.196.284.383.568.562.853a.5.5 0 01-.847.531c-.171-.272-.35-.544-.538-.817a.5.5 0 01.299-.771 10.035 10.035 0 00-3.402-.169C9.44 3.847 8.45 5.617 7.821 7.385a.503.503 0 01.09-.036c.333-.098.667-.184 1.001-.258a.5.5 0 11.216.976 15.7 15.7 0 00-.936.241.5.5 0 01-.59-.26c-.861 2.828-.798 5.652.189 8.48 4.703 1.506 9.393.455 14.115-3.151a10.089 10.089 0 00.086-1.788zm-15.443-3.5c.538-1.914 1.47-3.826 2.798-5.733C5.112 3.518 2 7.396 2 12c0 .5.037.992.108 1.473 1.5 1.132 2.998 2.005 4.494 2.62-.696-2.366-.789-4.735-.277-7.102-.256.112-.513.231-.77.359a.5.5 0 01-.444-.896c.31-.154.622-.298.933-.431a.5.5 0 01.505.066zm11.12.9a.5.5 0 01-.987.138c-.07-.311-.15-.623-.241-.935a.5.5 0 01.894-.42c.263.1.526.208.788.324a.5.5 0 11-.403.915 16.997 16.997 0 00-.05-.022zm3.92 5.856c-1.527 1.063-3.057 1.873-4.589 2.43a16.77 16.77 0 01-.347.847.5.5 0 11-.915-.403l.021-.048c-2.5.685-5.004.697-7.505.034.618 1.405 1.463 2.812 2.536 4.223a10.102 10.102 0 002.418 0l.013-.017a.5.5 0 01.7-.096 10.015 10.015 0 007.668-6.97zm-19.149.099c1 3.252 3.614 5.797 6.907 6.7-1.001-1.438-1.778-2.88-2.33-4.322-1.527-.541-3.053-1.334-4.577-2.378zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm3.187-3.159a.5.5 0 11-.843-.537 20.2 20.2 0 00.506-.835.5.5 0 01.867.498c-.167.291-.344.583-.53.874zm2.448-5.651a.5.5 0 11-.975-.224c.072-.316.133-.631.182-.947a.5.5 0 11.988.154c-.053.34-.118.678-.195 1.017zM18 12.069a.5.5 0 01-1-.005 12.97 12.97 0 00-.031-.963.5.5 0 01.998-.069c.023.346.035.691.033 1.037zm-1.274-6.026a.5.5 0 01-.919.394 17.475 17.475 0 00-.408-.883.5.5 0 01.896-.444c.154.31.298.622.431.933zm4.116 3.519a.5.5 0 11-.537.843 20.994 20.994 0 00-.835-.506.5.5 0 01.498-.867c.291.167.583.344.874.53zM15.19 7.114a.5.5 0 11-.223.975 13.703 13.703 0 00-.947-.182.5.5 0 01.154-.988c.339.053.678.118 1.016.195zm-3.12-.365a.5.5 0 01-.006 1 12.97 12.97 0 00-.962.031.5.5 0 01-.07-.997 13.97 13.97 0 011.037-.034zM3.298 9.471a.5.5 0 01.531.847c-.272.171-.544.35-.817.539a.5.5 0 01-.568-.824c.285-.196.57-.383.854-.562z"
});

function Svg24Px$c(props) {
  return /*#__PURE__*/createElement("svg", _extends$1a({
    viewBox: "0 0 24 24"
  }, props), _ref$19);
}

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var _ref$1a = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M1 6.5h14V5a1 1 0 00-1-1H2a1 1 0 00-1 1v1.5zm0 1V12a1 1 0 001 1h12a1 1 0 001-1V7.5H1zM2 3h12a2 2 0 012 2v7a2 2 0 01-2 2H2a2 2 0 01-2-2V5a2 2 0 012-2zm6 8a.5.5 0 110-1h4a.5.5 0 110 1H8z"
});

function Svg16Px$v(props) {
  return /*#__PURE__*/createElement("svg", _extends$1b({
    viewBox: "0 0 16 16"
  }, props), _ref$1a);
}

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var _ref$1b = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M2 9h20V8a2 2 0 00-2-2H4a2 2 0 00-2 2v1zm0 2v5a2 2 0 002 2h16a2 2 0 002-2v-5H2zm2-7h16a4 4 0 014 4v8a4 4 0 01-4 4H4a4 4 0 01-4-4V8a4 4 0 014-4zm8 11a.5.5 0 110-1h7a.5.5 0 110 1h-7z"
});

function Svg24Px$d(props) {
  return /*#__PURE__*/createElement("svg", _extends$1c({
    viewBox: "0 0 24 24"
  }, props), _ref$1b);
}

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var _ref$1c = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M3.75 13.454v-.044a.45.45 0 01.221-.38c2.052-1.878 2.49-3.026 1.443-3.979a6.451 6.451 0 01-1.508-2.085C2.526 6.147 1.419 5.137.59 3.936-.43 2.458-.115 1.263 1.48.782l.138-.02H3.3C3.627.282 4.208.018 5 0h6.011c.785.018 1.364.282 1.689.762h1.685l.138.02c1.595.481 1.909 1.676.89 3.154-.817 1.184-1.904 2.182-3.256 2.993a6.552 6.552 0 01-1.57 2.121c-1.048.953-.61 2.101 1.442 3.98a.447.447 0 01.221.379V15h1a.5.5 0 110 1H2.75a.5.5 0 110-1h1v-1.546zm2.069-.883h4.362c-1.426-1.668-1.612-3.038-.267-4.26C11.552 6.82 12 4.778 12 1.862c0-.6-.27-.846-1-.863H5.011C4.271 1.017 4 1.263 4 1.863c0 1.536.094 2.59.468 3.783.338 1.08.867 1.981 1.618 2.664 1.345 1.223 1.159 2.593-.267 4.261zm-1.069 1.1V15h6.5v-1.328a18.23 18.23 0 01-.107-.1H4.857a18.23 18.23 0 01-.107.1zm-1.392-8.27C3.075 4.303 3 3.267 3 1.864c0-.034 0-.068.002-.101h-1.31c-.854.275-.937.675-.3 1.599A8.946 8.946 0 003.358 5.4zm9.64-3.64l.002.102c0 1.321-.085 2.482-.321 3.513a8.933 8.933 0 001.933-2.015c.637-.924.553-1.324-.3-1.6h-1.314z"
});

function Svg16Px$w(props) {
  return /*#__PURE__*/createElement("svg", _extends$1d({
    viewBox: "0 0 16 16"
  }, props), _ref$1c);
}

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var _ref$1d = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M16 21v-1.558a19.55 19.55 0 01-.952-.942H8.952c-.289.308-.607.622-.952.942V21h8zm2 0h1a1 1 0 010 2H5a1 1 0 010-2h1v-2c0-.298.13-.565.337-.748 2.665-2.386 3.19-3.702 1.996-4.77a8.535 8.535 0 01-1.576-1.892c-2.023-1.208-3.652-2.696-4.876-4.46C.282 4.825.8 2.868 3.34 2.106l.14-.042h2.04C6.025 1.397 6.88 1.024 8 1h8.022c1.107.025 1.956.397 2.459 1.064h2.262l.14.042c2.54.762 3.058 2.719 1.459 5.024-1.295 1.865-3.04 3.421-5.228 4.665a8.508 8.508 0 01-1.447 1.687c-1.194 1.068-.669 2.384 1.996 4.77.207.183.337.45.337.748v2zm-3.806-3.5c-1.588-2.085-1.677-3.883.14-5.508C16.42 10.124 17 7.522 17 3.789c0-.587-.205-.771-1-.789H8.022C7.205 3.018 7 3.202 7 3.79c0 1.981.123 3.335.607 4.857.434 1.362 1.106 2.492 2.06 3.345 1.816 1.625 1.727 3.423.139 5.508h4.388zm4.352-9.135A12.606 12.606 0 0020.7 5.99c.83-1.197.773-1.589-.255-1.925H19c-.008 1.576-.094 2.698-.398 4.064l-.055.237zM5.388 8.11C5.1 6.854 5.01 5.626 5 4.064H3.779c-1.028.336-1.085.728-.255 1.925a12.45 12.45 0 001.864 2.12z"
});

function Svg24Px$e(props) {
  return /*#__PURE__*/createElement("svg", _extends$1e({
    viewBox: "0 0 24 24"
  }, props), _ref$1d);
}

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var _ref$1e = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8 7a3 3 0 100-6 3 3 0 000 6zm0 1a4 4 0 110-8 4 4 0 010 8zm-6.969 8.002a7 7 0 0113.938.002h1.004A8 8 0 00.027 16h1.004zM8 9.667a7 7 0 016.97 6.337h1.003A8 8 0 00.027 16h1.004A7 7 0 018 9.668z"
});

function Svg16Px$x(props) {
  return /*#__PURE__*/createElement("svg", _extends$1f({
    viewBox: "0 0 16 16"
  }, props), _ref$1e);
}

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var _ref$1f = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M12 10a4 4 0 100-8 4 4 0 000 8zm0 2a6 6 0 110-12 6 6 0 010 12zM2.049 24.004C2.549 18.922 6.842 15 12 15s9.45 3.921 9.951 9.003h2.008C23.452 17.842 18.292 13 12 13S.547 17.843.04 24.004h2.01zM12 15c5.158 0 9.45 3.921 9.951 9.003h2.008C23.452 17.842 18.292 13 12 13S.547 17.843.04 24.004h2.01C2.549 18.922 6.842 15 12 15z"
});

function Svg24Px$f(props) {
  return /*#__PURE__*/createElement("svg", _extends$1g({
    viewBox: "0 0 24 24"
  }, props), _ref$1f);
}

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var _ref$1g = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M21.333 3C22.806 3 24 4.075 24 5.4v1.2c0 .137-.013.27-.037.401L29.333 7C30.806 7 32 8.159 32 9.588v16.824C32 27.842 30.806 29 29.333 29H2.667C1.194 29 0 27.841 0 26.412V9.588C0 8.158 1.194 7 2.667 7l5.37.001A2.207 2.207 0 018 6.6V5.4C8 4.075 9.194 3 10.667 3h10.666zM30 11.803L16 22 2 11.803V27h28V11.803zM30 9H2v1.159l14 10.196L30 10.16V9zm-14 3a2 2 0 11.001 3.999A2 2 0 0116 12zm0 1a1 1 0 100 2 1 1 0 000-2zm6-8H10v2h12V5z"
});

function Svg32Px$n(props) {
  return /*#__PURE__*/createElement("svg", _extends$1h({
    viewBox: "0 0 32 32"
  }, props), _ref$1g);
}

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var _ref$1h = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13 0c.773 0 1.42.563 1.493 1.298l.007.14v7.216a.5.5 0 01-.992.09l-.008-.09V1.438c0-.209-.171-.392-.408-.43L13 1H3c-.252 0-.451.16-.492.36l-.008.077v13.126c0 .208.171.391.408.43L3 15h5.634a.5.5 0 01.09.992l-.09.008H3c-.773 0-1.42-.563-1.493-1.298l-.007-.14V1.438C1.5.682 2.101.075 2.857.006L3 0h10zm-2.795 8a3.205 3.205 0 012.785 4.792l2.453 2.126a.54.54 0 01.054.759l-.088.101a.54.54 0 01-.76.054l-2.444-2.118.014-.015A3.205 3.205 0 1110.205 8zm.041.863a2.341 2.341 0 10-.001 4.683 2.341 2.341 0 00.001-4.683zM4.208 7.545l.076.044.07.057.706.707.708-.707a.5.5 0 01.765.638l-.058.07-.708.706.708.708a.5.5 0 01-.638.765l-.07-.058-.707-.708-.706.708a.501.501 0 01-.765-.638l.057-.07.707-.707-.707-.706a.501.501 0 01.562-.808zm3.126-4.917a.5.5 0 01.092.634l-.054.072-2.146 2.392-1.58-1.575a.5.5 0 01.638-.766l.07.058.832.83 1.442-1.607a.5.5 0 01.706-.038zM11.429 4c.315 0 .571.224.571.5s-.256.5-.571.5H9.57C9.256 5 9 4.776 9 4.5s.256-.5.571-.5h1.858z"
});

function Svg16Px$y(props) {
  return /*#__PURE__*/createElement("svg", _extends$1i({
    viewBox: "0 0 16 16"
  }, props), _ref$1h);
}

var Icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IconPlaceholder: SvgIconPlaceholder,
  IconAdd16: Svg16Px,
  IconAdd24: Svg24Px,
  IconArrowLeft16: Svg16Px$1,
  IconArrowLeft24: Svg24Px$1,
  IconArrowRight16: Svg16Px$2,
  IconArrowRight24: Svg24Px$2,
  IconCalendar16: Svg16Px$3,
  IconChevronDown16: Svg16Px$4,
  IconChevronLeft16: Svg16Px$5,
  IconChevronRight16: Svg16Px$6,
  IconChevronUp16: Svg16Px$7,
  IconClose16: Svg16Px$8,
  IconClose24: Svg24Px$3,
  IconContactChat24: Svg24Px$4,
  IconContactMail24: Svg24Px$5,
  IconContactPhone24: Svg24Px$6,
  IconDownload16: Svg16Px$9,
  IconFeedback16: Svg16Px$a,
  IconOpenInANewWindow16: Svg16Px$b,
  IconOpenInANewWindow24: Svg24Px$7,
  IconVideoPlay64: Svg64Px,
  IconEdit16: Svg16Px$c,
  IconReload16: Svg16Px$d,
  IconUpload16: Svg16Px$e,
  IconFacebook32: SvgFacebook,
  IconTwitter32: SvgTwitter,
  IconLinkedIn32: SvgLinkedIn,
  IconYouTube32: SvgYoutube,
  IconCertificate32: Svg32Px,
  IconDocument32: Svg32Px$1,
  IconPdf32: Svg32Px$2,
  IconTimelineAlert32: Svg32Px$3,
  IconTimelineCircles32: Svg32Px$4,
  IconTimelineLock32: Svg32Px$5,
  IconTimelineTick32: Svg32Px$6,
  IconTimelineCross32: Svg32Px$7,
  IconTick16: Svg16Px$f,
  IconTickOutline16: Svg16Px$g,
  IconTickOutline32: Svg32Px$8,
  IconTickSolid16: Svg16Px$h,
  IconTickSolid32: Svg32Px$9,
  IconCrossOutline16: Svg16Px$i,
  IconCrossOutline32: Svg32Px$a,
  IconCrossSolid16: Svg16Px$j,
  IconCrossSolid32: Svg32Px$b,
  IconQuestionSolid16: Svg16Px$k,
  IconQuestionSolid32: Svg32Px$c,
  IconPauseSolid16: Svg16Px$l,
  IconExclamationSolid16: Svg16Px$m,
  IconExclamationSolid32: Svg32Px$d,
  IconEmail32: Svg32Px$e,
  IconEmployment32: Svg32Px$f,
  IconExchange32: Svg32Px$g,
  IconMailingAddress32: Svg32Px$h,
  IconMembership32: Svg32Px$i,
  IconPassword32: Svg32Px$j,
  IconQualification32: Svg32Px$k,
  IconSecondaryAddress32: Svg32Px$l,
  IconTelephone32: Svg32Px$m,
  IconCelebration64: Svg64Px$1,
  IconExamProgress16: Svg16Px$n,
  IconExemptions16: Svg16Px$o,
  IconCircle: Svg16Px$p,
  IconDashboard16: Svg16Px$q,
  IconDashboard24: Svg24Px$8,
  IconDocuments16: Svg16Px$r,
  IconDocuments24: Svg24Px$9,
  IconHamburger16: Svg16Px$s,
  IconHamburger24: Svg24Px$a,
  IconHelp16: Svg16Px$t,
  IconHelp24: Svg24Px$b,
  IconNetwork16: Svg16Px$u,
  IconNetwork24: Svg24Px$c,
  IconPayment16: Svg16Px$v,
  IconPayment24: Svg24Px$d,
  IconProfessionalDevelopment16: Svg16Px$w,
  IconProfessionalDevelopment24: Svg24Px$e,
  IconProfile16: Svg16Px$x,
  IconProfile24: Svg24Px$f,
  IconFirm24: Svg32Px$n,
  IconFirm32: Svg32Px$n,
  IconMonitoring16: Svg16Px$y
});

var css_248z$g = ".file-uploader{border:2px solid #dcdcdc;padding:2rem;background:#fafafa;text-align:left}.file-uploader__table{margin:0 0 2rem}.file-uploader__input{display:none}.file-uploader__label{padding-left:1rem}.file-uploader__remove-cell{max-width:8rem}@media screen and (min-width:28.75em){.file-uploader__remove-cell{text-align:right}}";
styleInject(css_248z$g);

var TableRow = function TableRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return jsx("tr", _extends({
    className: className
  }, props), children);
};

TableRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var TableHead = function TableHead(_ref) {
  var children = _ref.children;
  return jsx("thead", null, jsx(TableRow, null, children));
};

TableHead.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var TableHeadCell = function TableHeadCell(_ref) {
  var children = _ref.children,
      colspan = _ref.colspan,
      scope = _ref.scope,
      className = _ref.className,
      label = _ref.label;
  return jsx("th", {
    className: className,
    colSpan: colspan,
    scope: scope,
    "data-label": label
  }, children);
};

TableHeadCell.propTypes = {
  label: PropTypes.string,
  scope: PropTypes.oneOf(["row", "col"]).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  colspan: PropTypes.string,
  className: PropTypes.string
};
TableHeadCell.defaultProps = {
  className: "",
  label: ""
};

var css_248z$h = ".responsive-table table{width:100%;border-spacing:0}.responsive-table tr>:first-child{padding-left:0;padding-top:2rem}.responsive-table tr>:last-child{padding-right:0;padding-bottom:2rem}.responsive-table th{font-weight:400;text-align:left}.responsive-table thead{display:none}.responsive-table thead th{font-size:.75rem;color:#3f3f3f;text-transform:uppercase;padding:1rem}.responsive-table tbody td,.responsive-table tbody th{font-size:1rem;display:block}.responsive-table tbody td:before,.responsive-table tbody th:before{content:attr(data-label);display:block;font-size:.75rem;color:#3f3f3f;text-transform:uppercase;padding:0 0 .5rem}.responsive-table tbody tr:not(:last-child)>:last-child,.responsive-table thead td,.responsive-table thead th{border-bottom:1px solid #e5e5e5}.responsive-table tbody th{padding:1rem 0;color:#000}.responsive-table tbody td{padding:.5rem 0;color:#2d2d2d}.responsive-table tfoot td,.responsive-table tfoot th{font-size:.875rem;color:#3f3f3f;padding:1rem 0}.responsive-table tfoot tr:first-child td,.responsive-table tfoot tr:first-child th{border-top:2px solid #979797}.responsive-table__row-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.responsive-table__row-header-icon{-ms-flex:none;flex:none;margin-right:1rem}.responsive-table__row-header-text{-ms-flex:1;flex:1}@media screen and (min-width:28.75em){.responsive-table thead{display:table-header-group}.responsive-table tbody td,.responsive-table tbody th{display:table-cell;padding:1rem}.responsive-table tbody td:before,.responsive-table tbody th:before{display:none}.responsive-table tbody tr td,.responsive-table tbody tr th{border-bottom:1px solid #e5e5e5}.responsive-table tr>:last-child{padding-bottom:1rem}.responsive-table tr>:first-child{padding-top:1rem}.responsive-table tfoot td,.responsive-table tfoot th{padding:1rem}}.responsive-table--has-row-headers tbody td:before,.responsive-table--has-row-headers tbody th:before{content:attr(data-label);display:block;font-size:.75rem;color:#3f3f3f;text-transform:uppercase;padding:0 0 .5rem}.responsive-table--has-row-headers tbody td{padding-left:2rem}.responsive-table--has-row-headers tr>:first-child:before{padding-left:2rem}@media screen and (min-width:28.75em){.responsive-table--has-row-headers tbody td,.responsive-table--has-row-headers tbody th{padding:1rem}.responsive-table--has-row-headers tbody td:before,.responsive-table--has-row-headers tbody th:before{display:none}.responsive-table--has-row-headers thead tr>:first-child{padding-left:2rem}}.responsive-table--condensed{width:auto}.responsive-table--is-striped thead th{padding-bottom:1rem}.responsive-table--is-striped tbody td,.responsive-table--is-striped tbody th,.responsive-table--is-striped tr>:first-child,.responsive-table--is-striped tr>:last-child{padding:1rem}.responsive-table--is-striped tbody tr:nth-child(odd) td,.responsive-table--is-striped tbody tr:nth-child(odd) th{background-color:rgba(0,0,0,.02)}@media screen and (min-width:48em){.responsive-table--sticky-columns{position:relative;overflow-x:auto;background-image:linear-gradient(90deg,#fff,#fff),linear-gradient(90deg,#fff,#fff),linear-gradient(90deg,rgba(0,0,20,.05),hsla(0,0%,100%,0)),linear-gradient(270deg,rgba(0,0,20,.05),hsla(0,0%,100%,0));background-position:0,100%,0,100%;background-repeat:no-repeat;background-color:#fff;background-size:20px 100%,20px 100%,24px 100%,24px 100%;background-attachment:local,local,scroll,scroll}.responsive-table--sticky-columns table tr>:first-child{position:-webkit-sticky;position:sticky;top:0;left:0;background-color:#fff}.responsive-table--sticky-columns.responsive-table--is-striped table tbody tr:nth-child(odd)>:first-child{background-color:#fafafa}}.responsive-table--scrolling{overflow-x:auto;background-image:linear-gradient(90deg,#fff,#fff),linear-gradient(90deg,#fff,#fff),linear-gradient(90deg,rgba(0,0,20,.05),hsla(0,0%,100%,0)),linear-gradient(270deg,rgba(0,0,20,.05),hsla(0,0%,100%,0));background-position:0,100%,0,100%;background-repeat:no-repeat;background-color:#fff;background-size:20px 100%,20px 100%,24px 100%,24px 100%;background-attachment:local,local,scroll,scroll}.responsive-table--scrolling thead th{white-space:nowrap}";
styleInject(css_248z$h);

var Table = function Table(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isStriped = _ref.isStriped,
      isScrolling = _ref.isScrolling,
      isStickyColumns = _ref.isStickyColumns,
      cols = _ref.cols,
      props = _objectWithoutProperties(_ref, ["children", "className", "isStriped", "isScrolling", "isStickyColumns", "cols"]);

  var classes = classnames("responsive-table", {
    "responsive-table--sticky-columns": isStickyColumns,
    "responsive-table--scrolling": isScrolling,
    "responsive-table--is-striped": isStriped
  }, className);

  var renderHeader = function renderHeader() {
    return jsx(React__default.Fragment, null, cols && jsx(TableHead, null, cols.map(function (column) {
      return jsx(TableHeadCell, {
        key: column.label,
        scope: "col"
      }, column.text);
    })));
  };

  return jsx("div", _extends({
    className: classes
  }, props), jsx("div", {
    className: "responsive-table__inner"
  }, jsx("table", null, renderHeader(), children)));
};

Table.propTypes = {
  /**
   *  An array of objects representing the table column headers
   */
  cols: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    label: PropTypes.string
  }).isRequired),

  /**
   * This flag will render striped table rows
   */
  isStriped: PropTypes.bool,

  /**
   * This flag will enable horizontal scrolling when the table conent is wider than it's container
   */
  isScrolling: PropTypes.bool,

  /**
   * This flag will make the first column position sticky on tablet screen sizes and greater.
   */
  isStickyColumns: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
};
// | Prop             | Required | Default | Type   | Description                                                 |
// | :--------------- | :------- | :------ | :----- | :---------------------------------------------------------- |
// | `cols` | true     | -  | array | An array of objects representing the table column headers  |
// | `isStriped`  | false   | false | bool | This flag will render striped table rows |
// | `isScrolling`  | false    | false | bool   | This flag will enable horizontal scrolling when the table conent is wider than it's container |
// | `isStickyColumns`  | false    | false | bool | This flag will make the first column position sticky on tablet screen sizes and greater. |
// | `children` | false    | true       | node   | Child nodes which make up the content and structure of the table  |
// | `className`      | false    | -       | string | Custom className(s) to add to the component  |

var TableBody = function TableBody(_ref) {
  var children = _ref.children;
  return jsx("tbody", null, children);
};

TableBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var TableCell = function TableCell(_ref) {
  var children = _ref.children,
      colspan = _ref.colspan,
      className = _ref.className,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["children", "colspan", "className", "label"]);

  return jsx("td", _extends({
    className: className,
    colSpan: colspan,
    "data-label": label
  }, props), children);
};

TableCell.propTypes = {
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  colspan: PropTypes.string,
  className: PropTypes.string
};
TableCell.defaultProps = {
  className: ""
};

var fileListToArray = function fileListToArray(list) {
  var result = [];
  if (!list) return result;

  for (var i = 0; i < list.length; i += 1) {
    result.push({
      file: list.item(i)
    });
  }

  return result;
};

var FileUploader = /*#__PURE__*/function (_Component) {
  _inherits(FileUploader, _Component);

  var _super = _createSuper(FileUploader);

  function FileUploader(props) {
    var _this;

    _classCallCheck(this, FileUploader);

    _this = _super.call(this, props);
    _this.state = {
      highlight: false,
      inputKey: Date.now()
    };
    _this.fileInputRef = /*#__PURE__*/createRef();
    _this.openFileDialog = _this.openFileDialog.bind(_assertThisInitialized(_this));
    _this.onFilesAdded = _this.onFilesAdded.bind(_assertThisInitialized(_this));
    _this.onDragOver = _this.onDragOver.bind(_assertThisInitialized(_this));
    _this.onDragLeave = _this.onDragLeave.bind(_assertThisInitialized(_this));
    _this.onDrop = _this.onDrop.bind(_assertThisInitialized(_this));
    _this.onFileRemove = _this.onFileRemove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FileUploader, [{
    key: "onFileRemove",
    value: function onFileRemove(file) {
      var onRemove = this.props.onRemove;
      this.setState({
        inputKey: Date.now()
      });
      onRemove(file);
    }
  }, {
    key: "onFilesAdded",
    value: function onFilesAdded(e) {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onAdd = _this$props.onAdd;
      if (disabled) return;
      var files = e.target.files;
      var array = fileListToArray(files);
      onAdd(array);
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e) {
      e.preventDefault();
      var disabled = this.props.disabled;
      if (disabled) return;
      this.setState({
        highlight: true
      });
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave() {
      this.setState({
        highlight: false
      });
    }
  }, {
    key: "onDrop",
    value: function onDrop(e) {
      e.preventDefault();
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          onAdd = _this$props2.onAdd;
      if (disabled) return;
      var files = e.dataTransfer.files;
      var array = fileListToArray(files);
      onAdd(array);
      this.setState({
        highlight: false
      });
    }
  }, {
    key: "openFileDialog",
    value: function openFileDialog() {
      this.fileInputRef.current.click();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          multiple = _this$props3.multiple,
          disabled = _this$props3.disabled,
          addButtonText = _this$props3.addButtonText,
          className = _this$props3.className,
          files = _this$props3.files,
          accept = _this$props3.accept,
          removeText = _this$props3.removeText,
          filePendingText = _this$props3.filePendingText,
          fileSuccessText = _this$props3.fileSuccessText,
          fileErroredText = _this$props3.fileErroredText,
          onRemove = _this$props3.onRemove,
          removeable = _this$props3.removeable;
      var _this$state = this.state,
          highlight = _this$state.highlight,
          inputKey = _this$state.inputKey;
      var classes = classnames("file-uploader", {
        "file-uploader--highlight": highlight
      }, className);
      var hasStatuses = files.some(function (file) {
        return !!file.status;
      });

      var getStatusCol = function getStatusCol(file) {
        if (!hasStatuses) return null;

        switch (file.status) {
          case "error":
            return jsx(TableCell, null, jsx(Alert, {
              className: "alert--inline",
              type: "error"
            }, fileErroredText));

          case "pending":
            return jsx(TableCell, null, jsx(Alert, {
              className: "alert--inline",
              type: "info"
            }, filePendingText));

          case "success":
            return jsx(TableCell, null, jsx(Alert, {
              className: "alert--inline",
              type: "success"
            }, fileSuccessText));

          default:
            return jsx(TableCell, null);
        }
      };

      var erroredFile = function erroredFile(file, key) {
        return jsx(TableRow, {
          key: key
        }, getStatusCol(file), jsx(TableCell, {
          label: "FileName",
          className: "u-error"
        }, file.errorMessage), onRemove && jsx(TableCell, null));
      };

      var addedFile = function addedFile(file, key) {
        return jsx(TableRow, {
          key: key
        }, getStatusCol(file), jsx(TableCell, null, file.file.name), onRemove && removeable && jsx(TableCell, {
          className: "file-uploader__remove-cell"
        }, jsx(Button, {
          id: "removeBtn_".concat(key),
          disabled: disabled,
          variant: "link",
          text: removeText,
          onClick: function onClick() {
            return _this2.onFileRemove(file);
          }
        })));
      };

      return jsx("div", {
        className: classes,
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDrop: this.onDrop
      }, files && files.length > 0 && jsx(Table, {
        className: "file-uploader__table"
      }, jsx(TableBody, null, files.map(function (file, idx) {
        return file.errorMessage ? erroredFile(file, idx) : addedFile(file, idx);
      }))), jsx("input", {
        id: id,
        ref: this.fileInputRef,
        key: inputKey,
        className: "file-uploader__input",
        type: "file",
        multiple: multiple,
        disabled: disabled,
        files: files,
        accept: accept,
        onChange: this.onFilesAdded
      }), jsx(Button, {
        variant: "outlined",
        text: addButtonText,
        icon: Svg16Px,
        className: "file-uploader__button",
        onClick: this.openFileDialog,
        disabled: disabled
      }));
    }
  }]);

  return FileUploader;
}(Component);

FileUploader.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  removeable: PropTypes.bool,
  disabled: PropTypes.bool,
  addButtonText: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
  removeText: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.shape({})),
  accept: PropTypes.string,
  fileSuccessText: PropTypes.string,
  filePendingText: PropTypes.string,
  fileErroredText: PropTypes.string
};
FileUploader.defaultProps = {
  removeText: "Remove",
  removeable: true,
  files: [],
  fileSuccessText: "Uploaded",
  fileErroredText: "Failed",
  filePendingText: "Pending"
};

var css_248z$i = ".form-field+.form-field{margin-top:2rem}.form-label{color:#2d2d2d;margin-bottom:.5rem;display:block;font-weight:700}.form-field-validation__item{margin-bottom:1rem;display:-ms-flexbox;display:flex;-ms-flex-align:baseline;align-items:baseline}.form-field-validation__item .alert{-ms-flex:none;flex:none}.form-field-validation__item-message{-ms-flex:1 1 auto;flex:1 1 auto}.form-field-validation{margin:1rem 0 0}.form-field--short [type=date],.form-field--short [type=datetime-local],.form-field--short [type=email],.form-field--short [type=password],.form-field--short [type=tel],.form-field--short [type=text]{width:10rem}.form-field--invalid .file-uploader,.form-field--invalid .react-select-container .react-select__control,.form-field--invalid .toggle-control--checkbox .toggle-control__control,.form-field--invalid .toggle-control--radio .toggle-control__control,.form-field--invalid [type=date],.form-field--invalid [type=datetime-local],.form-field--invalid [type=email],.form-field--invalid [type=password],.form-field--invalid [type=tel],.form-field--invalid [type=text],.form-field--invalid select,.form-field--invalid textarea{background-color:#fff;border-color:#f24137}.form-field--invalid .file-uploader:focus,.form-field--invalid .file-uploader:hover,.form-field--invalid .react-select-container .react-select__control:focus,.form-field--invalid .react-select-container .react-select__control:hover,.form-field--invalid .toggle-control--checkbox .toggle-control__control:focus,.form-field--invalid .toggle-control--checkbox .toggle-control__control:hover,.form-field--invalid .toggle-control--radio .toggle-control__control:focus,.form-field--invalid .toggle-control--radio .toggle-control__control:hover,.form-field--invalid [type=date]:focus,.form-field--invalid [type=date]:hover,.form-field--invalid [type=datetime-local]:focus,.form-field--invalid [type=datetime-local]:hover,.form-field--invalid [type=email]:focus,.form-field--invalid [type=email]:hover,.form-field--invalid [type=password]:focus,.form-field--invalid [type=password]:hover,.form-field--invalid [type=tel]:focus,.form-field--invalid [type=tel]:hover,.form-field--invalid [type=text]:focus,.form-field--invalid [type=text]:hover,.form-field--invalid select:focus,.form-field--invalid select:hover,.form-field--invalid textarea:focus,.form-field--invalid textarea:hover{background-color:#fff;border-color:#f24137}.form-field--max-width{max-width:31.25rem}";
styleInject(css_248z$i);

var FormField = function FormField(_ref) {
  var children = _ref.children,
      valid = _ref.valid,
      className = _ref.className,
      hasMaxWidth = _ref.hasMaxWidth,
      props = _objectWithoutProperties(_ref, ["children", "valid", "className", "hasMaxWidth"]);

  var classes = classnames("form-field", {
    "form-field--valid": valid,
    "form-field--invalid": valid != null && !valid,
    "form-field--max-width": hasMaxWidth
  }, className);
  return jsx("div", _extends({
    className: classes
  }, props), children);
};

FormField.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  valid: PropTypes.bool,
  className: PropTypes.string,
  hasMaxWidth: PropTypes.bool
};

var FormFieldValidation = function FormFieldValidation(_ref) {
  var list = _ref.list,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["list", "className"]);

  var classes = classnames("form-field-validation", className);

  var renderMessages = function renderMessages() {
    return list.map(function (validationItem, i) {
      var fieldId = validationItem.fieldId,
          valid = validationItem.valid,
          messageLabel = validationItem.messageLabel,
          message = validationItem.message;
      return jsx("div", {
        key: "".concat(fieldId, "-form-validation-").concat(i),
        className: "form-field-validation__item",
        role: "listitem"
      }, jsx(Alert, {
        type: valid ? "success" : "error",
        inline: true
      }, messageLabel), " ", jsx("span", {
        className: "form-field-validation__item-message"
      }, message));
    });
  };

  return jsx("div", _extends({
    className: classes,
    role: "list"
  }, props), renderMessages());
};

FormFieldValidation.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    fieldId: PropTypes.string,
    valid: PropTypes.bool,
    messageLabel: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
  })).isRequired,
  className: PropTypes.string
};

var css_248z$j = ".form-group{position:relative}.form-group:before{content:\"\";transition:all .1s ease-in-out;position:absolute;top:0;left:0;margin-top:0;margin-left:0;border:1px solid #b9b9b9;background-color:#e5e5e5;box-shadow:0 1px 6px 0 rgba(0,0,0,.16);z-index:0;opacity:0;width:100%;height:100%}.form-group__inner{position:relative}.form-group .button-group{display:block;position:relative}.form-group--has-focus{position:relative;z-index:1}.form-group--has-focus:before{opacity:1;width:calc(100% + 4rem);height:calc(100% + 4rem);margin-top:-2rem;margin-left:-2rem}.form-group--has-focus .button-group{display:block}";
styleInject(css_248z$j);

var timeoutID;

var FormGroup = /*#__PURE__*/function (_Component) {
  _inherits(FormGroup, _Component);

  var _super = _createSuper(FormGroup);

  function FormGroup(props) {
    var _this;

    _classCallCheck(this, FormGroup);

    _this = _super.call(this, props);
    _this.handleOnBlur = _this.handleOnBlur.bind(_assertThisInitialized(_this));
    _this.handleOnFocus = _this.handleOnFocus.bind(_assertThisInitialized(_this));
    _this.formGroupRef = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(FormGroup, [{
    key: "handleOnBlur",
    value: function handleOnBlur(e) {
      var _this2 = this;

      var onFocusBlur = this.props.onFocusBlur;
      timeoutID = setTimeout(function () {
        if (!_this2.formGroupRef.current.contains(e.relatedTarget)) {
          if (!_this2.formGroupRef.current.isEqualNode(e.relatedTarget)) {
            onFocusBlur(null);
          }
        }
      }, 0);
    }
  }, {
    key: "handleOnFocus",
    value: function handleOnFocus() {
      var _this$props = this.props,
          focusedFormGroup = _this$props.focusedFormGroup,
          id = _this$props.id,
          onFocusBlur = _this$props.onFocusBlur;
      var isManagingFocus = focusedFormGroup === id;
      clearTimeout(timeoutID);

      if (!isManagingFocus) {
        onFocusBlur(id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          canSubmit = _this$props2.canSubmit,
          focusedFormGroup = _this$props2.focusedFormGroup,
          id = _this$props2.id;
      var classes = classnames("form-group", {
        "form-group--has-focus": focusedFormGroup === id
      }, className);
      return jsx("div", {
        tabIndex: "-1",
        className: classes,
        ref: this.formGroupRef,
        onFocus: this.handleOnFocus,
        onBlur: this.handleOnBlur
      }, jsx("div", {
        className: "form-group__inner u-margin-bottom-2"
      }, children), jsx(ButtonGroup, null, jsx(ButtonGroupRow, {
        buttonAlignment: "space-between"
      }, jsx(Button, {
        text: "Cancel",
        variant: "link",
        onClick: function onClick() {}
      }), jsx(Button, {
        text: "Save",
        variant: "primary",
        disabled: !canSubmit,
        onClick: function onClick() {}
      }))));
    }
  }]);

  return FormGroup;
}(Component);

FormGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  canSubmit: PropTypes.bool.isRequired,
  focusedFormGroup: PropTypes.string,
  id: PropTypes.string.isRequired,
  onFocusBlur: PropTypes.func.isRequired
};

var css_248z$k = ".hamburger{width:1rem;height:.9375rem;position:relative}.hamburger__stroke{width:100%;height:.1875rem;background-color:#000;position:absolute;top:0;left:0;transform-origin:center;transition:.3s ease-in-out}.hamburger__stroke:first-child{top:0}.hamburger__stroke:nth-child(2){top:.375rem;opacity:1}.hamburger__stroke:nth-child(3){top:.75rem}.hamburger--is-active .hamburger__stroke:first-child{transform:rotate(45deg);top:.375rem}.hamburger--is-active .hamburger__stroke:nth-child(2){opacity:0}.hamburger--is-active .hamburger__stroke:nth-child(3){transform:rotate(-45deg);top:.375rem}";
styleInject(css_248z$k);

var Hamburger = function Hamburger(_ref) {
  var isActive = _ref.isActive,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["isActive", "className"]);

  var classes = classnames("hamburger", {
    "hamburger--is-active": isActive
  }, className);
  return jsx("div", _extends({
    className: classes
  }, props), jsx("div", {
    className: "hamburger__stroke"
  }), jsx("div", {
    className: "hamburger__stroke"
  }), jsx("div", {
    className: "hamburger__stroke"
  }));
};

Hamburger.propTypes = {
  isActive: PropTypes.bool.isRequired,
  className: PropTypes.string
};

var css_248z$l = ".icon-button{display:inline-block;color:#3c3c3c;transition:all .1s ease-in-out;vertical-align:middle}.icon-button:focus,.icon-button:hover{color:#4a4a4a}.icon-button:active{color:#0a0a0a}.icon-button__text{position:absolute!important;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.icon-button svg{width:2rem;height:2rem;color:currentColor;fill:currentColor;display:block}.icon-button--small svg{width:1rem;height:1rem}.icon-button--large svg{width:3rem;height:3rem}";
styleInject(css_248z$l);

var IconButton = function IconButton(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      icon = _ref.icon,
      size = _ref.size,
      newWindow = _ref.newWindow,
      className = _ref.className,
      text = _ref.text,
      props = _objectWithoutProperties(_ref, ["href", "onClick", "icon", "size", "newWindow", "className", "text"]);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    onClick();
  };

  var classes = classnames("icon-button", "icon-button--".concat(size), className);
  var targetProps = newWindow ? {
    target: "_blank",
    rel: "noopener noreferrer"
  } : {};
  return jsx("a", _extends({
    href: href,
    onClick: onClick ? handleClick : null,
    className: classes
  }, targetProps, props), jsx("span", {
    className: "icon-button__text"
  }, text), icon);
};

IconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  newWindow: PropTypes.bool,
  className: PropTypes.string
};
IconButton.defaultProps = {
  href: "#",
  size: "medium"
};

var css_248z$m = "@-webkit-keyframes loading-dots{10%{background:#b9b9b9;border-radius:50%;transform:rotate(0deg) scale(.85)}15%{background:#c80000;border-radius:0;transform:rotate(90deg) scale(1)}20%{transform:rotate(80deg)}45%{background:#b9b9b9;border-radius:50%;transform:rotate(180deg) scale(.85)}}@keyframes loading-dots{10%{background:#b9b9b9;border-radius:50%;transform:rotate(0deg) scale(.85)}15%{background:#c80000;border-radius:0;transform:rotate(90deg) scale(1)}20%{transform:rotate(80deg)}45%{background:#b9b9b9;border-radius:50%;transform:rotate(180deg) scale(.85)}}.loading-dots{white-space:nowrap;text-align:center}.loading-dot{width:1rem;height:1rem;background:#b9b9b9;border-radius:50%;transform:rotate(0deg) scale(.85);-webkit-animation:loading-dots 2.5s linear infinite;animation:loading-dots 2.5s linear infinite;-webkit-animation-delay:.4s;animation-delay:.4s;display:inline-block;margin-right:.5rem}.loading-dot:nth-child(2){-webkit-animation-delay:.8s;animation-delay:.8s}.loading-dot:nth-child(3){-webkit-animation-delay:1.2s;animation-delay:1.2s}.loading-dot:nth-child(4){-webkit-animation-delay:1.6s;animation-delay:1.6s}";
styleInject(css_248z$m);

var LoadingDots = function LoadingDots(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var classes = classnames("loading-dots", className);
  return jsx("div", _extends({
    className: classes
  }, props), jsx("div", {
    className: "loading-dot"
  }), jsx("div", {
    className: "loading-dot"
  }), jsx("div", {
    className: "loading-dot"
  }), jsx("div", {
    className: "loading-dot"
  }));
};

LoadingDots.propTypes = {
  /**
   * Optional className to append to the outer container
   */
  className: PropTypes.string
};

var css_248z$n = ".link-list{margin:0;padding:0;list-style:none}.link-list li{padding-left:0;margin-bottom:0}.link-list li:before{display:none}.link-list li:not(:last-child){margin-bottom:.5rem}";
styleInject(css_248z$n);

var LinkList = function LinkList(_ref) {
  var heading = _ref.heading,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["heading", "className", "children"]);

  var classes = classnames("link-list", className);
  return jsx("div", _extends({
    className: classes
  }, props), heading && jsx("h3", {
    className: "h600 u-margin-bottom-1"
  }, heading), jsx("ul", null, children));
};

LinkList.propTypes = {
  heading: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var LinkListItem = function LinkListItem(_ref) {
  var text = _ref.text,
      to = _ref.to,
      onClick = _ref.onClick,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["text", "to", "onClick", "icon", "iconPosition", "className"]);

  return jsx("li", _extends({
    className: className
  }, props), jsx(Button, {
    textAlignment: "left",
    text: text,
    variant: "link",
    to: to,
    onClick: onClick,
    icon: icon,
    iconPosition: iconPosition
  }));
};

LinkListItem.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.func,
  iconPosition: PropTypes.string
};

var css_248z$o = "@-webkit-keyframes modalIn{0%{transform:scale(.9);opacity:0}to{transform:scale(1);opacity:1}}@keyframes modalIn{0%{transform:scale(.9);opacity:0}to{transform:scale(1);opacity:1}}@-webkit-keyframes modalOverlayIn{0%{opacity:.5}to{opacity:1}}@keyframes modalOverlayIn{0%{opacity:.5}to{opacity:1}}body.modal-open{overflow:hidden}.modal-container{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999}.modal__outer{height:100%}.modal-overlay{display:none}.modal{position:relative;z-index:2;height:100%;background:#fff;box-shadow:0 4px 24px rgba(0,0,0,.32);-webkit-animation:modalIn .3s ease-out both;animation:modalIn .3s ease-out both;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between}.modal,.modal__inner{display:-ms-flexbox;display:flex}.modal__inner{padding:1rem;overflow-y:auto;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;-ms-flex-direction:column;flex-direction:column;-webkit-overflow-scrolling:touch}.modal__close-bar{-ms-flex:none;flex:none;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:end;justify-content:flex-end;padding-bottom:1rem}.modal__content{max-width:37rem;margin-left:auto;margin-right:auto;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;width:100%}.modal__actions{-ms-flex:none;flex:none;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;padding-top:1rem}.modal__action--right{margin-left:auto}@media screen and (min-width:48em){.modal__outer{position:relative;width:100vw;overflow:auto}.modal{margin:3rem;min-height:calc(100vh - 6rem);height:auto}.modal--full-screen{margin:0;min-height:100vh}.modal__close-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:end;justify-content:flex-end;padding-bottom:2rem}.modal__inner{padding:3rem}.modal__actions{padding-top:3rem}.modal-overlay{display:block;appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;font-family:avenir,Helvetica,Arial,sans-serif;padding:0;text-align:initial;text-indent:.01px;text-overflow:\"\";text-decoration:none;font-size:inherit;cursor:default;background:hsla(0,0%,54.5%,.8);width:100vw;height:100vh;z-index:998;position:fixed;top:0;left:0;-webkit-animation:modalOverlayIn .3s ease-out;animation:modalOverlayIn .3s ease-out}}";
styleInject(css_248z$o);

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);
    _this.handleOnEscape = _this.handleOnEscape.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleOnEscape, false);
      document.body.classList.toggle("modal-open");
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleOnEscape);
      document.body.classList.remove("modal-open");
    }
  }, {
    key: "handleOnEscape",
    value: function handleOnEscape(e) {
      var closeModal = this.props.closeModal;

      if (e.keyCode === 27) {
        closeModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          closeModal = _this$props.closeModal,
          buttonLeft = _this$props.buttonLeft,
          buttonRight = _this$props.buttonRight,
          closeLinkText = _this$props.closeLinkText,
          containerRef = _this$props.containerRef,
          role = _this$props.role,
          fullScreen = _this$props.fullScreen,
          className = _this$props.className;
      var hasActions = buttonLeft || buttonRight;
      var classes = classnames("modal", {
        "modal--has-actions": hasActions,
        "modal--full-screen": fullScreen
      }, className);
      return jsx(Fragment, null, jsx("button", {
        type: "button",
        tabIndex: "-1",
        className: "modal-overlay",
        onClick: closeModal
      }), jsx("div", {
        className: "modal-container"
      }, jsx("div", {
        className: "modal__outer",
        ref: containerRef
      }, jsx("div", {
        className: classes,
        "aria-modal": "true",
        role: role
      }, jsx(FocusLock, {
        returnFocus: true,
        className: "modal__inner"
      }, closeLinkText && jsx("div", {
        className: "modal__close-bar"
      }, jsx(Button, {
        text: closeLinkText,
        icon: Svg16Px$8,
        iconPosition: "right",
        variant: "link",
        className: "modal__close",
        onClick: closeModal,
        "aria-label": "Close Modal"
      })), jsx("div", {
        className: "modal__content"
      }, children), hasActions && jsx("div", {
        className: "modal__actions"
      }, buttonLeft && jsx("div", {
        className: "modal__action--left"
      }, buttonLeft), buttonRight && jsx("div", {
        className: "modal__action--right"
      }, buttonRight)))))));
    }
  }]);

  return Modal;
}(Component);

Modal.defaultProps = {
  role: "dialog"
};
Modal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  buttonLeft: PropTypes.node,
  buttonRight: PropTypes.node,
  closeLinkText: PropTypes.string,
  containerRef: PropTypes.shape({}),
  role: PropTypes.string,
  fullScreen: PropTypes.bool,
  className: PropTypes.string
};

var css_248z$p = ".nav-bar{position:fixed;top:0;left:0;width:100%;z-index:20;background-color:#fff;border-bottom:1px solid #e5e5e5;height:4.125rem;-ms-flex-align:center;align-items:center}.nav-bar,.nav-bar__inner{display:-ms-flexbox;display:flex}.nav-bar__inner{-ms-flex:1;flex:1;padding:0 1rem;-ms-flex-pack:justify;justify-content:space-between}@media screen and (min-width:64em){.nav-bar{display:none}}.nav-bar__menu-btn{appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;padding:0;text-align:initial;text-indent:.01px;text-overflow:\"\";text-decoration:none;font-size:inherit;font-family:avenir,Helvetica,Arial,sans-serif;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:1rem;color:#000}.nav-bar__menu-btn .hamburger{margin-right:1rem}.nav-bar__links li{padding-left:0;margin-bottom:0;display:inline-block}.nav-bar__links li:before{display:none}.nav-bar__links-item-btn{appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;text-align:initial;text-indent:.01px;text-overflow:\"\";text-decoration:none;font-size:inherit;font-family:avenir,Helvetica,Arial,sans-serif;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column;font-size:.76923rem;color:#000;padding:0 1rem}li:last-child .nav-bar__links-item-btn{margin-right:-1rem}.nav-bar__links-item-btn-icon{width:1rem;height:1rem;margin-bottom:.5rem}";
styleInject(css_248z$p);

var NavBar = function NavBar(_ref) {
  var menuDrawOpen = _ref.menuDrawOpen,
      menu = _ref.menu,
      onMenuClick = _ref.onMenuClick,
      links = _ref.links,
      onLinkClick = _ref.onLinkClick;
  return jsx("div", {
    className: "nav-bar"
  }, jsx("div", {
    className: "nav-bar__inner"
  }, jsx(BaseButton, {
    id: "nav-bar-button",
    className: "nav-bar__menu-btn",
    onClick: onMenuClick
  }, menu.icon && menu.icon({
    isActive: menuDrawOpen
  }), menu.text), jsx("ul", {
    className: "nav-bar__links"
  }, links.map(function (link, i) {
    return jsx("li", {
      key: i
    }, jsx(BaseAnchor, {
      className: "nav-bar__links-item-btn",
      to: link.to,
      onClick: onLinkClick
    }, link.icon && link.icon({
      className: "nav-bar__links-item-btn-icon"
    }), link.text));
  }))));
};

NavBar.propTypes = {
  menu: PropTypes.shape({
    text: PropTypes.string.isRequired,
    icon: PropTypes.func
  }).isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    icon: PropTypes.func,
    to: PropTypes.string.isRequired
  })),
  menuDrawOpen: PropTypes.bool,
  onMenuClick: PropTypes.func.isRequired,
  onLinkClick: PropTypes.func.isRequired
};

var css_248z$q = ".page-header{padding:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between}.page-header__content{position:relative;z-index:1;padding:2.5rem 0}.page-header__title{font-size:1rem;line-height:1.67;letter-spacing:.094em;text-transform:uppercase;font-weight:700}.page-header__title+.page-header__quote{margin-top:1.5rem}.page-header__quote{position:relative}.page-header__extra-content{padding-top:2rem;position:relative}.page-header--with-background{background:50% no-repeat;background-size:cover;min-height:32.5rem;position:relative}.page-header--with-background .page-header__quote,.page-header--with-background .page-header__title{color:#fff;z-index:1}.page-header--with-background .page-header__background-overlay{background:linear-gradient(90deg,rgba(0,0,0,.75),transparent);position:absolute;top:0;left:0;bottom:0;right:0;z-index:0}";
styleInject(css_248z$q);

var getBackgroundCssFromRenditions = function getBackgroundCssFromRenditions(backgroundImages) {
  var defaultImage = backgroundImages.find(function (image) {
    return !image.minWidth || !image.maxWidth;
  });
  var mqs = backgroundImages.filter(function (image) {
    return !!image.minWidth || !!image.maxWidth;
  }).reduce(function (images, image) {
    var minWidth = image.minWidth,
        maxWidth = image.maxWidth,
        src = image.src;
    var mq = [];
    if (minWidth) mq.push("(min-width: ".concat(minWidth, "px)"));
    if (maxWidth) mq.push("(max-width: ".concat(maxWidth, "px)"));
    var mqString = "@media screen and ".concat(mq.join(" and "));
    return _objectSpread2(_objectSpread2({}, images), {}, _defineProperty({}, mqString, {
      backgroundImage: "url(\"".concat(src, "\")")
    }));
  }, {});
  return _objectSpread2({
    backgroundImage: defaultImage ? "url(\"".concat(defaultImage.src, "\")") : null
  }, mqs);
};

var PageHeader = function PageHeader(_ref) {
  var pageTitle = _ref.pageTitle,
      quote = _ref.quote,
      backgroundImages = _ref.backgroundImages,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["pageTitle", "quote", "backgroundImages", "className", "children"]);

  var withBackground = !!backgroundImages && backgroundImages.length;
  var classes = classnames("page-header", {
    "page-header--with-background": withBackground
  }, className);
  return jsx("div", _extends({
    className: classes,
    css: withBackground ? getBackgroundCssFromRenditions(backgroundImages) : {}
  }, props), !!withBackground && jsx("div", {
    className: "page-header__background-overlay"
  }), jsx("header", {
    className: "page-header__content"
  }, jsx("div", {
    className: "grid-container fluid"
  }, jsx("div", {
    className: "cell"
  }, jsx("h1", {
    className: "u-content-container-medium"
  }, pageTitle && jsx("div", {
    className: "page-header__title"
  }, pageTitle), quote && jsx("div", {
    className: "page-header__quote u-font-heading h500"
  }, jsx("div", {
    className: "page-header__quote-inner"
  }, quote)))))), children && jsx("div", {
    className: "page-header__extra-content"
  }, jsx("div", {
    className: "grid-container fluid"
  }, jsx("div", {
    className: "cell"
  }, children))));
};

PageHeader.propTypes = {
  /**
   * Custom className to add to the component
   */
  className: PropTypes.string,

  /**
   * Line of text to be added at the top as an overheading
   */
  pageTitle: PropTypes.string,

  /**
   * Large font message
   */
  quote: PropTypes.string,

  /**
   * Background images
   */
  backgroundImages: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number
  })),

  /**
   * Content to be rendered beneath the text
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var css_248z$r = ".panel{border-radius:.3125rem;background:#f2f2f2;border:1px solid #f2f2f2;padding:1.75rem 2rem}.panel--info{background-color:#dcf0fa;border-color:#64c8fa}.panel--success{background-color:#dcf0dc;border-color:#8cc84b}.panel--warning{background-color:#fffac8;border-color:#ffde0a}.panel--error{background-color:#fe9898;border-color:#f24137}";
styleInject(css_248z$r);

var Panel = function Panel(_ref) {
  var children = _ref.children,
      type = _ref.type,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "type", "className"]);

  var classNames = classnames("panel", {
    "panel--info": type === "info",
    "panel--success": type === "success",
    "panel--warning": type === "warning",
    "panel--error": type === "error"
  }, className);
  return jsx("div", _extends({
    className: classNames
  }, props), children);
};

Panel.propTypes = {
  type: PropTypes.oneOf(["info", "success", "warning", "error"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
};

var css_248z$s = "@-webkit-keyframes fadeInPopupDown{0%{opacity:0;transform:translateY(-1rem)}to{opacity:1;transform:translateY(0)}}@keyframes fadeInPopupDown{0%{opacity:0;transform:translateY(-1rem)}to{opacity:1;transform:translateY(0)}}@-webkit-keyframes fadeInPopupUp{0%{opacity:0;transform:translateY(1rem)}to{opacity:1;transform:translateY(0)}}@keyframes fadeInPopupUp{0%{opacity:0;transform:translateY(1rem)}to{opacity:1;transform:translateY(0)}}.popup{z-index:100;position:absolute;max-width:20rem;display:block}.popup[data-placement=top]{top:-1rem!important}.popup[data-placement=bottom]{top:1rem!important}.popup__inner{padding:1.5rem 2rem;background:#fff;box-shadow:0 4px 24px rgba(0,0,0,.32);opacity:1}.popup--has-close-button .popup__inner{padding-top:2.5rem;padding-bottom:2rem}[data-placement=top] .popup__inner{-webkit-animation:fadeInPopupDown .2s ease-out;animation:fadeInPopupDown .2s ease-out}[data-placement=bottom] .popup__inner{-webkit-animation:fadeInPopupUp .2s ease-out;animation:fadeInPopupUp .2s ease-out}.popup__arrow{position:absolute;height:1rem;width:1rem;border:.5rem solid}[data-placement=top] .popup__arrow{bottom:-1rem!important;border-color:#fff transparent transparent}[data-placement=bottom] .popup__arrow{top:-1rem!important;border-color:transparent transparent #fff}.popup-trigger{cursor:pointer;overflow:hidden;padding:0;background:none;border:none}.popup-trigger--open,.popup-trigger:focus,.popup-trigger:hover{color:#c80000}.popup-trigger__icon{width:1rem;height:1rem}.popup__close-button{appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;font-family:avenir,Helvetica,Arial,sans-serif;padding:0;text-align:initial;text-indent:.01px;text-overflow:\"\";text-decoration:none;font-size:inherit;position:absolute;top:1rem;right:1rem}";
styleInject(css_248z$s);

var PopupManager = /*#__PURE__*/function (_PureComponent) {
  _inherits(PopupManager, _PureComponent);

  var _super = _createSuper(PopupManager);

  function PopupManager(props) {
    var _this;

    _classCallCheck(this, PopupManager);

    _this = _super.call(this, props);
    _this.handleOnEscape = _this.handleOnEscape.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.scheduleUpdate = null;
    _this.popupInner = /*#__PURE__*/React__default.createRef();
    return _this;
  }

  _createClass(PopupManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleOnEscape, false);
      document.addEventListener("mousedown", this.handleClick, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var children = this.props.children;

      if (prevProps.children !== children && this.scheduleUpdate) {
        this.scheduleUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleOnEscape, false);
      document.removeEventListener("mousedown", this.handleClick, false);
    }
  }, {
    key: "handleOnEscape",
    value: function handleOnEscape(e) {
      var _this$props = this.props,
          showPopup = _this$props.showPopup,
          closePopup = _this$props.closePopup;

      if (showPopup && e.keyCode === 27) {
        closePopup();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var showPopup = this.props.showPopup;

      if (showPopup && this.popupInner.current && !this.popupInner.current.contains(e.target)) {
        var closePopup = this.props.closePopup;
        setTimeout(closePopup, 200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          showPopup = _this$props2.showPopup,
          handleTogglePopup = _this$props2.handleTogglePopup,
          className = _this$props2.className,
          position = _this$props2.position,
          CustomTrigger = _this$props2.CustomTrigger,
          showCloseButton = _this$props2.showCloseButton;
      var popupSettings = {
        preventOverflow: {
          padding: 24
        }
      };
      return jsx(Manager, null, jsx(Reference, null, function (_ref) {
        var ref = _ref.ref;
        var triggerClasses = classnames("popup-trigger", className, {
          "popup-trigger--open": showPopup
        });

        if (CustomTrigger) {
          return jsx(CustomTrigger, {
            forwardedRef: ref,
            className: triggerClasses,
            onClick: handleTogglePopup
          });
        }

        var arrowIcon = position === "top" ? jsx(Svg16Px$7, {
          className: "popup-trigger__icon"
        }) : jsx(Svg16Px$4, {
          className: "popup-trigger__icon"
        });
        return jsx("button", {
          type: "button",
          ref: ref,
          className: triggerClasses,
          onClick: handleTogglePopup
        }, !showPopup ? arrowIcon : jsx(Svg16Px$8, {
          className: "popup-trigger__icon"
        }));
      }), showPopup && jsx(Popper, {
        placement: position,
        modifiers: popupSettings
      }, function (_ref2) {
        var ref = _ref2.ref,
            style = _ref2.style,
            placement = _ref2.placement,
            arrowProps = _ref2.arrowProps,
            scheduleUpdate = _ref2.scheduleUpdate;
        _this2.scheduleUpdate = scheduleUpdate;
        var classes = classnames("popup", {
          "popup--has-close-button": showCloseButton
        });
        return jsx("div", {
          ref: ref,
          className: classes,
          style: style,
          "data-placement": placement
        }, jsx("div", {
          className: "popup__inner",
          ref: _this2.popupInner
        }, showCloseButton && jsx("button", {
          className: "popup__close-button",
          onClick: handleTogglePopup
        }, jsx(Svg16Px$8, {
          className: "popup-trigger__icon"
        })), children, jsx("div", {
          className: "popup__arrow",
          ref: arrowProps.ref,
          style: arrowProps.style
        })));
      }));
    }
  }]);

  return PopupManager;
}(PureComponent);

PopupManager.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  showPopup: PropTypes.bool.isRequired,
  handleTogglePopup: PropTypes.func.isRequired,
  closePopup: PropTypes.func.isRequired,
  className: PropTypes.string,
  position: PropTypes.string.isRequired,
  CustomTrigger: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  showCloseButton: PropTypes.bool
};
PopupManager.defaultProps = {
  className: ""
};

var css_248z$t = ".preference-card__inner{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between}.preference-card__title{margin-bottom:1rem}.preference-card__content{-ms-flex-positive:1;flex-grow:1}.preference-card__loading{height:1.8rem}.preference-card__loading,.preference-card__tabs{margin-top:1rem;-ms-flex-item-align:end;align-self:flex-end}.preference-card__error{margin-top:2rem}@media screen and (min-width:28.75em){.preference-card__inner{-ms-flex-direction:row;flex-direction:row}.preference-card__loading,.preference-card__tabs{margin:0 0 0 2rem;-ms-flex-item-align:start;align-self:flex-start}}";
styleInject(css_248z$t);

var css_248z$u = ".tab-dropdown{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.tab-dropdown__button:after{width:.5rem;content:\"\"}.tab-dropdown__button:hover+.popup-trigger{color:#c80000}.tab-dropdown__item{padding-left:0;margin-bottom:1rem}.tab-dropdown__item:before{display:none}.tab-dropdown__item:last-of-type{margin-bottom:0}.tab-bar__items{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.tab-bar__item{padding-left:0;margin-bottom:0;margin-right:1.5rem}.tab-bar__item:before{display:none}.tab-bar__item:last-of-type{margin-right:0}.tab-bar__link{color:#2d2d2d;font-weight:700}@media screen and (max-width:63.99875em){.tab-bar{display:none}}@media screen and (min-width:48em){.tab-dropdown{display:none}.tab-bar{display:block}}";
styleInject(css_248z$u);

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);
    _this.state = {
      showPopup: false
    };
    _this.handleTogglePopup = _this.handleTogglePopup.bind(_assertThisInitialized(_this));
    _this.closePopup = _this.closePopup.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "closePopup",
    value: function closePopup() {
      this.setState({
        showPopup: false
      });
    }
  }, {
    key: "handleTogglePopup",
    value: function handleTogglePopup() {
      var showPopup = this.state.showPopup;
      this.setState({
        showPopup: !showPopup
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var showPopup = this.state.showPopup;

      var _this$props = this.props,
          onTabLinkClick = _this$props.onTabLinkClick,
          tabs = _this$props.tabs,
          noSelectedTabLabel = _this$props.noSelectedTabLabel,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["onTabLinkClick", "tabs", "noSelectedTabLabel", "className"]);

      var selectedTab = tabs.find(function (tab) {
        return tab.selected === true;
      });

      var handleTabClick = function handleTabClick(tabId) {
        onTabLinkClick(tabId);

        _this2.closePopup();
      };

      return jsx("nav", _extends({
        className: className
      }, props), jsx("div", {
        className: "tab-dropdown"
      }, jsx(Button, {
        id: "TabDropdownOpener",
        text: selectedTab ? selectedTab.label : noSelectedTabLabel,
        variant: "link",
        onClick: this.handleTogglePopup,
        active: showPopup,
        className: "tab-dropdown__button"
      }), jsx(PopupManager, {
        className: "tab-dropdown__arrow",
        showPopup: showPopup,
        handleTogglePopup: this.handleTogglePopup,
        closePopup: this.closePopup,
        position: "bottom"
      }, jsx("ul", {
        className: "tab-dropdown__items"
      }, tabs.map(function (tab) {
        return jsx("li", {
          className: "tab-dropdown__item",
          key: tab.id
        }, jsx(Button, {
          text: tab.label,
          variant: "nav",
          onClick: function onClick() {
            handleTabClick(tab.id);
          },
          className: "tab-dropdown__link",
          active: tab.selected
        }));
      })))), jsx("div", {
        className: "tab-bar"
      }, jsx("ul", {
        className: "tab-bar__items"
      }, tabs.map(function (tab) {
        return jsx("li", {
          className: "tab-bar__item",
          key: tab.id
        }, jsx(Button, {
          text: tab.label,
          variant: "nav",
          onClick: function onClick() {
            handleTabClick(tab.id);
          },
          className: "tab-bar__link",
          active: tab.selected
        }));
      }))));
    }
  }]);

  return Tabs;
}(Component);

Tabs.defaultProps = {
  noSelectedTabLabel: "Select...",
  className: ""
};
Tabs.propTypes = {
  className: PropTypes.string,
  onTabLinkClick: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.bool.isRequired]),
    label: PropTypes.string.isRequired
  })).isRequired,
  noSelectedTabLabel: PropTypes.string
};

var PreferenceCard = function PreferenceCard(_ref) {
  var heading = _ref.heading,
      children = _ref.children,
      trueLabel = _ref.trueLabel,
      falseLabel = _ref.falseLabel,
      loading = _ref.loading,
      toggleValue = _ref.toggleValue,
      hideToggle = _ref.hideToggle,
      handleToggle = _ref.handleToggle,
      error = _ref.error,
      errorTitle = _ref.errorTitle,
      errorMessage = _ref.errorMessage,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["heading", "children", "trueLabel", "falseLabel", "loading", "toggleValue", "hideToggle", "handleToggle", "error", "errorTitle", "errorMessage", "className"]);

  var tabs = [{
    id: false,
    label: falseLabel,
    selected: toggleValue === false
  }, {
    id: true,
    label: trueLabel,
    selected: toggleValue === true
  }];
  return jsx(Card, _extends({
    className: classnames("preference-card", className)
  }, rest), jsx("div", {
    className: "preference-card__inner"
  }, jsx("div", {
    className: "preference-card__content"
  }, jsx("div", {
    className: "u-content-container-medium"
  }, heading && jsx("h4", {
    className: "preference-card__title h700"
  }, heading), children, jsx("div", {
    className: "preference-card__error",
    style: {
      display: error ? "block" : "none"
    }
  }, jsx(BodyCopy, null, jsx(Alert, {
    type: "error",
    inline: true
  }, errorTitle), !!errorMessage && errorMessage)))), !hideToggle && (loading ? jsx(LoadingDots, {
    className: "preference-card__loading"
  }) : jsx(Tabs, {
    className: "preference-card__tabs",
    tabs: tabs,
    onTabLinkClick: function onTabLinkClick(tabId) {
      return handleToggle(tabId);
    }
  }))));
};

PreferenceCard.propTypes = {
  heading: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node), PropTypes.objectOf(PropTypes.node)]),
  trueLabel: PropTypes.string,
  falseLabel: PropTypes.string,
  hideToggle: PropTypes.bool,
  handleToggle: PropTypes.func.isRequired,
  toggleValue: PropTypes.bool.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.objectOf(PropTypes.node)]),
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.arrayOf(PropTypes.node), PropTypes.objectOf(PropTypes.node)])
};
PreferenceCard.defaultProps = {
  errorTitle: "Oops!",
  trueLabel: "Yes",
  falseLabel: "No"
};

var css_248z$v = "@-webkit-keyframes fadeInOpacity{0%{opacity:0}to{opacity:1}}@keyframes fadeInOpacity{0%{opacity:0}to{opacity:1}}.progress-indicator{margin:0 auto;max-width:100%;width:15.25rem;height:.25rem;position:relative}.progress-indicator__line{position:absolute;width:100%;height:100%;top:0;left:0;z-index:1;overflow:hidden;border-radius:8px}.progress-indicator__line-inner{background-color:#c80000;transition:transform .2s ease-in-out;transform-origin:0 0;height:100%}.progress-indicator__list{list-style:none;display:-ms-flexbox;display:flex;margin:0;padding:0}.progress-indicator__list-item{-ms-flex:1;flex:1;background:#e5e5e5;position:relative;height:.25rem;margin:0 .25rem}.progress-indicator__list-item:first-child{border-top-left-radius:8px;border-bottom-left-radius:8px;margin-left:0}.progress-indicator__list-item:last-child{border-top-right-radius:8px;border-bottom-right-radius:8px;margin-right:0}.progress-indicator__list-item.is-active{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.progress-indicator__list-item.is-active:after{content:\"\";display:block;background-color:#fff;border:3px solid #c80000;border-radius:50%;width:.75rem;height:.75rem;box-sizing:border-box;-ms-flex:none;flex:none;-webkit-animation-name:fadeInOpacity;animation-name:fadeInOpacity;-webkit-animation-iteration-count:1;animation-iteration-count:1;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;-webkit-animation-duration:.15s;animation-duration:.15s;position:relative;z-index:1;margin-right:-.625rem}";
styleInject(css_248z$v);

var ProgressIndicator = function ProgressIndicator(_ref) {
  var className = _ref.className,
      currentStep = _ref.currentStep,
      totalSteps = _ref.totalSteps;
  var classes = classnames("progress-indicator", className);
  var scale = "scaleX(".concat(currentStep / totalSteps, ")");
  return jsx("div", {
    className: classes
  }, jsx("span", {
    className: "show-for-sr progress-bar__status-txt"
  }, "Your current progress: step ", currentStep, " of ", totalSteps), jsx("div", {
    className: "progress-indicator__line"
  }, jsx("div", {
    className: "progress-indicator__line-inner",
    style: {
      transform: scale
    }
  })), jsx("ol", {
    className: "progress-indicator__list",
    "aria-hidden": "true"
  }, Array.from(Array(totalSteps)).map(function (item, i) {
    var step = i + 1;
    var itemClasses = classnames("progress-indicator__list-item", {
      "is-active": step === currentStep
    });
    return jsx("li", {
      key: i,
      className: itemClasses
    }, jsx("span", {
      className: "hide"
    }, "Section ", step));
  })));
};

ProgressIndicator.propTypes = {
  className: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
};

var css_248z$w = ".toggle-control--radio input:focus+.toggle-control__control{border-color:#b9b9b9}.toggle-control--radio .toggle-control__control{border:2px solid #e5e5e5;height:1.5rem;width:1.5rem;border-radius:2rem}.toggle-control--radio .toggle-control__control:after{position:absolute;top:0;left:0;width:100%;height:100%;background:transparent;content:\"\";border-radius:2rem;border:.2rem solid #fafafa;transition:all .1s ease-out;transform:scale(0)}.toggle-control--radio.toggle-control--checked .toggle-control__control:after{background:#c80000;transform:scale(1)}@media screen and (min-width:64em){.toggle-control--radio .toggle-control__control{height:2rem;width:2rem;border-radius:2rem;margin-right:1rem}}";
styleInject(css_248z$w);

var RadioButton = function RadioButton(props) {
  return jsx(ToggleControl, _extends({
    type: "radio"
  }, props));
};

RadioButton.propTypes = ToggleControlPropTypes;

var css_248z$x = ".toggle-control-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:stretch;justify-content:stretch}.toggle-control-group .toggle-control{margin-bottom:1rem}.toggle-control-group .toggle-control:last-child{margin-bottom:0}@media screen and (min-width:28.75em){.toggle-control-group--inline{-ms-flex-direction:row;flex-direction:row}.toggle-control-group--inline .toggle-control{margin:0 1rem 0 0;-ms-flex:1 1 auto;flex:1 1 auto}.toggle-control-group--inline .toggle-control:last-child{margin:0}.toggle-control-group--inline .toggle-control__label{font-size:1.25rem;line-height:1.2;font-weight:700}}";
styleInject(css_248z$x);

var ToggleControlGroup = function ToggleControlGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      inline = _ref.inline,
      rest = _objectWithoutProperties(_ref, ["children", "className", "inline"]);

  var classes = classnames("toggle-control-group", {
    "toggle-control-group--list": !inline,
    "toggle-control-group--inline": inline
  }, className);
  return jsx("div", _extends({
    className: classes
  }, rest), children);
};

ToggleControlGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  inline: PropTypes.bool,
  className: PropTypes.string
};

var css_248z$y = ".show-hide-panel{z-index:auto;background:#fff;box-shadow:0 1px 6px 0 rgba(0,0,0,.16)}.show-hide-panel__content,.show-hide-panel__control{padding:1.25rem 1.5rem}.show-hide-panel__control{appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;font-family:avenir,Helvetica,Arial,sans-serif;text-align:initial;text-indent:.01px;text-overflow:\"\";text-decoration:none;font-size:inherit;padding:1.25rem 1.5rem;color:#2d2d2d;width:100%}.show-hide-panel__heading{font-size:1rem;font-weight:700}.show-hide-panel__status{font-size:1rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-top:1rem}.show-hide-panel__content{overflow:hidden;box-shadow:inset 0 8px 4px -6px rgba(0,0,0,.16)}.show-hide-panel__chevron{height:1rem;margin-left:.5rem;transform:scaleY(1);transition:transform .2s linear}.show-hide-panel--expanded .show-hide-panel__chevron{transform:scaleY(-1)}@media screen and (min-width:48em){.show-hide-panel__content,.show-hide-panel__control{padding:2.5rem 3rem}.show-hide-panel__control{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.show-hide-panel__status{margin:0 0 0 1rem}}";
styleInject(css_248z$y);

var ShowHidePanel = function ShowHidePanel(_ref) {
  var id = _ref.id,
      headingLevel = _ref.headingLevel,
      headingContent = _ref.headingContent,
      className = _ref.className,
      showLabel = _ref.showLabel,
      hideLabel = _ref.hideLabel,
      children = _ref.children,
      isExpanded = _ref.isExpanded;

  var _useState = useState(!!isExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var classes = classnames("show-hide-panel", {
    "show-hide-panel--expanded": expanded
  }, className);
  var controlId = "".concat(id, "-control");
  var panelId = "".concat(id, "-panel");
  var Heading = headingLevel;
  return jsx("div", {
    id: id,
    className: classes
  }, jsx(Heading, null, jsx("button", {
    id: controlId,
    "aria-controls": panelId,
    "aria-expanded": expanded ? "true" : "false",
    className: "show-hide-panel__control",
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, jsx("span", {
    className: "show-hide-panel__heading"
  }, headingContent), jsx("span", {
    className: "show-hide-panel__status"
  }, expanded ? hideLabel : showLabel, " ", jsx(Svg16Px$4, {
    className: "show-hide-panel__chevron"
  })))), expanded && jsx("div", {
    key: "content",
    id: panelId,
    className: "show-hide-panel__content",
    role: "region",
    "aria-labelledby": controlId
  }, children));
};

ShowHidePanel.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  headingLevel: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  headingContent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  showLabel: PropTypes.string.isRequired,
  hideLabel: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  isExpanded: PropTypes.bool
};

var css_248z$z = ".scroll-box__body{border:1px solid #e5e5e5;border-radius:5px 5px 0 0;max-height:36.25rem;position:relative;overflow:auto;z-index:1;background-repeat:no-repeat;background-color:#fafafa;background-image:radial-gradient(farthest-side at 50% 0,rgba(0,0,0,.16),transparent),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,.16),transparent);background-position:0 0,0 100%;background-size:100% 14px}.scroll-box__body:after,.scroll-box__body:before{content:\"\";position:relative;z-index:-1;display:block;height:30px;margin:0 0 -30px;background:linear-gradient(180deg,#fafafa,#fafafa 30%,hsla(0,0%,100%,0));-ms-flex:none;flex:none}.scroll-box__body:after{margin:-30px 0 0;background:linear-gradient(180deg,hsla(0,0%,100%,0),#fafafa 70%,#fafafa)}.scroll-box__body-inner{padding:3rem 2.5rem}.scroll-box__footer{background:#fff;border:1px solid #e5e5e5;border-top:none;padding:1.5rem;border-radius:0 0 5px 5px}.scroll-box .toggle-control__label{font-size:1.25rem;line-height:1.2;font-weight:700}.scroll-box--checked .scroll-box__body{background-color:#fff}.scroll-box--checked .scroll-box__body:before{background:linear-gradient(180deg,#fff,#fff 30%,hsla(0,0%,100%,0))}.scroll-box--checked .scroll-box__body:after{background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff 70%,#fff)}";
styleInject(css_248z$z);

var ScrollBox = function ScrollBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      checkbox = _ref.checkbox,
      checked = _ref.checked;
  var classes = classnames("scroll-box", {
    "scroll-box--checked": checked
  }, className);
  return jsx("div", {
    className: classes
  }, jsx("div", {
    className: "scroll-box__body"
  }, jsx("div", {
    className: "scroll-box__body-inner"
  }, children)), jsx("div", {
    className: "scroll-box__footer"
  }, checkbox));
};

ScrollBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  checkbox: PropTypes.instanceOf(Checkbox).isRequired,
  checked: PropTypes.bool.isRequired
};

var css_248z$A = ".react-select-container{font-size:1.25rem;line-height:1.2;font-weight:700}.react-select-container .react-select__control,.react-select-container .react-select__menu{width:100%}.react-select-container .react-select__option-icon{width:2rem;margin-right:1rem;vertical-align:middle}.react-select-container .react-select__control{border-radius:0;border:2px solid #e5e5e5;background-color:#fafafa;min-height:0;padding:1.25rem 1.5rem;box-shadow:none}.react-select-container .react-select__control:hover{border:2px solid #e5e5e5}.react-select-container .react-select__control.react-select__control--is-focused{border:2px solid #b9b9b9}.react-select-container .react-select__control.react-select__control--menu-is-open .react-select__dropdown-indicator{transform:scaleY(-1)}.react-select-container .react-select__placeholder+div,.react-select-container .react-select__single-value+div{padding:0;margin:0}.react-select-container .react-select__single-value{color:#000}.react-select-container .react-select__placeholder{color:#939393}.react-select-container .react-select__indicator,.react-select-container .react-select__value-container{padding:0}.react-select-container .react-select__indicator svg{width:2rem;height:2rem}.react-select-container .react-select__indicator-separator{display:none}.react-select-container .react-select__input{display:block}.react-select-container .react-select__menu{border-radius:0;margin:0;box-shadow:0 4px 24px rgba(0,0,0,.32);color:#000}.react-select-container .react-select__menu-list{padding:0}.react-select-container .react-select__option{padding:.75rem 1.25rem;transition:all .1s ease-in-out;font-weight:400}.react-select-container .react-select__option:last-child{border-bottom:0}.react-select-container .react-select__option:active{background:#d33333}.react-select-container .react-select__option--is-focused{background:#c80000;color:#fff}.react-select-container .react-select__option--is-focused:active{background-color:#c80000;color:#fff}.react-select-container .react-select__option--is-selected{background-color:#c80000;color:#fff;font-weight:700}.react-select-container .react-select__option--is-selected:active{background:#c80000;color:#fff}.react-select-container .react-select__group{padding:0}.react-select-container .react-select__group-heading{background-color:#3f3f3f;border-bottom:1px solid #e5e5e5;margin-bottom:0;padding:.5rem;color:#fff}.react-select-container .react-select__group-heading:empty{display:none}.react-select-container .react-select__multi-value{margin:1px 4px 1px 0;border-radius:5px}.react-select-container .react-select__multi-value__label{font-size:1.25rem;color:#2d2d2d;padding:.1875rem .75rem}.react-select-container .react-select__multi-value__remove{cursor:pointer}.react-select-container .react-select__multi-value__remove svg{width:1rem}.react-select--is-disabled .react-select__control{background-color:#e5e5e5}.react-select-container--has-jumplist .react-select__group:first-child{border-bottom:1px solid #e5e5e5}.react-select-container--has-jumplist .react-select__group{padding-top:1rem;padding-bottom:1rem}@media screen and (max-width:63.99875em){.native-select{display:block}.react-select-container{display:none}}@media screen and (min-width:48em){.native-select{display:none}.react-select-container{display:block}}";
styleInject(css_248z$A);

var renderOptions = function renderOptions(options, id) {
  return options.map(function (option) {
    if (option.options) {
      var groupName = "".concat(id, "_group_").concat(option.id ? option.id : option.label);
      return jsx("optgroup", {
        key: groupName,
        label: option.label
      }, renderOptions(option.options));
    }

    return jsx("option", {
      key: option.value,
      value: option.value
    }, option.label);
  });
};

var getNativeSafeValue = function getNativeSafeValue(value, multiple) {
  if (!value && multiple) {
    return [];
  }

  if (multiple) {
    return value.map(function (v) {
      return v.value;
    });
  }

  return value ? value.value : "";
};

var MultiValueRemove = function MultiValueRemove(props) {
  return jsx(components.MultiValueRemove, props, jsx(Svg16Px$8, null));
};

var _SingleValue = function SingleValue(_ref, isCountryCode) {
  var data = _ref.data,
      singleValueProps = _objectWithoutProperties(_ref, ["data"]);

  var value = data.value,
      label = data.label,
      icon = data.icon;

  if (isCountryCode) {
    return jsx(components.SingleValue, singleValueProps, value);
  }

  return jsx(components.SingleValue, singleValueProps, icon && jsx("img", {
    src: icon,
    className: "react-select__option-icon",
    alt: ""
  }), label);
};

var Option = function Option(_ref2) {
  var data = _ref2.data,
      optionProps = _objectWithoutProperties(_ref2, ["data"]);

  var label = data.label,
      icon = data.icon;
  return jsx(components.Option, optionProps, icon && jsx("img", {
    src: icon,
    className: "react-select__option-icon",
    alt: ""
  }), label);
};

var Select = function Select(_ref3) {
  var id = _ref3.id,
      options = _ref3.options,
      value = _ref3.value,
      defaultValue = _ref3.defaultValue,
      onChange = _ref3.onChange,
      placeholder = _ref3.placeholder,
      disabled = _ref3.disabled,
      className = _ref3.className,
      hasJumpList = _ref3.hasJumpList,
      isCountryCode = _ref3.isCountryCode,
      multiple = _ref3.multiple,
      required = _ref3.required,
      isSearchable = _ref3.isSearchable,
      props = _objectWithoutProperties(_ref3, ["id", "options", "value", "defaultValue", "onChange", "placeholder", "disabled", "className", "hasJumpList", "isCountryCode", "multiple", "required", "isSearchable"]);

  var handleNativeChange = function handleNativeChange(e) {
    if (multiple) {
      var selectedOptions = [].slice.call(e.target.selectedOptions);
      var results = selectedOptions ? selectedOptions.map(function (opt) {
        return {
          label: opt.label,
          value: opt.value
        };
      }) : [];
      return onChange(results);
    } // eslint-disable-next-line no-unused-vars


    var _e$target$selectedOpt = _toArray(e.target.selectedOptions),
        selectedOption = _e$target$selectedOpt[0],
        rest = _e$target$selectedOpt.slice(1);

    var result = selectedOption ? {
      label: selectedOption.label,
      value: selectedOption.value
    } : null;
    return onChange(result);
  };

  var nativeSelectClasses = classnames("native-select", {
    "native-select--has-jumplist": hasJumpList
  });
  var reactSelectClasses = classnames("react-select-container", {
    "react-select-container--has-jumplist": hasJumpList
  });
  var safeValue = getNativeSafeValue(value, multiple);
  return jsx("div", _extends({
    className: className
  }, props), jsx("select", {
    id: id,
    onChange: handleNativeChange,
    value: safeValue,
    className: nativeSelectClasses,
    disabled: disabled,
    multiple: multiple,
    required: required
  }, jsx("option", {
    key: "".concat(id, "_null"),
    value: null
  }, placeholder), renderOptions(options, id)), jsx(ReactSelect, {
    id: id,
    defaultValue: defaultValue,
    value: value,
    onChange: onChange,
    className: reactSelectClasses,
    classNamePrefix: "react-select",
    isSearchable: isSearchable,
    isDisabled: disabled,
    options: options,
    placeholder: placeholder,
    required: required,
    components: {
      SingleValue: function SingleValue(singleValue) {
        return _SingleValue(singleValue, isCountryCode);
      },
      MultiValueRemove: MultiValueRemove,
      Option: Option
    },
    isMulti: multiple
  }));
};

var optionPropTypes = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string
});
Select.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([optionPropTypes, PropTypes.arrayOf(optionPropTypes)]),
  defaultValue: optionPropTypes,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  hasJumpList: PropTypes.bool,
  isCountryCode: PropTypes.bool,
  multiple: PropTypes.bool,
  required: PropTypes.bool,
  isSearchable: PropTypes.bool
};

var css_248z$B = "@-webkit-keyframes sidebarOverlayIn{0%{opacity:.5}to{opacity:1}}@keyframes sidebarOverlayIn{0%{opacity:.5}to{opacity:1}}.sidebar__inner{position:fixed;top:4.125rem;width:19rem;max-width:100%;z-index:10;background-color:#fff;box-shadow:0 1px 6px 0 rgba(0,0,0,.16);display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:calc(100% - 4.125rem)}.sidebar__header{padding:2rem;-ms-flex:none;flex:none;position:relative}.sidebar__header:after{content:\"\";position:absolute;bottom:0;width:calc(100% - 3rem);left:1.5rem;border-bottom:1px solid #e5e5e5}.sidebar__menu{overflow:auto;z-index:1;background-repeat:no-repeat;background-color:#fff;background-image:radial-gradient(farthest-side at 50% 0,rgba(0,0,0,.16),transparent),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,.16),transparent);background-position:0 0,0 100%;background-size:100% 14px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;position:relative}.sidebar__menu:after,.sidebar__menu:before{content:\"\";position:relative;z-index:-1;display:block;height:30px;margin:0 0 -30px;background:linear-gradient(180deg,#fff,#fff 30%,hsla(0,0%,100%,0));-ms-flex:none;flex:none}.sidebar__menu:after{margin:-30px 0 0;background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff 70%,#fff)}.sidebar__menu-inner{-ms-flex:1;flex:1}.sidebar__controls{-ms-flex:none;flex:none;margin-left:1.5rem;margin-right:1.5rem;padding-top:1rem}.sidebar__controls-item{padding-left:0;margin-bottom:0}.sidebar__controls-item:before{display:none}.sidebar__overlay{display:none;background:hsla(0,0%,54.5%,.8);width:100%;height:100%;z-index:10;position:fixed;top:0;left:0;-webkit-animation:sidebarOverlayIn .3s ease-out;animation:sidebarOverlayIn .3s ease-out}@media screen and (max-width:63.99875em){.sidebar__inner{left:-19rem;transition:transform .3s ease-in-out}.sidebar--is-active .sidebar__inner{transform:translateX(19rem)}.sidebar--is-active .sidebar__overlay{display:block}}@media screen and (min-width:64em){.sidebar__inner{width:20rem;top:0;left:0;height:100%}}";
styleInject(css_248z$B);

var Sidebar = /*#__PURE__*/function (_Component) {
  _inherits(Sidebar, _Component);

  var _super = _createSuper(Sidebar);

  function Sidebar(props) {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _super.call(this, props);
    _this.handleOnEscape = _this.handleOnEscape.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Sidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleOnEscape, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleOnEscape);
    }
  }, {
    key: "handleOnEscape",
    value: function handleOnEscape(e) {
      var closeMenu = this.props.closeMenu;

      if (e.keyCode === 27) {
        closeMenu();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userProfile = _this$props.userProfile,
          navigation = _this$props.navigation,
          isActive = _this$props.isActive,
          navBar = _this$props.navBar,
          closeMenu = _this$props.closeMenu,
          controls = _this$props.controls;
      var classes = classnames("sidebar", {
        "sidebar--is-active": isActive
      });
      return jsx(Fragment, null, navBar, jsx("div", {
        className: classes
      }, jsx("button", {
        type: "button",
        tabIndex: "-1",
        className: "sidebar__overlay",
        onClick: closeMenu
      }), jsx("div", {
        className: "sidebar__inner"
      }, jsx("div", {
        className: "sidebar__menu"
      }, jsx("div", {
        className: "sidebar__header"
      }, userProfile), jsx("div", {
        className: "sidebar__menu-inner"
      }, navigation)), jsx("ul", {
        className: "sidebar__controls"
      }, controls && controls.map(function (control, i) {
        var onClick = control.onClick,
            text = control.text,
            to = control.to;

        if (onClick) {
          return jsx("li", {
            className: "sidebar__controls-item",
            key: i
          }, jsx(BaseButton, {
            className: "vertical-nav__item-btn vertical-nav__item-btn--aside",
            onClick: onClick
          }, jsx("span", {
            className: "vertical-nav__item-btn-inner"
          }, jsx("span", {
            className: "vertical-nav__item-text"
          }, text))));
        }

        return jsx("li", {
          className: "sidebar__controls-item",
          key: i
        }, jsx(BaseAnchor, {
          className: "vertical-nav__item-btn  vertical-nav__item-btn--aside",
          to: to
        }, jsx("span", {
          className: "vertical-nav__item-btn-inner"
        }, jsx("span", {
          className: "vertical-nav__item-text"
        }, text))));
      })))));
    }
  }]);

  return Sidebar;
}(Component);

Sidebar.propTypes = {
  userProfile: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  navigation: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isActive: PropTypes.bool,
  navBar: PropTypes.node,
  closeMenu: PropTypes.func.isRequired,
  controls: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    to: PropTypes.string
  }))
};

var css_248z$C = ".sidebar-skeleton{display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;z-index:10;background:#fff}@media screen and (min-width:64em){.sidebar-skeleton{width:20rem}}.sidebar-skeleton__top{border-bottom:1px solid #e5e5e5;-ms-flex:0 0 auto;flex:0 0 auto}@media screen and (max-width:63.99875em){.sidebar-skeleton__top{display:none!important}}.sidebar-skeleton__middle{-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-item-align:stretch;align-self:stretch}@media screen and (max-width:63.99875em){.sidebar-skeleton__middle{display:none!important}}.sidebar-skeleton__bottom{-ms-flex:0 0 auto;flex:0 0 auto;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:.25rem 0}.sidebar-skeleton__bottom .menu-item-skeleton{-ms-flex:1 1 auto;flex:1 1 auto;max-width:12rem}@media screen and (max-width:63.99875em){.sidebar-skeleton__bottom{position:fixed;top:0;left:0;width:100%;background:#fff;border-bottom:1px solid #e5e5e5}}@media screen and (min-width:64em){.sidebar-skeleton__bottom-mobile-item{display:none!important}}.user-avatar-skeleton{-webkit-animation-name:skeletonAnimation;animation-name:skeletonAnimation;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;background-color:#b9b9b9!important;color:#b9b9b9!important;width:4rem;height:4rem;border-radius:50%!important;margin:0 auto 1rem}.menu-item-skeleton{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.menu-item-skeleton__text{-ms-flex:1 1 auto;flex:1 1 auto}";
styleInject(css_248z$C);

var SidebarSkeleton = function SidebarSkeleton(_ref) {
  var className = _ref.className;
  var classes = classnames("sidebar", "sidebar-skeleton", className);
  return jsx("div", {
    className: classes
  }, jsx("div", {
    className: "sidebar__inner"
  }, jsx("div", {
    className: "sidebar-skeleton__top u-padding-2"
  }, jsx("div", {
    className: "u-text-center"
  }, jsx("div", {
    className: "user-avatar-skeleton"
  }), jsx("p", {
    className: "u-skeleton-text"
  }, "__________________"))), jsx("div", {
    className: "sidebar-skeleton__middle u-padding-2"
  }, jsx("div", {
    className: "menu-item-skeleton u-margin-bottom-2"
  }, jsx("p", {
    className: "u-skeleton-icon u-margin-right-1"
  }), jsx("p", {
    className: "menu-item-skeleton__text u-skeleton-text"
  })), jsx("div", {
    className: "menu-item-skeleton u-margin-bottom-2"
  }, jsx("p", {
    className: "u-skeleton-icon u-margin-right-1"
  }), jsx("p", {
    className: "menu-item-skeleton__text u-skeleton-text"
  })), jsx("div", {
    className: "menu-item-skeleton u-margin-bottom-2"
  }, jsx("p", {
    className: "u-skeleton-icon u-margin-right-1"
  }), jsx("p", {
    className: "menu-item-skeleton__text u-skeleton-text"
  })), jsx("div", {
    className: "menu-item-skeleton u-margin-bottom-2"
  }, jsx("p", {
    className: "u-skeleton-icon u-margin-right-1"
  }), jsx("p", {
    className: "menu-item-skeleton__text u-skeleton-text"
  })), jsx("div", {
    className: "menu-item-skeleton u-margin-bottom-2"
  }, jsx("p", {
    className: "u-skeleton-icon u-margin-right-1"
  }), jsx("p", {
    className: "menu-item-skeleton__text u-skeleton-text"
  }))), jsx("ul", {
    className: "sidebar-skeleton__bottom"
  }, jsx("div", {
    className: "menu-item-skeleton u-padding-1"
  }, jsx("p", {
    className: "menu-item-skeleton__text u-skeleton-text"
  })))));
};

SidebarSkeleton.propTypes = {
  className: PropTypes.string
};

var css_248z$D = "body.page-has-sidebar{padding-top:4rem}@media screen and (min-width:64em){body.page-has-sidebar{padding:0 0 0 20rem}}";
styleInject(css_248z$D);

var SidebarContainer = /*#__PURE__*/function (_Component) {
  _inherits(SidebarContainer, _Component);

  var _super = _createSuper(SidebarContainer);

  function SidebarContainer() {
    _classCallCheck(this, SidebarContainer);

    return _super.apply(this, arguments);
  }

  _createClass(SidebarContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.toggle("page-has-sidebar");
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove("page-has-sidebar");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showLoadingSkeleton = _this$props.showLoadingSkeleton,
          children = _this$props.children;
      return showLoadingSkeleton ? jsx(SidebarSkeleton, null) : children;
    }
  }]);

  return SidebarContainer;
}(Component);

SidebarContainer.propTypes = {
  showLoadingSkeleton: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var css_248z$E = ".acca-skip-link{position:absolute;left:-62rem;width:1px;height:1px;overflow:hidden;z-index:-999;display:block;padding:1rem;font-family:avenir,Helvetica,Arial,sans-serif;color:#000;background-color:#fff}.acca-skip-link:active,.acca-skip-link:focus{position:relative;left:auto;z-index:1;width:auto;height:auto;color:#c80000}";
styleInject(css_248z$E);

var SkipLink = function SkipLink(_ref) {
  var text = _ref.text,
      to = _ref.to;
  return jsx("a", {
    href: "#".concat(to),
    className: "acca-skip-link"
  }, text);
};

SkipLink.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
};

var css_248z$F = ".status-key{line-height:1;text-transform:uppercase;font-size:.75rem;padding:.4375rem .5rem;border-radius:1px;border:1px solid #e5e5e5;background:#f2f2f2;letter-spacing:.1em;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;white-space:nowrap}.status-key svg{width:1rem;margin-right:.5rem;color:#fff}.status-key--success{background-color:#dcf0dc;border-color:#8cc84b}.status-key--success svg{color:#8cc84b}.status-key--warning{background-color:#fffac8;border-color:#ffde0a}.status-key--warning svg{color:#ffde0a}.status-key--info{background-color:#dcf0fa;border-color:#64c8fa}.status-key--info svg{color:#64c8fa}.status-key--error{background-color:#fe9898;border-color:#f24137}.status-key--error svg{color:#f24137}";
styleInject(css_248z$F);

var StatusKey = function StatusKey(_ref) {
  var type = _ref.type,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["type", "children", "className"]);

  var classNames = classnames("status-key", _defineProperty({}, "status-key--".concat(type), !!type), className);
  return jsx("span", _extends({
    className: classNames
  }, props), children);
};

StatusKey.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["success", "warning", "error", "info"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired
};

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var _ref$1i = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  fill: "#C80000",
  d: "M0 128h127.815V0H0z"
}), /*#__PURE__*/createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M25.097 70.345l-.017-.048-2.564-8.57a.258.258 0 00-.25-.192.243.243 0 00-.241.183l-2.583 8.59-.01.035a.247.247 0 00.243.295h5.176c.14 0 .25-.109.25-.247 0-.016-.002-.03-.004-.046zm2.062 6.18a.422.422 0 00-.39-.259h-9.087a.426.426 0 00-.39.258l-1.28 3.502-.003.002a.415.415 0 01-.383.254H8.89a.42.42 0 01-.422-.416c0-.054.01-.105.03-.151l.007-.018 10.844-26.908.013-.03a.421.421 0 01.383-.245h5.051c.163 0 .308.097.374.236l.023.053 10.721 26.88.023.056c.014.038.022.08.022.127 0 .23-.188.416-.418.416h-6.808a.42.42 0 01-.39-.253l-.003-.01-1.18-3.495z"
}), /*#__PURE__*/createElement("path", {
  d: "M63.594 70.591h-6.797a.421.421 0 00-.35.187c-.841 1.451-2.708 3.803-6.25 3.803-4.633 0-7.497-4.054-7.497-8.258 0-3.939 2.676-8.106 7.463-8.106 3.281 0 5.296 2.024 6.308 3.901.012.024.028.051.04.077a.429.429 0 00.351.182h6.808a.42.42 0 00.385-.582c-1.344-4.276-5.921-9.806-13.857-9.806-9.118 0-14.62 7.278-14.62 14.373 0 7.504 5.954 14.447 14.697 14.447 6.29 0 11.687-3.794 13.701-9.632l.013-.034a.422.422 0 00-.396-.551m30.243-.001H87.04a.421.421 0 00-.35.187c-.841 1.451-2.708 3.803-6.247 3.803-4.636 0-7.5-4.054-7.5-8.258 0-3.939 2.676-8.106 7.463-8.106 3.28 0 5.295 2.024 6.308 3.901l.042.077a.425.425 0 00.349.182h6.808a.42.42 0 00.385-.582c-1.344-4.276-5.92-9.806-13.855-9.806-9.12 0-14.623 7.278-14.623 14.373 0 7.504 5.955 14.447 14.698 14.447 6.293 0 11.687-3.794 13.701-9.632.004-.012.009-.022.011-.034a.41.41 0 00.024-.132.42.42 0 00-.418-.42"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M110.778 70.345l-.016-.048-2.565-8.57a.259.259 0 00-.251-.192.243.243 0 00-.24.183l-2.582 8.59-.011.035a.247.247 0 00.243.295h5.179a.246.246 0 00.247-.247c0-.016-.002-.03-.004-.046zm2.062 6.18a.422.422 0 00-.39-.259h-9.087a.426.426 0 00-.389.258l-1.281 3.502-.003.002a.418.418 0 01-.385.254H94.57a.42.42 0 01-.422-.416c0-.054.01-.105.03-.151l.007-.018 10.845-26.908.013-.03a.421.421 0 01.382-.245h5.051c.164 0 .308.097.374.236l.023.053 10.724 26.88.02.056c.014.038.022.08.022.127 0 .23-.188.416-.417.416h-6.809a.418.418 0 01-.389-.253l-.004-.01-1.18-3.495z"
})), /*#__PURE__*/createElement("g", {
  fill: "#231F20"
}, /*#__PURE__*/createElement("path", {
  d: "M164.135 77.5h2.64l.145-19.573h-5.976l-.147 3.725h-3.666l.146-6.72h23.287l.147 6.72h-3.67l-.145-3.725h-5.867l-.147 19.572h2.97v2.995h-9.717zm18.215 0h2.165l.147-22.092h-2.751v-2.995h7.004l-.108 9.092c0 1.278-.22 2.593-.477 4.2h.073c.769-2.446 2.895-4.637 6.711-4.637 4.473 0 6.637 2.811 6.637 7.34 0 3.03-.11 6.062-.147 9.091h2.494v2.995h-8.765v-2.995h2.164c.037-2.776.147-5.585.147-8.36 0-2.667-1.248-4.638-3.851-4.638-2.823 0-4.952 2.226-5.023 5.768l-.146 7.23h2.565v2.995h-8.838v-2.995z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M211.088 51.975a2.795 2.795 0 012.825 2.812 2.795 2.795 0 01-2.825 2.812 2.795 2.795 0 01-2.822-2.812 2.795 2.795 0 012.822-2.812zm-4.62 25.524h2.493l.074-12.998h-2.895v-2.995h7.004L213.07 77.5h2.565v2.996h-9.167V77.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M218.343 77.5h2.163l.074-13h-2.678v-2.995h6.786c0 1.278-.11 2.593-.367 4.2h.074c.769-2.446 2.895-4.637 6.71-4.637 4.474 0 6.638 2.811 6.638 7.34 0 3.03-.11 6.062-.147 9.091h2.493v2.995h-8.764v-2.995h2.164c.037-2.776.147-5.585.147-8.36 0-2.667-1.248-4.638-3.852-4.638-2.822 0-4.951 2.226-5.023 5.768l-.146 7.23h2.565v2.995h-8.837v-2.995zm24.302 0h2.31l.147-22.092h-3.336v-2.995h7.445l-.147 17.347 6.748-5.186v-.073h-2.715v-2.996h8.948v2.996h-1.906l-6.821 5.621 7.371 7.377h2.163v2.995h-9.167v-2.995h2.237l-6.858-6.645v6.645h2.31v2.995h-8.729z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M287.483 60.703c-.403-1.132-.55-1.79-.66-2.337h-.074c-.11.51-.257 1.205-.697 2.337l-2.823 7.23h6.785l-2.53-7.23zm-14.119 16.796h2.2l9.316-22.566h4.547l8.617 22.566h2.273v2.995h-9.387V77.5h2.346l-2.2-6.353h-9.02l-2.384 6.353h2.64v2.995h-8.948V77.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M302.504 77.5h2.163l.146-22.092h-2.75v-2.995h7.004l-.108 9.092c0 1.278-.22 2.593-.477 4.2h.074c.769-2.446 2.895-4.637 6.71-4.637 4.474 0 6.638 2.811 6.638 7.34 0 3.03-.11 6.062-.147 9.091h2.493v2.995h-8.764v-2.995h2.164c.037-2.776.147-5.585.147-8.36 0-2.667-1.248-4.638-3.852-4.638-2.822 0-4.951 2.226-5.023 5.768l-.146 7.23h2.565v2.995h-8.837v-2.995z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M340.154 68.882v-.365c0-1.57-1.028-4.455-4.51-4.455-3.485 0-4.658 2.52-4.805 4.82h9.315zm3.115 10.735c-1.319.548-3.85 1.316-6.71 1.316-6.307-.036-10.048-3.908-10.048-9.86 0-5.624 3.19-10.005 9.35-10.005 5.723 0 8.62 4.163 8.62 10.042v.548h-13.642c.037 3.687 2.75 6.061 6.527 6.061a13.54 13.54 0 006.124-1.46l-.22 3.358zm11.579-1.898c3.191 0 4.915-2.41 4.915-4.821v-.764c-4.254.036-7.959.216-7.959 3.028 0 1.426 1.101 2.557 3.044 2.557zm-6.343-14.935c1.025-.475 3.482-1.716 7.555-1.716 5.646 0 7.442 2.775 7.442 7.266 0 3.068-.11 6.1-.147 9.165h2.567v2.995h-6.05c0-1.203.11-2.666.331-3.943h-.073c-.808 2.155-2.347 4.382-6.346 4.382-4.583 0-6.086-3.031-6.086-5.442 0-5.003 5.097-5.659 8.214-5.805l3.924-.22v-1.423c0-2.338-.844-3.98-4.217-3.98-1.431 0-2.824.4-3.448.657v2.775h-3.666v-4.71zm33.985 2.3c-.845-.51-2.13-.803-3.633-.803-3.776 0-5.903 3.286-5.903 7.012 0 3.54 1.54 6.206 4.62 6.206 3.3 0 4.915-2.702 4.915-7.12v-5.295zm6.6 15.41h-6.456c0-1.35.183-2.775.367-3.87h-.074c-.988 2.557-3.078 4.309-6.343 4.309-4.584 0-7.959-3.36-7.959-9.019 0-6.282 3.742-10.846 10.232-10.846 1.356 0 2.64.182 3.777.437l.074-6.097h-3.483v-2.995h7.445l-.147 25.086h2.567v2.996z"
})));

function SvgStandard(props) {
  return /*#__PURE__*/createElement("svg", _extends$1j({
    viewBox: "0 0 390 128"
  }, props), _ref$1i);
}

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var _ref$1j = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  fill: "#C80000",
  stroke: "#FFF",
  d: "M.5 127.5h126.815V.5H.5v127z"
}), /*#__PURE__*/createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M25.097 70.345l-.017-.048-2.564-8.57a.258.258 0 00-.25-.192.243.243 0 00-.241.183l-2.583 8.59-.01.035a.247.247 0 00.243.295h5.176c.14 0 .25-.109.25-.247 0-.016-.002-.03-.004-.046zm2.062 6.18a.422.422 0 00-.39-.259h-9.087a.426.426 0 00-.39.258l-1.28 3.502-.003.002a.415.415 0 01-.383.254H8.89a.42.42 0 01-.422-.416c0-.054.01-.105.03-.151l.007-.018 10.844-26.908.013-.03a.421.421 0 01.383-.245h5.051c.163 0 .308.097.374.236l.023.053 10.721 26.88.023.056c.014.038.022.08.022.127 0 .23-.188.416-.418.416h-6.808a.42.42 0 01-.39-.253l-.003-.01-1.18-3.495z"
}), /*#__PURE__*/createElement("path", {
  d: "M63.594 70.591h-6.797a.421.421 0 00-.35.187c-.841 1.451-2.708 3.803-6.25 3.803-4.633 0-7.497-4.054-7.497-8.258 0-3.939 2.676-8.106 7.463-8.106 3.281 0 5.296 2.024 6.308 3.901.012.024.028.051.04.077a.429.429 0 00.351.182h6.808a.42.42 0 00.385-.582c-1.344-4.276-5.921-9.806-13.857-9.806-9.118 0-14.62 7.278-14.62 14.373 0 7.504 5.954 14.447 14.697 14.447 6.29 0 11.687-3.794 13.701-9.632l.013-.034a.422.422 0 00-.396-.551m30.243-.001H87.04a.421.421 0 00-.35.187c-.841 1.451-2.708 3.803-6.247 3.803-4.636 0-7.5-4.054-7.5-8.258 0-3.939 2.676-8.106 7.463-8.106 3.28 0 5.295 2.024 6.308 3.901l.042.077a.425.425 0 00.349.182h6.808a.42.42 0 00.385-.582c-1.344-4.276-5.92-9.806-13.855-9.806-9.12 0-14.623 7.278-14.623 14.373 0 7.504 5.955 14.447 14.698 14.447 6.293 0 11.687-3.794 13.701-9.632.004-.012.009-.022.011-.034a.41.41 0 00.024-.132.42.42 0 00-.418-.42"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M110.778 70.345l-.016-.048-2.565-8.57a.259.259 0 00-.251-.192.243.243 0 00-.24.183l-2.582 8.59-.011.035a.247.247 0 00.243.295h5.179a.246.246 0 00.247-.247c0-.016-.002-.03-.004-.046zm2.062 6.18a.422.422 0 00-.39-.259h-9.087a.426.426 0 00-.389.258l-1.281 3.502-.003.002a.418.418 0 01-.385.254H94.57a.42.42 0 01-.422-.416c0-.054.01-.105.03-.151l.007-.018 10.845-26.908.013-.03a.421.421 0 01.382-.245h5.051c.164 0 .308.097.374.236l.023.053 10.724 26.88.02.056c.014.038.022.08.022.127 0 .23-.188.416-.417.416h-6.809a.418.418 0 01-.389-.253l-.004-.01-1.18-3.495z"
})), /*#__PURE__*/createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/createElement("path", {
  d: "M164.135 77.5h2.64l.145-19.573h-5.976l-.147 3.725h-3.666l.146-6.72h23.287l.147 6.72h-3.67l-.145-3.725h-5.867l-.147 19.572h2.97v2.995h-9.717zm18.215 0h2.165l.147-22.092h-2.751v-2.995h7.004l-.108 9.092c0 1.278-.22 2.593-.477 4.2h.073c.769-2.446 2.895-4.637 6.711-4.637 4.473 0 6.637 2.811 6.637 7.34 0 3.03-.11 6.062-.147 9.091h2.494v2.995h-8.765v-2.995h2.164c.037-2.776.147-5.585.147-8.36 0-2.667-1.248-4.638-3.851-4.638-2.823 0-4.952 2.226-5.023 5.768l-.146 7.23h2.565v2.995h-8.838v-2.995z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M211.088 51.975a2.795 2.795 0 012.825 2.812 2.795 2.795 0 01-2.825 2.812 2.795 2.795 0 01-2.822-2.812 2.795 2.795 0 012.822-2.812zm-4.62 25.524h2.493l.074-12.998h-2.895v-2.995h7.004L213.07 77.5h2.565v2.996h-9.167V77.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M218.343 77.5h2.163l.074-13h-2.678v-2.995h6.786c0 1.278-.11 2.593-.367 4.2h.074c.769-2.446 2.895-4.637 6.71-4.637 4.474 0 6.638 2.811 6.638 7.34 0 3.03-.11 6.062-.147 9.091h2.493v2.995h-8.764v-2.995h2.164c.037-2.776.147-5.585.147-8.36 0-2.667-1.248-4.638-3.852-4.638-2.822 0-4.951 2.226-5.023 5.768l-.146 7.23h2.565v2.995h-8.837v-2.995zm24.302 0h2.31l.147-22.092h-3.336v-2.995h7.445l-.147 17.347 6.748-5.186v-.073h-2.715v-2.996h8.948v2.996h-1.906l-6.821 5.621 7.371 7.377h2.163v2.995h-9.167v-2.995h2.237l-6.858-6.645v6.645h2.31v2.995h-8.729z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M287.483 60.703c-.403-1.132-.55-1.79-.66-2.337h-.074c-.11.51-.257 1.205-.697 2.337l-2.823 7.23h6.785l-2.53-7.23zm-14.119 16.796h2.2l9.316-22.566h4.547l8.617 22.566h2.273v2.995h-9.387V77.5h2.346l-2.2-6.353h-9.02l-2.384 6.353h2.64v2.995h-8.948V77.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M302.504 77.5h2.163l.146-22.092h-2.75v-2.995h7.004l-.108 9.092c0 1.278-.22 2.593-.477 4.2h.074c.769-2.446 2.895-4.637 6.71-4.637 4.474 0 6.638 2.811 6.638 7.34 0 3.03-.11 6.062-.147 9.091h2.493v2.995h-8.764v-2.995h2.164c.037-2.776.147-5.585.147-8.36 0-2.667-1.248-4.638-3.852-4.638-2.822 0-4.951 2.226-5.023 5.768l-.146 7.23h2.565v2.995h-8.837v-2.995z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "nonzero",
  d: "M340.154 68.882v-.365c0-1.57-1.028-4.455-4.51-4.455-3.485 0-4.658 2.52-4.805 4.82h9.315zm3.115 10.735c-1.319.548-3.85 1.316-6.71 1.316-6.307-.036-10.048-3.908-10.048-9.86 0-5.624 3.19-10.005 9.35-10.005 5.723 0 8.62 4.163 8.62 10.042v.548h-13.642c.037 3.687 2.75 6.061 6.527 6.061a13.54 13.54 0 006.124-1.46l-.22 3.358zm11.579-1.898c3.191 0 4.915-2.41 4.915-4.821v-.764c-4.254.036-7.959.216-7.959 3.028 0 1.426 1.101 2.557 3.044 2.557zm-6.343-14.935c1.025-.475 3.482-1.716 7.555-1.716 5.646 0 7.442 2.775 7.442 7.266 0 3.068-.11 6.1-.147 9.165h2.567v2.995h-6.05c0-1.203.11-2.666.331-3.943h-.073c-.808 2.155-2.347 4.382-6.346 4.382-4.583 0-6.086-3.031-6.086-5.442 0-5.003 5.097-5.659 8.214-5.805l3.924-.22v-1.423c0-2.338-.844-3.98-4.217-3.98-1.431 0-2.824.4-3.448.657v2.775h-3.666v-4.71zm33.985 2.3c-.845-.51-2.13-.803-3.633-.803-3.776 0-5.903 3.286-5.903 7.012 0 3.54 1.54 6.206 4.62 6.206 3.3 0 4.915-2.702 4.915-7.12v-5.295zm6.6 15.41h-6.456c0-1.35.183-2.775.367-3.87h-.074c-.988 2.557-3.078 4.309-6.343 4.309-4.584 0-7.959-3.36-7.959-9.019 0-6.282 3.742-10.846 10.232-10.846 1.356 0 2.64.182 3.777.437l.074-6.097h-3.483v-2.995h7.445l-.147 25.086h2.567v2.996z"
})));

function SvgReversed(props) {
  return /*#__PURE__*/createElement("svg", _extends$1k({
    viewBox: "0 0 390 128"
  }, props), _ref$1j);
}

var css_248z$G = ".footer{background-color:#f2f2f2;color:#000}.footer-row+.footer-row{border-top:1px solid #e5e5e5}.footer-section__heading{font-size:1rem;line-height:1.67;letter-spacing:.094em;text-transform:uppercase;color:#565656;margin-bottom:1.5rem;font-weight:400}.footer-section__item+.footer-section__item{margin-top:1.5rem}.footer-section__link{color:#000;border-bottom:.125rem solid transparent;font-weight:400;transition:all .1s ease-in-out;text-decoration:none;display:inline-block;position:relative;padding-bottom:.125rem;line-height:1.1}.footer-section__link:focus,.footer-section__link:hover{color:#c80000}.footer-section__link:active{color:#a00000}.footer-section__link:after{content:\"\";width:0;position:absolute;left:0;bottom:0;margin-bottom:-.125rem;transition:width .1s ease-out;display:block;border-bottom:.13rem solid #c80000}.footer-section__link:focus:after,.footer-section__link:hover:after{width:100%}.footer-section__link:active:after{width:100%;border-bottom-color:#a00000;border-bottom-style:solid}.footer-logo{margin-bottom:2rem}.footer-logo__image,.footer-logo__link{display:block}.footer-logo__image{height:4rem}.footer-section__item{padding-left:0;margin-bottom:0}.footer-section__item:before{display:none}.footer__social-links{list-style-type:none;margin:0;padding:0}.footer__social-link{padding-left:0;display:inline-block;margin:0 1rem 0 0}.footer__social-link:before{display:none}.footer__social-link:last-child{margin-right:0}.footer-row--top{padding:4rem 0}.footer-row--bottom{padding:2rem 0}.footer-row--bottom .brand-logo{margin-bottom:1rem}.footer-section--logo{margin-bottom:2rem}@media screen and (max-width:47.99875em){.footer-section+.footer-section,.footer-section.cell+.footer-section{margin-top:4rem}}@media screen and (min-width:48em){.footer-row--bottom .footer-section{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.footer-section--social{text-align:right}.footer-logo{margin-bottom:0}}@media screen and (min-width:82.5em){.footer-row--top{padding:6rem 0}}";
styleInject(css_248z$G);

var Footer = function Footer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("footer", className);
  return jsx("footer", _extends({
    className: classes
  }, props), jsx("section", {
    id: "footer-top",
    className: "footer-row footer-row--top"
  }, jsx("div", {
    className: "grid-container fluid"
  }, jsx("div", {
    className: "grid-x grid-margin-x"
  }, children))), jsx("section", {
    id: "footer-middle",
    className: "footer-row footer-row--bottom"
  }, jsx("div", {
    className: "grid-container fluid"
  }, jsx("div", {
    className: "grid-x grid-margin-x"
  }, jsx("div", {
    className: "footer-section cell"
  }, jsx("div", {
    className: "footer-logo"
  }, jsx("a", {
    href: "https://www.accaglobal.com",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "footer-logo__link",
    title: "Home Link"
  }, jsx(SvgStandard, {
    className: "footer-logo__image"
  }))), jsx("ul", {
    className: "footer__social-links"
  }, jsx("li", {
    className: "footer__social-link"
  }, jsx(IconButton, {
    icon: jsx(SvgLinkedIn, null),
    href: "https://www.linkedin.com/school/162244",
    newWindow: true,
    text: "LinkedIn"
  })), jsx("li", {
    className: "footer__social-link"
  }, jsx(IconButton, {
    icon: jsx(SvgTwitter, null),
    href: "https://twitter.com/ACCANews",
    newWindow: true,
    text: "Twitter"
  })), jsx("li", {
    className: "footer__social-link"
  }, jsx(IconButton, {
    icon: jsx(SvgYoutube, null),
    href: "https://www.youtube.com/user/ACCAOfficial",
    newWindow: true,
    text: "YouTube"
  })), jsx("li", {
    className: "footer__social-link"
  }, jsx(IconButton, {
    icon: jsx(SvgFacebook, null),
    href: "http://www.facebook.com/ACCA.Official",
    newWindow: true,
    text: "Facebook"
  }))))))));
};

Footer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
};

var FooterSection = function FooterSection(_ref) {
  var heading = _ref.heading,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      props = _objectWithoutProperties(_ref, ["heading", "children", "className"]);

  return jsx("div", _extends({
    className: "footer-section ".concat(className)
  }, props), jsx("h4", {
    className: "footer-section__heading"
  }, heading), jsx("ul", {
    className: "footer-section__items"
  }, children));
};

FooterSection.propTypes = {
  /**
   * Section heading
   */
  heading: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
};

var FooterLink = function FooterLink(_ref) {
  var name = _ref.name,
      link = _ref.link,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["name", "link", "className"]);

  var classes = classnames("footer-section__item", className);
  return jsx("li", _extends({
    className: classes
  }, props), isExternal$1(link) || !link ? jsx("a", {
    rel: "noopener noreferrer",
    href: link,
    className: "footer-section__link",
    title: name,
    target: "_blank"
  }, name) : jsx(Link, {
    to: link,
    className: "footer-section__link",
    title: name
  }, name));
};

FooterLink.propTypes = {
  /**
   * Link text
   */
  name: PropTypes.string.isRequired,

  /**
   * Url of page to link to
   */
  link: PropTypes.string.isRequired,
  className: PropTypes.string
};

var TableFoot = function TableFoot(_ref) {
  var children = _ref.children;
  return jsx("tfoot", null, children);
};

TableFoot.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var css_248z$H = ".telephone-field__country-code{margin:0 0 1rem}@media screen and (min-width:48em){.telephone-field{display:-ms-flexbox;display:flex}.telephone-field__country-code{-ms-flex:0 0 auto;flex:0 0 auto;width:9rem;margin:0 -2px 0 0}.telephone-field__country-code .react-select__menu{width:24rem}.telephone-field__country-code .react-select-container .react-select__control{background-color:#fff}.telephone-field__tel{-ms-flex:0 1 auto;flex:0 1 auto;margin:0}.telephone-field__tel:focus{position:relative}}";
styleInject(css_248z$H);

var TelephoneField = function TelephoneField(_ref) {
  var id = _ref.id,
      countryCode = _ref.countryCode,
      countryCodes = _ref.countryCodes,
      telephone = _ref.telephone,
      disabled = _ref.disabled,
      className = _ref.className,
      placeholder = _ref.placeholder,
      onCountryCodeChange = _ref.onCountryCodeChange,
      onTelephoneChange = _ref.onTelephoneChange,
      onTelephoneBlur = _ref.onTelephoneBlur,
      name = _ref.name,
      required = _ref.required;
  var classes = classnames("telephone-field", className);
  return jsx("div", {
    className: classes
  }, jsx(Select, {
    id: "".concat(id, "-country-code"),
    className: "telephone-field__country-code",
    options: countryCodes,
    disabled: disabled,
    onChange: function onChange(value) {
      return onCountryCodeChange(value);
    },
    hasJumpList: true,
    placeholder: placeholder,
    value: countryCode,
    isCountryCode: true
  }), jsx("input", {
    id: "".concat(id, "-input"),
    className: "telephone-field__tel",
    type: "tel",
    name: name,
    disabled: disabled,
    placeholder: placeholder,
    value: telephone,
    onChange: function onChange(e) {
      return onTelephoneChange(e.target.value);
    },
    onBlur: onTelephoneBlur,
    required: required
  }));
};

TelephoneField.propTypes = {
  id: PropTypes.string.isRequired,
  countryCode: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }),
  countryCodes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({}))
  })).isRequired,
  telephone: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onCountryCodeChange: PropTypes.func.isRequired,
  onTelephoneChange: PropTypes.func.isRequired,
  onTelephoneBlur: PropTypes.func,
  name: PropTypes.string,
  required: PropTypes.bool
};
TelephoneField.defaultProps = {};

var css_248z$I = ".tile-grid:hover .tile{-webkit-filter:grayscale(1);filter:grayscale(1);background-color:#f2f2f2}.tile-grid:hover .tile:focus,.tile-grid:hover .tile:hover{-webkit-filter:grayscale(0);filter:grayscale(0);background-color:#fff}.tile{appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;font-family:avenir,Helvetica,Arial,sans-serif;text-align:initial;text-indent:.01px;text-overflow:\"\";text-decoration:none;font-size:inherit;background:#fff no-repeat;box-shadow:0 1px 6px 0 rgba(0,0,0,.16);padding:3rem 1.5rem 2rem;position:relative;width:100%;color:#2d2d2d;min-height:16rem;display:table;height:100%;font-size:1.25rem;line-height:1.5rem;transition:all .1s ease-in-out}.tile:focus,.tile:hover{box-shadow:0 4px 24px rgba(0,0,0,.32)}.tile__content{position:relative;z-index:1;display:table-cell}.tile__overlay{background:linear-gradient(180deg,transparent,rgba(0,0,0,.75));position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;z-index:0}.tile__label{font-size:.75rem;line-height:1.67;letter-spacing:.094em;text-transform:uppercase;margin-bottom:.5rem}.tile__title{font-size:inherit;line-height:inherit}.tile.tile--with-image{color:#fff;background-position:50%;background-size:cover}.tile.tile--with-image .tile__content{display:table-cell;vertical-align:bottom}";
styleInject(css_248z$I);

var Tile = function Tile(_ref) {
  var label = _ref.label,
      heading = _ref.heading,
      backgroundImages = _ref.backgroundImages,
      onClick = _ref.onClick,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["label", "heading", "backgroundImages", "onClick", "children", "className"]);

  var withBackground = !!backgroundImages && backgroundImages.length;
  var classes = classnames("tile", {
    "tile--with-image": withBackground
  }, className);

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 13) {
      onClick();
    }
  };

  var innerProps = {};

  if (onClick) {
    innerProps = _objectSpread2(_objectSpread2({}, innerProps), {}, {
      onClick: onClick,
      role: "button",
      tabIndex: "0",
      onKeyDown: handleKeyPress
    });
  }

  return jsx("div", _extends({
    className: classes
  }, innerProps, {
    css: withBackground ? getBackgroundCssFromRenditions(backgroundImages) : {}
  }, props), !!withBackground && jsx("div", {
    className: "tile__overlay"
  }), children, jsx("div", {
    className: "tile__content"
  }, label && jsx("p", {
    className: "tile__label"
  }, label), jsx("p", {
    className: "tile__title u-font-heading u-content-container-medium"
  }, heading)));
};

Tile.propTypes = {
  /**
   * Component main title
   */
  heading: PropTypes.string.isRequired,

  /**
   * Label showing on top of the title
   */
  label: PropTypes.string,

  /**
   * Background image source
   */
  backgroundImages: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number
  })),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

var css_248z$J = ".tile-grid .tile{margin-bottom:1rem}.tile-grid .tile:first-child,.tile-grid .tile:nth-child(10){font-size:2rem;line-height:2.5rem;min-height:28rem}@media screen and (min-width:600px){.tile-grid{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:stretch;align-items:stretch}.tile-grid .tile{margin:0 0 1rem;width:calc(50% - .5rem)}.tile-grid .tile:nth-child(4),.tile-grid .tile:nth-child(5),.tile-grid .tile:nth-child(6),.tile-grid .tile:nth-child(7){font-size:1.5rem;line-height:2rem;padding:2.5rem;width:100%}.tile-grid .tile:first-child,.tile-grid .tile:nth-child(10){padding:2.5rem;width:100%}}@media screen and (min-width:82.5em){.tile-grid .tile{width:calc(50% - .5rem)}@supports (display:grid){.tile-grid{display:grid;gap:1rem;grid-auto-columns:1fr 1fr 1fr 1fr;grid-auto-rows:1fr}.tile-grid .tile{margin-bottom:0;width:100%}.tile-grid .tile:first-child{grid-column:1/span 2;grid-row:1/span 2}.tile-grid .tile:nth-child(2){grid-column:3/span 1;grid-row:1/span 1}.tile-grid .tile:nth-child(3){grid-column:4/span 1;grid-row:1/span 1}.tile-grid .tile:nth-child(4){grid-column:3/span 2;grid-row:2/span 1}.tile-grid .tile:nth-child(5){grid-column:1/span 2;grid-row:3/span 1}.tile-grid .tile:nth-child(6){grid-column:3/span 2;grid-row:3/span 1}.tile-grid .tile:nth-child(7){grid-column:1/span 2;grid-row:4/span 1}.tile-grid .tile:nth-child(8){grid-column:1/span 1;grid-row:5/span 1}.tile-grid .tile:nth-child(9){grid-column:2/span 1;grid-row:5/span 1}.tile-grid .tile:nth-child(10){grid-column:3/span 2;grid-row:4/span 2}}}";
styleInject(css_248z$J);

var css_248z$K = ".video-player{width:100%;overflow:hidden}.video-player__frame{box-sizing:border-box;display:block;position:absolute;top:0;left:0;width:100%;height:100%}.video-player__support-message{font-weight:700;padding:1rem;position:absolute;top:50%;left:50%;max-width:100%;text-align:center;transform:translate(-50%,-50%)}.video-stage{background-color:rgba(0,0,0,.8);color:#fff;position:fixed;top:0;bottom:0;left:0;right:0;height:100%;width:100%}.video-stage__inner{box-sizing:border-box;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);max-width:78rem;margin:0 auto;width:90%}.video-stage__close{appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;font-family:avenir,Helvetica,Arial,sans-serif;padding:0;text-align:initial;text-indent:.01px;text-overflow:\"\";text-decoration:none;font-size:inherit;color:currentColor;position:absolute;top:1rem;right:1rem;z-index:2}.video-stage__close-icon{fill:currentColor;height:1rem;width:1rem}.video-trigger{position:relative}.video-trigger:focus .video-trigger__icon,.video-trigger:hover .video-trigger__icon{opacity:.9}.video-trigger__icon{fill:currentColor;height:4rem;width:4rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:5;transition:opacity .2s ease-in-out}.video-stage[aria-hidden=true]{opacity:0;display:none}.video-stage[aria-hidden=false]{opacity:1;z-index:100;transition:opacity .15s cubic-bezier(.23,1,.32,1) 50ms;display:block}@media screen and (min-width:87.5em){.video-stage__close{top:2rem;right:2rem}}";
styleInject(css_248z$K);

var getVideoPath = function getVideoPath(url) {
  url.match(/(http|https):\/\/(player.|www.|play.)?(webvideocore.net|vimeo\.com|youtu(be\.com|\.be))\/(video\/|embed\/|watch\?v=)?([A-Za-z0-9._%-]*)(\&\S+)?/);
  var match = {
    provider: null,
    url: RegExp.$3,
    id: RegExp.$6,
    embedHTML: null
  };

  if (match.url === "youtube.com" || match.url === "youtu.be") {
    return "https://www.youtube.com/embed/".concat(match.id);
  }

  if (match.url === "vimeo.com") {
    return "https://player.vimeo.com/video/".concat(match.id);
  }

  if (match.url === "webvideocore.net") {
    return url;
  }

  return false;
};

var Video = /*#__PURE__*/function (_Component) {
  _inherits(Video, _Component);

  var _super = _createSuper(Video);

  function Video(props) {
    var _this;

    _classCallCheck(this, Video);

    _this = _super.call(this, props);
    _this.handleOnEscape = _this.handleOnEscape.bind(_assertThisInitialized(_this));
    _this.renderVideoFrame = _this.renderVideoFrame.bind(_assertThisInitialized(_this));
    _this.renderVideoModal = _this.renderVideoModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleOnEscape, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleOnEscape);
    }
  }, {
    key: "handleOnEscape",
    value: function handleOnEscape(e) {
      var _this$props = this.props,
          inModal = _this$props.inModal,
          handleCloseModal = _this$props.handleCloseModal;

      if (inModal && e.keyCode === 27) {
        handleCloseModal(e);
      }
    }
  }, {
    key: "renderVideoFrame",
    value: function renderVideoFrame() {
      var _this$props2 = this.props,
          url = _this$props2.url,
          id = _this$props2.id,
          inModal = _this$props2.inModal,
          showModal = _this$props2.showModal,
          className = _this$props2.className,
          supportMessage = _this$props2.supportMessage;
      var videoUrl = getVideoPath(url);
      var classes = classnames("video-player", "responsive-embed", "u-bg-grey-accessible", className);
      return jsx("div", {
        className: classes,
        id: id
      }, videoUrl ? jsx("iframe", {
        className: "video-player__frame",
        src: "".concat(videoUrl).concat(inModal && showModal ? "?autoplay=1" : ""),
        frameBorder: "0",
        allowFullScreen: true,
        title: "video"
      }) : jsx("p", {
        className: "video-player__support-message"
      }, supportMessage));
    }
  }, {
    key: "renderVideoModal",
    value: function renderVideoModal() {
      var _this$props3 = this.props,
          showModal = _this$props3.showModal,
          handleCloseModal = _this$props3.handleCloseModal;

      if (showModal) {
        return jsx(FocusLock, {
          returnFocus: true
        }, jsx("div", {
          className: "video-stage",
          role: "presentation",
          "aria-hidden": !showModal
        }, jsx(BaseButton, {
          onClick: function onClick(e) {
            handleCloseModal(e);
          },
          className: "video-stage__close"
        }, jsx(Svg16Px$8, {
          className: "video-stage__close-icon"
        })), jsx("div", {
          id: "video-stage-content",
          className: "video-stage__inner"
        }, showModal ? this.renderVideoFrame() : null)));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var inModal = this.props.inModal;
      return inModal ? this.renderVideoModal() : this.renderVideoFrame();
    }
  }]);

  return Video;
}(Component);

Video.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string.isRequired,
  inModal: PropTypes.bool,
  showModal: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  supportMessage: PropTypes.string,
  className: PropTypes.string
};

var css_248z$L = ".video-tile .video-tile__play-icon{color:currentColor;width:1rem;display:inline-block;vertical-align:middle;top:-1px;position:relative;font-size:1em}";
styleInject(css_248z$L);

var VideoTile = /*#__PURE__*/function (_Component) {
  _inherits(VideoTile, _Component);

  var _super = _createSuper(VideoTile);

  function VideoTile(props) {
    var _this;

    _classCallCheck(this, VideoTile);

    _this = _super.call(this, props);
    _this.state = {
      showVideoModal: false
    };
    _this.handleModalVisibitily = _this.handleModalVisibitily.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VideoTile, [{
    key: "handleModalVisibitily",
    value: function handleModalVisibitily(show) {
      this.setState({
        showVideoModal: show
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          heading = _this$props.heading,
          image = _this$props.image,
          url = _this$props.url,
          children = _this$props.children,
          className = _this$props.className;
      var classes = classnames("video-tile", "video-trigger", className);
      var showVideoModal = this.state.showVideoModal;
      return jsx(Tile, {
        label: jsx("span", null, label, " ", jsx(Svg64Px, {
          className: "video-tile__play-icon"
        })),
        heading: heading,
        onClick: function onClick() {
          _this2.handleModalVisibitily(true);
        },
        className: classes,
        image: image
      }, jsx(Video, {
        url: url,
        inModal: true,
        showModal: showVideoModal,
        handleCloseModal: function handleCloseModal(e) {
          e.stopPropagation();

          _this2.handleModalVisibitily(false);
        }
      }), children);
    }
  }]);

  return VideoTile;
}(Component);

VideoTile.propTypes = {
  /**
   * Component main title
   */
  heading: PropTypes.string.isRequired,

  /**
   * Label showing on top of the title
   */
  label: PropTypes.string,

  /**
   * Background image source
   */
  image: PropTypes.string,

  /**
   * Video url (youtube | vimeo accepted)
   */
  url: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

var TileGrid = function TileGrid(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("tile-grid", className);
  return jsx("div", {
    className: classes
  }, children);
};

TileGrid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(Tile), PropTypes.instanceOf(VideoTile)])).isRequired
};

var css_248z$M = ".timeline-event__icon{height:2rem;width:2rem;position:absolute;left:0;top:.2rem;transform:translateX(-50%)}@media screen and (min-width:48em){.timeline-event__icon{left:2rem}}.timeline-event{position:relative;padding-left:1.25rem;min-height:2rem}.timeline-event+.timeline-event{margin-top:2rem}.timeline-event:after{content:\"\";position:absolute;width:0;border-left:.125rem solid #b9b9b9;left:0;top:2.7rem;bottom:-1.5rem}.timeline-event:last-of-type:after{display:none}.timeline-event--large:after{top:4.7rem}.timeline-event--large:before{content:\"\";position:absolute;width:0;border-left:.125rem solid #b9b9b9;left:0;top:-.55rem;height:2.25rem;transform-origin:top center}.timeline-event--large .timeline-event__icon{top:2.2rem}.timeline-event--large.timeline-event:first-child:before{display:none}@media screen and (min-width:48em){.timeline-event{padding-left:4rem}.timeline-event:after{left:1.9375rem}.timeline-event--large:before{left:1.9375rem}}";
styleInject(css_248z$M);

var Timeline = /*#__PURE__*/function (_Component) {
  _inherits(Timeline, _Component);

  var _super = _createSuper(Timeline);

  function Timeline(props) {
    var _this;

    _classCallCheck(this, Timeline);

    _this = _super.call(this, props);
    var visibleEvents = _this.props.visibleEvents;
    _this.state = {
      visibleEvents: visibleEvents
    };
    _this.handleExpansion = _this.handleExpansion.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Timeline, [{
    key: "handleExpansion",
    value: function handleExpansion() {
      var _this$props = this.props,
          increments = _this$props.increments,
          children = _this$props.children;
      var visibleEvents = this.state.visibleEvents;
      this.setState({
        visibleEvents: visibleEvents + increments > children.length ? children.length : visibleEvents + increments
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          buttonText = _this$props2.buttonText,
          children = _this$props2.children,
          id = _this$props2.id;
      var visibleEvents = this.state.visibleEvents;
      var toArray = React__default.Children.toArray;
      var canShowMore = visibleEvents < toArray(children).length;
      var toDisplay = toArray(children).slice(0, visibleEvents);
      return jsx("div", {
        className: "timeline ".concat(className),
        id: id
      }, toDisplay, canShowMore && jsx(Button, {
        text: buttonText,
        variant: "outlined",
        onClick: this.handleExpansion,
        className: "timeline__expansion-button u-margin-top-4",
        icon: Svg16Px$4,
        iconPosition: "right"
      }));
    }
  }]);

  return Timeline;
}(Component);

Timeline.propTypes = {
  /**
   * number of TimelineEvent components to show by default
   */
  visibleEvents: PropTypes.number.isRequired,

  /**
   * number of TimelineEvent components to show when expanding
   */
  increments: PropTypes.number,

  /**
   * Expand button text
   */
  buttonText: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  id: PropTypes.string
};
Timeline.defaultProps = {
  className: "",
  increments: 1
};

var TimelineEvent = function TimelineEvent(_ref) {
  var icon = _ref.icon,
      _ref$contentSize = _ref.contentSize,
      contentSize = _ref$contentSize === void 0 ? "default" : _ref$contentSize,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["icon", "contentSize", "className", "children"]);

  var classes = classnames("timeline-event", {
    "timeline-event--large": contentSize === "large"
  }, className);
  return jsx("div", _extends({
    className: classes
  }, props), icon({
    className: "timeline-event__icon"
  }), jsx("div", {
    className: "timeline-event__content"
  }, children));
};

TimelineEvent.propTypes = {
  /**
   * Icon to be rendered on the left hand side of the component
   */
  icon: PropTypes.func.isRequired,

  /**
   * Size of the heading ('default' or 'large')
   */
  contentSize: PropTypes.oneOf(["default", "large"]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node), PropTypes.objectOf(PropTypes.node)]).isRequired
};
TimelineEvent.defaultProps = {
  contentSize: "default",
  className: ""
};

var css_248z$N = ".user-profile{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:flex-start;position:relative}.user-profile__name{font-size:1rem;line-height:1.5;font-family:caecilia-roman-heavy,Arial,sans-serif;margin:.5rem 0 0;color:#2d2d2d}.avatar,.user-profile__name{-ms-flex:none;flex:none;text-align:center}.avatar{background:#c80000;color:#fff;width:4rem;height:4rem;border-radius:50%!important;position:relative}.avatar--affiliate,.avatar--graduate,.avatar--student{background:#3f3f3f}.avatar--fellow,.avatar--member{background:#c80000}.avatar--firm{background:#000}.avatar__inner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.avatar__initials{font-family:caecilia-roman-heavy,Arial,sans-serif;font-size:1.5rem;line-height:1.2}.avatar__type{text-transform:uppercase;font-size:.5rem;font-weight:700;line-height:1;white-space:nowrap}.avatar__icon{color:#fff}";
styleInject(css_248z$N);

var UserProfile = function UserProfile(_ref) {
  var name = _ref.name,
      initials = _ref.initials,
      userType = _ref.userType,
      userTypeText = _ref.userTypeText,
      hideName = _ref.hideName,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["name", "initials", "userType", "userTypeText", "hideName", "className"]);

  return jsx("div", _extends({
    className: classnames("user-profile", className)
  }, props), jsx("div", {
    className: classnames("avatar", "avatar--".concat(userType.toLowerCase()))
  }, jsx("div", {
    className: "avatar__inner"
  }, userType !== "firm" && jsx("div", {
    className: "avatar__initials"
  }, initials), userType === "firm" && jsx("div", {
    className: "avatar__icon"
  }, jsx(Svg32Px$n, null), " "), jsx("div", {
    className: "avatar__type"
  }, userTypeText))), !hideName && !!name && jsx("div", {
    className: "user-profile__name"
  }, name));
};

UserProfile.propTypes = {
  userType: PropTypes.string.isRequired,
  userTypeText: PropTypes.string.isRequired,
  name: PropTypes.string,
  initials: PropTypes.string,
  className: PropTypes.string,
  hideName: PropTypes.bool
};

var VerticalNavTopLevelContainer = function VerticalNavTopLevelContainer(_ref) {
  var children = _ref.children;
  return jsx("ul", {
    className: "vertical-nav__list vertical-nav__list--top-level",
    role: "group"
  }, children);
};

VerticalNavTopLevelContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var VerticalNavSubLevelContainer = function VerticalNavSubLevelContainer(_ref) {
  var parentSectionName = _ref.parentSectionName,
      parentUrl = _ref.parentUrl,
      onClick = _ref.onClick,
      children = _ref.children,
      isActiveSection = _ref.isActiveSection,
      id = _ref.id;
  var classes = classnames("vertical-nav__sub-block", {
    "is-active": isActiveSection
  });
  return jsx("div", {
    className: classes,
    id: id
  }, jsx("div", {
    className: "vertical-nav__sub-block-inner"
  }, jsx("div", {
    className: "vertical-nav__back-btn-container"
  }, jsx(BaseAnchor, {
    className: "vertical-nav__back-btn",
    to: parentUrl,
    onClick: onClick,
    title: "Go back to ".concat(parentSectionName)
  }, jsx(Svg16Px$5, {
    className: "vertical-nav__arrow-icon"
  }), "Back to ", parentSectionName)), jsx("ul", {
    className: "vertical-nav__list vertical-nav__list--sub-level",
    role: "group"
  }, children)));
};

VerticalNavSubLevelContainer.propTypes = {
  id: PropTypes.string.isRequired,
  parentSectionName: PropTypes.string.isRequired,
  parentUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  isActiveSection: PropTypes.bool
};

var VerticalNavItem = function VerticalNavItem(_ref) {
  var id = _ref.id,
      icon = _ref.icon,
      text = _ref.text,
      to = _ref.to,
      onClick = _ref.onClick,
      isActive = _ref.isActive,
      hasSubMenu = _ref.hasSubMenu,
      className = _ref.className,
      notifications = _ref.notifications,
      tabIndex = _ref.tabIndex;
  var buttonClasses = classnames("vertical-nav__item-btn", {
    "is-active": isActive,
    "has-children": hasSubMenu
  });
  var listItemClass = "vertical-nav__list-item ".concat(className);
  return jsx("li", {
    className: listItemClass,
    role: "menuitem",
    id: "".concat(id, "-link"),
    onTransitionEnd: function onTransitionEnd(e) {
      return e.stopPropagation();
    }
  }, jsx(BaseAnchor, {
    className: buttonClasses,
    to: to,
    onClick: onClick,
    tabIndex: tabIndex
  }, jsx("span", {
    className: "vertical-nav__item-btn-inner"
  }, icon && icon, jsx("span", {
    className: "vertical-nav__item-text"
  }, text)), hasSubMenu && jsx(Svg16Px$6, {
    className: "vertical-nav__arrow-icon"
  }), notifications > 0 && jsx(Badge, {
    number: notifications
  })));
};

VerticalNavItem.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.node,
  isActive: PropTypes.bool.isRequired,
  notifications: PropTypes.number,
  hasSubMenu: PropTypes.bool,
  tabIndex: PropTypes.string
};
VerticalNavItem.defaultProps = {
  className: ""
};

var css_248z$O = ".vertical-nav{overflow:hidden;max-width:20rem}.vertical-nav__inner{transition:transform .2s ease-in-out;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-align:start;align-items:flex-start}.vertical-nav__list{padding:0}.vertical-nav__root-block,.vertical-nav__sub-block{-ms-flex:none;flex:none;margin-left:1.5rem;margin-right:1.5rem;width:calc(100% - 3rem)}.vertical-nav__sub-block{display:none}.vertical-nav__sub-block.is-active{display:block}.vertical-nav__list-item{padding-left:0;margin-bottom:0;list-style:none}.vertical-nav__list-item:before{display:none}.vertical-nav__item-btn{appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:0;cursor:pointer;text-align:initial;text-indent:.01px;text-overflow:\"\";font-size:inherit;color:currentColor;display:-ms-flexbox;display:flex;width:100%;font-family:avenir,Helvetica,Arial,sans-serif;font-size:1rem;font-weight:400;text-align:left;text-decoration:none;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;position:relative;overflow:visible;padding:.5rem 0;min-height:3rem}.vertical-nav__item-btn.is-active{font-weight:700}.vertical-nav__item-btn .badge{position:absolute;top:40%;left:0;transform:translate(-80%,-40%)}.vertical-nav__item-btn .vertical-nav__arrow-icon{right:0}.vertical-nav__item-btn.vertical-nav__item-btn--aside{padding:0;margin:1rem 0;font-size:1rem;min-height:0}.vertical-nav__item-btn-inner{color:#000;border-bottom:.125rem solid transparent;font-weight:400;transition:all .1s ease-in-out;text-decoration:none;display:inline-block;position:relative;padding-bottom:.125rem;line-height:1.1;-ms-flex:none;flex:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;color:currentColor;transition:all .05s ease-in-out;max-width:calc(100% - 2rem)}.vertical-nav__item-btn-inner:focus,.vertical-nav__item-btn-inner:hover{color:#c80000}.vertical-nav__item-btn-inner:active{color:#d33333}.vertical-nav__item-btn-inner:after{content:\"\";width:0;position:absolute;left:0;bottom:0;margin-bottom:-.125rem;transition:width .1s ease-out;display:block;border-bottom:.13rem solid #c80000}.vertical-nav__item-btn-inner:focus:after,.vertical-nav__item-btn-inner:hover:after{width:100%}.vertical-nav__item-btn-inner:active:after{width:100%;border-bottom-color:#d33333;border-bottom-style:solid}.vertical-nav__item-btn-inner svg{fill:currentColor;-ms-flex:none;flex:none;width:1rem;height:1rem;margin-right:.5rem}.vertical-nav__arrow-icon{-ms-flex:none;flex:none;fill:#dcdcdc;width:1rem;height:1rem;transition:all .1s ease-in-out;position:absolute;top:50%;margin-top:-.7rem}.vertical-nav__item-btn:focus:not(.is-active) .vertical-nav__item-btn-inner,.vertical-nav__item-btn:hover:not(.is-active) .vertical-nav__item-btn-inner{border-bottom-color:currentColor;color:#c80000}.vertical-nav__item-btn:focus:not(.is-active) .vertical-nav__item-btn-inner:after,.vertical-nav__item-btn:hover:not(.is-active) .vertical-nav__item-btn-inner:after{width:100%}.vertical-nav__item-btn:active:not(.is-active) .vertical-nav__item-btn-inner{color:#d33333;border-bottom-color:currentColor}.vertical-nav__item-btn.is-active .vertical-nav__item-btn-inner{color:#000;border-bottom-color:currentColor;font-weight:700}.vertical-nav__back-btn{color:currentColor;display:-ms-flexbox;display:flex;width:100%;font-weight:700;font-size:1rem;text-align:left;text-decoration:none;-ms-flex-align:center;align-items:center;border-top:1px solid #f2f2f2;border-bottom:1px solid #f2f2f2;padding:1rem 0;margin-bottom:2.5rem;position:relative}.vertical-nav__back-btn .vertical-nav__arrow-icon{margin-top:0;margin-right:.5rem;position:static}.vertical-nav__list--top-level{margin-top:1.5rem}@media screen and (min-width:64em){.vertical-nav__item-btn{padding:1rem 0;min-height:4rem}.vertical-nav__back-btn{border-top:none}}";
styleInject(css_248z$O);

var getMenuItems = function getMenuItems(menu) {
  var subMenus = [];

  var menuItems = function menuItems(array) {
    var sectionParent = array[0];
    array.forEach(function (item) {
      if (item.subLinks && item.subLinks.length > 0) {
        subMenus.push({
          parentId: sectionParent.id,
          parentName: sectionParent.name,
          parentUrl: sectionParent.to,
          sectionId: item.id,
          links: item.subLinks
        });
        menuItems(item.subLinks);
      }
    });
  };

  menuItems(menu);
  return subMenus;
};

var VerticalNav = /*#__PURE__*/function (_Component) {
  _inherits(VerticalNav, _Component);

  var _super = _createSuper(VerticalNav);

  function VerticalNav() {
    _classCallCheck(this, VerticalNav);

    return _super.apply(this, arguments);
  }

  _createClass(VerticalNav, [{
    key: "renderTopLevelItems",
    value: function renderTopLevelItems() {
      var _this$props = this.props,
          navigation = _this$props.navigation,
          currentUrl = _this$props.currentUrl,
          onItemClick = _this$props.onItemClick,
          currentLevel = _this$props.currentLevel;
      var sectionId = navigation[0].id;
      var isActiveSection = currentLevel === 0;
      return jsx("nav", {
        className: "vertical-nav__root-block"
      }, jsx(VerticalNavTopLevelContainer, null, navigation.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name,
            subLinks = _ref.subLinks,
            to = _ref.to,
            icon = _ref.icon,
            notifications = _ref.notifications;
        var hasSubMenu = subLinks && subLinks.length > 0;
        var isActive = to === currentUrl;
        var itemProps = {
          key: id,
          id: id,
          isActive: isActive,
          text: name,
          hasSubMenu: hasSubMenu,
          notifications: notifications,
          to: to,
          onClick: function onClick() {
            onItemClick(to, hasSubMenu, id, sectionId);
          }
        };

        if (icon) {
          itemProps.icon = icon in Icons ? Icons[icon]() : null;
        }

        return jsx(VerticalNavItem, _extends({}, itemProps, {
          tabIndex: isActiveSection ? "0" : "-1"
        }));
      })));
    }
  }, {
    key: "renderSubLevelItems",
    value: function renderSubLevelItems() {
      var _this$props2 = this.props,
          currentLevel = _this$props2.currentLevel,
          currentMenu = _this$props2.currentMenu,
          currentUrl = _this$props2.currentUrl,
          onItemClick = _this$props2.onItemClick,
          onBackBtnClick = _this$props2.onBackBtnClick,
          previousMenu = _this$props2.previousMenu,
          navigation = _this$props2.navigation;
      var subMenus = getMenuItems(navigation);
      return jsx(Fragment, null, subMenus.map(function (menu, i) {
        var parentId = menu.parentId,
            parentName = menu.parentName,
            sectionId = menu.sectionId,
            parentUrl = menu.parentUrl,
            links = menu.links;
        var hasFocus = sectionId === currentMenu;
        var isActiveSection = currentLevel > 0 && (hasFocus || sectionId === previousMenu);
        return jsx(VerticalNavSubLevelContainer, {
          id: sectionId,
          key: "".concat(parentId, "_").concat(i),
          isActiveSection: isActiveSection,
          parentSectionName: parentName,
          parentUrl: parentUrl,
          onClick: function onClick() {
            return onBackBtnClick(parentUrl, parentId, sectionId);
          }
        }, links && links.map(function (item) {
          var hasSubMenu = item.subLinks && item.subLinks.length > 0;
          var isActive = item.to === currentUrl;
          return jsx(VerticalNavItem, {
            key: item.id,
            id: item.id,
            text: item.name,
            to: item.to,
            onClick: function onClick() {
              onItemClick(item.to, hasSubMenu, item.id, sectionId);
            },
            isActive: isActive,
            hasSubMenu: hasSubMenu,
            notifications: item.notifications,
            tabIndex: hasFocus ? "0" : "-1"
          });
        }));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var currentLevel = this.props.currentLevel;
      var position = -currentLevel * 100;
      return jsx("div", {
        className: "vertical-nav"
      }, jsx("div", {
        className: "vertical-nav__inner",
        style: {
          transform: "translate(".concat(position, "%)")
        },
        role: "menu"
      }, this.renderTopLevelItems(), this.renderSubLevelItems()));
    }
  }]);

  return VerticalNav;
}(Component);

VerticalNav.propTypes = {
  previousMenu: PropTypes.string,
  currentUrl: PropTypes.string.isRequired,
  currentMenu: PropTypes.string.isRequired,
  currentLevel: PropTypes.number.isRequired,
  navigation: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    notifications: PropTypes.number,
    subLinks: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired
    }))
  })).isRequired,
  onItemClick: PropTypes.func.isRequired,
  onBackBtnClick: PropTypes.func.isRequired
};

export { Alert, Anchor, Autocomplete, Badge, BodyCopy, Button, ButtonGroup, ButtonGroupRow, Card, CardGroup, Checkbox, ContentList, DashboardCard, DatePicker, Doughnut, FileUploader, Footer, FooterLink, FooterSection, FormField, FormFieldValidation, FormGroup, Hamburger, Svg16Px as IconAdd16, Svg24Px as IconAdd24, Svg16Px$1 as IconArrowLeft16, Svg24Px$1 as IconArrowLeft24, Svg16Px$2 as IconArrowRight16, Svg24Px$2 as IconArrowRight24, IconButton, Svg16Px$3 as IconCalendar16, Svg64Px$1 as IconCelebration64, Svg32Px as IconCertificate32, Svg16Px$4 as IconChevronDown16, Svg16Px$5 as IconChevronLeft16, Svg16Px$6 as IconChevronRight16, Svg16Px$7 as IconChevronUp16, Svg16Px$p as IconCircle, Svg16Px$8 as IconClose16, Svg24Px$3 as IconClose24, Svg24Px$4 as IconContactChat24, Svg24Px$5 as IconContactMail24, Svg24Px$6 as IconContactPhone24, Svg16Px$i as IconCrossOutline16, Svg32Px$a as IconCrossOutline32, Svg16Px$j as IconCrossSolid16, Svg32Px$b as IconCrossSolid32, Svg16Px$q as IconDashboard16, Svg24Px$8 as IconDashboard24, Svg32Px$1 as IconDocument32, Svg16Px$r as IconDocuments16, Svg24Px$9 as IconDocuments24, Svg16Px$9 as IconDownload16, Svg16Px$c as IconEdit16, Svg32Px$e as IconEmail32, Svg32Px$f as IconEmployment32, Svg16Px$n as IconExamProgress16, Svg32Px$g as IconExchange32, Svg16Px$m as IconExclamationSolid16, Svg32Px$d as IconExclamationSolid32, Svg16Px$o as IconExemptions16, SvgFacebook as IconFacebook32, Svg16Px$a as IconFeedback16, Svg32Px$n as IconFirm24, Svg32Px$n as IconFirm32, Svg16Px$s as IconHamburger16, Svg24Px$a as IconHamburger24, Svg16Px$t as IconHelp16, Svg24Px$b as IconHelp24, SvgLinkedIn as IconLinkedIn32, Svg32Px$h as IconMailingAddress32, Svg32Px$i as IconMembership32, Svg16Px$y as IconMonitoring16, Svg16Px$u as IconNetwork16, Svg24Px$c as IconNetwork24, Svg16Px$b as IconOpenInANewWindow16, Svg24Px$7 as IconOpenInANewWindow24, Svg32Px$j as IconPassword32, Svg16Px$l as IconPauseSolid16, Svg16Px$v as IconPayment16, Svg24Px$d as IconPayment24, Svg32Px$2 as IconPdf32, SvgIconPlaceholder as IconPlaceholder, Svg16Px$w as IconProfessionalDevelopment16, Svg24Px$e as IconProfessionalDevelopment24, Svg16Px$x as IconProfile16, Svg24Px$f as IconProfile24, Svg32Px$k as IconQualification32, Svg16Px$k as IconQuestionSolid16, Svg32Px$c as IconQuestionSolid32, Svg16Px$d as IconReload16, Svg32Px$l as IconSecondaryAddress32, Svg32Px$m as IconTelephone32, Svg16Px$f as IconTick16, Svg16Px$g as IconTickOutline16, Svg32Px$8 as IconTickOutline32, Svg16Px$h as IconTickSolid16, Svg32Px$9 as IconTickSolid32, Svg32Px$3 as IconTimelineAlert32, Svg32Px$4 as IconTimelineCircles32, Svg32Px$7 as IconTimelineCross32, Svg32Px$5 as IconTimelineLock32, Svg32Px$6 as IconTimelineTick32, SvgTwitter as IconTwitter32, Svg16Px$e as IconUpload16, Svg64Px as IconVideoPlay64, SvgYoutube as IconYouTube32, LinkList, LinkListItem, LoadingDots, SvgStandard as Logo, Modal, NavBar, OverlineHeading, PageHeader, Panel, PopupManager, PreferenceCard, ProgressIndicator, RadioButton, SvgReversed as ReversedLogo, ScrollBox, Select, ShowHidePanel, Sidebar, SidebarContainer, SkipLink, StatusKey, Table, TableBody, TableCell, TableFoot, TableHeadCell, TableRow, Tabs, TelephoneField, Tile, TileGrid, Timeline, TimelineEvent, ToggleControlGroup, UserProfile, VerticalNav, VerticalNavItem, VerticalNavSubLevelContainer, VerticalNavTopLevelContainer, Video, VideoTile };
//# sourceMappingURL=lib.es.js.map
